function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $parcel$global = globalThis;
var $parcel$modules = {};
var $parcel$inits = {};
var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
    parcelRequire = function(id) {
        if (id in $parcel$modules) {
            return $parcel$modules[id].exports;
        }
        if (id in $parcel$inits) {
            var init = $parcel$inits[id];
            delete $parcel$inits[id];
            var module = {
                id: id,
                exports: {}
            };
            $parcel$modules[id] = module;
            init.call(module.exports, module, module.exports);
            return module.exports;
        }
        var err = new Error("Cannot find module '" + id + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
    };
    parcelRequire.register = function register(id, init) {
        $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire94c2"] = parcelRequire;
}
var parcelRegister = parcelRequire.register;
if (!$parcel$global.lb) {
    $parcel$global.lb = new Set();
    $parcel$global.bq = [];
    $parcel$global.rlb = (bundle)=>{
        $parcel$global.lb.add(bundle);
        $parcel$global.pq();
    };
    $parcel$global.rwr = (b, r, d)=>{
        $parcel$global.bq.push({
            b,
            r,
            d
        });
        $parcel$global.pq();
    };
    $parcel$global.pq = ()=>{
        var runnableEntry = $parcel$global.bq.find((i)=>{
            return i.d.every((dep)=>{
                return $parcel$global.lb.has(dep);
            });
        });
        if (runnableEntry) {
            $parcel$global.bq = $parcel$global.bq.filter((i)=>{
                return i.b !== runnableEntry.b;
            });
            runnableEntry.r();
            $parcel$global.pq();
        }
    };
}
parcelRegister("bCj2g", function(module, exports) {
    $parcel$export(module.exports, "getAssetUrlsFromId", ()=>$819fad39c2413e72$export$303f43e55cf1ef2f);
    const $819fad39c2413e72$export$303f43e55cf1ef2f = (manifest, id)=>{
        if (!manifest.assets || !manifest.assets[id]) return;
        return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
    };
});
parcelRegister("iDwTy", function(module, exports) {
    $parcel$export(module.exports, "setBooleanFeatureFlagResolver", ()=>$7d8e7a6d4ef6d824$export$ba05d765b8392e5e);
    $parcel$export(module.exports, "getBooleanFF", ()=>$7d8e7a6d4ef6d824$export$470e5c2be1411c89);
    $parcel$export(module.exports, "fg", ()=>$7d8e7a6d4ef6d824$export$b40ec24ac8275656);
    var $9Ypnh = parcelRequire("9Ypnh");
    function $7d8e7a6d4ef6d824$export$ba05d765b8392e5e(flagResolver) {
        (0, $9Ypnh.setBooleanResolver)(flagResolver);
    }
    function $7d8e7a6d4ef6d824$export$470e5c2be1411c89(name) {
        return (0, $9Ypnh.resolveBooleanFlag)(name);
    }
    function $7d8e7a6d4ef6d824$export$b40ec24ac8275656(name) {
        return (0, $9Ypnh.resolveBooleanFlag)(name);
    }
});
parcelRegister("9Ypnh", function(module, exports) {
    $parcel$export(module.exports, "setBooleanResolver", ()=>$33e3a006c075050d$export$f2b591175b3e424c);
    $parcel$export(module.exports, "resolveBooleanFlag", ()=>$33e3a006c075050d$export$6333b6aff9fc6275);
    var $8Z6hb = parcelRequire("8Z6hb");
    var $2fFJv = parcelRequire("2fFJv");
    const $33e3a006c075050d$var$pkgName = '@atlaskit/platform-feature-flags';
    const $33e3a006c075050d$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
    const $33e3a006c075050d$var$hasProcessEnv = typeof $2fFJv !== 'undefined' && typeof $2fFJv.env !== 'undefined';
    const $33e3a006c075050d$var$ENV_ENABLE_PLATFORM_FF = $33e3a006c075050d$var$hasProcessEnv ? false : false;
    const $33e3a006c075050d$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $33e3a006c075050d$var$hasProcessEnv ? false : false;
    const $33e3a006c075050d$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $33e3a006c075050d$var$ENV_ENABLE_PLATFORM_FF || $33e3a006c075050d$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
    const $33e3a006c075050d$var$DEFAULT_PFF_GLOBAL = {
        earlyResolvedFlags: new Map(),
        booleanResolver: function(flagKey) {
            return false;
        }
    };
    const $33e3a006c075050d$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
    $33e3a006c075050d$var$globalVar[$33e3a006c075050d$export$7e41b1b2bdee3f98] = $33e3a006c075050d$var$globalVar[$33e3a006c075050d$export$7e41b1b2bdee3f98] || $33e3a006c075050d$var$DEFAULT_PFF_GLOBAL;
    function $33e3a006c075050d$export$f2b591175b3e424c(resolver) {
        $33e3a006c075050d$var$globalVar[$33e3a006c075050d$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    }
    function $33e3a006c075050d$export$6333b6aff9fc6275(flagKey) {
        if ($33e3a006c075050d$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
            (0, $8Z6hb.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $33e3a006c075050d$var$pkgName, flagKey);
            return true;
        }
        try {
            const result = $33e3a006c075050d$var$globalVar[$33e3a006c075050d$export$7e41b1b2bdee3f98]?.booleanResolver(flagKey);
            if (typeof result !== 'boolean') {
                console.warn(`${flagKey} resolved to a non-boolean value, returning false for safety`);
                return false;
            }
            return result;
        } catch (e) {
            return false;
        }
    }
});
parcelRegister("8Z6hb", function(module, exports) {
    $parcel$export(module.exports, "debug", ()=>$8eeffedfb7b23ba2$export$1c9f709888824e05);
    const $8eeffedfb7b23ba2$var$TESTS_MODE = globalThis?.process?.env?.JEST_WORKER_ID !== undefined;
    const $8eeffedfb7b23ba2$var$DEBUG_MODE = !$8eeffedfb7b23ba2$var$TESTS_MODE && globalThis?.process?.env?.NODE_ENV !== 'production';
    const $8eeffedfb7b23ba2$export$1c9f709888824e05 = (...args)=>{
        if (!$8eeffedfb7b23ba2$var$DEBUG_MODE) return;
        console.debug(...args);
    };
});
parcelRegister("cOm24", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7fc7db5e76894e44$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $7fc7db5e76894e44$export$2e2bcd8739ae039 = (0, $eUqFw.createContext)(null);
});
parcelRegister("fPtA6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34aed4a1ebe00811$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "FeatureGateEnvironment", ()=>(parcelRequire("iPfIg")).FeatureGateEnvironment);
    var $avKkz = parcelRequire("avKkz");
    var $jg0YP = parcelRequire("jg0YP");
    var $kuwjR = parcelRequire("kuwjR");
    var $iPfIg = parcelRequire("iPfIg");
    var $jnl6I = parcelRequire("jnl6I");
    const $34aed4a1ebe00811$var$DEFAULT_CLIENT_KEY = 'client-default-key';
    const $34aed4a1ebe00811$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/';
    class $34aed4a1ebe00811$var$FeatureGates {
        static{
            this.initPromise = null;
        }
        static{
            this.initCompleted = false;
        }
        static{
            this.hasGetExperimentErrorOccurred = false;
        }
        static{
            this.hasGetExperimentValueErrorOccurred = false;
        }
        static{
            this.hasGetLayerErrorOccurred = false;
        }
        static{
            this.hasGetLayerValueErrorOccurred = false;
        }
        static{
            this.hasCheckGateErrorOccurred = false;
        }
        static{
            this.subscriptions = new (0, $jg0YP.default)();
        }
        static async initialize(clientOptions, identifiers, customAttributes) {
            if ($34aed4a1ebe00811$var$FeatureGates.initPromise) {
                if (!$34aed4a1ebe00811$var$FeatureGates.shallowEquals(clientOptions, $34aed4a1ebe00811$var$FeatureGates.initOptions)) console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                return $34aed4a1ebe00811$var$FeatureGates.initPromise;
            }
            const startTime = performance.now();
            $34aed4a1ebe00811$var$FeatureGates.initOptions = clientOptions;
            $34aed4a1ebe00811$var$FeatureGates.initPromise = $34aed4a1ebe00811$var$FeatureGates.init(clientOptions, identifiers, customAttributes).then(()=>{
                $34aed4a1ebe00811$var$FeatureGates.initCompleted = true;
            }).finally(()=>{
                const endTime = performance.now();
                const totalTime = endTime - startTime;
                $34aed4a1ebe00811$var$FeatureGates.fireClientEvent(startTime, totalTime, 'initialize', $34aed4a1ebe00811$var$FeatureGates.initCompleted, clientOptions.apiKey);
            });
            return $34aed4a1ebe00811$var$FeatureGates.initPromise;
        }
        static async initializeWithProvider(clientOptions, provider, identifiers, customAttributes) {
            if ($34aed4a1ebe00811$var$FeatureGates.initPromise) {
                if (!$34aed4a1ebe00811$var$FeatureGates.shallowEquals(clientOptions, $34aed4a1ebe00811$var$FeatureGates.initOptions)) console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                return $34aed4a1ebe00811$var$FeatureGates.initPromise;
            }
            const startTime = performance.now();
            $34aed4a1ebe00811$var$FeatureGates.initOptions = clientOptions;
            $34aed4a1ebe00811$var$FeatureGates.subscriptions = new (0, $jg0YP.default)();
            $34aed4a1ebe00811$var$FeatureGates.provider = provider;
            $34aed4a1ebe00811$var$FeatureGates.provider.setClientVersion((0, $jnl6I.CLIENT_VERSION));
            if ($34aed4a1ebe00811$var$FeatureGates.provider.setApplyUpdateCallback) $34aed4a1ebe00811$var$FeatureGates.provider.setApplyUpdateCallback((experimentsResult)=>{
                (0, ($parcel$interopDefault($avKkz))).setInitializeValues(experimentsResult.experimentValues);
                $34aed4a1ebe00811$var$FeatureGates.subscriptions.anyUpdated();
            });
            $34aed4a1ebe00811$var$FeatureGates.initPromise = $34aed4a1ebe00811$var$FeatureGates.initWithProvider(clientOptions, identifiers, customAttributes).then(()=>{
                $34aed4a1ebe00811$var$FeatureGates.initCompleted = true;
            }).finally(()=>{
                const endTime = performance.now();
                const totalTime = endTime - startTime;
                $34aed4a1ebe00811$var$FeatureGates.fireClientEvent(startTime, totalTime, 'initialize', $34aed4a1ebe00811$var$FeatureGates.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
            });
            return $34aed4a1ebe00811$var$FeatureGates.initPromise;
        }
        static fireClientEvent(startTime, totalTime, action, success, apiKey) {
            $34aed4a1ebe00811$var$FeatureGates.initOptions.analyticsWebClient?.then((analyticsWebClient)=>{
                const attributes = {
                    targetApp: $34aed4a1ebe00811$var$FeatureGates.initOptions.targetApp,
                    clientVersion: (0, $jnl6I.CLIENT_VERSION),
                    success: success,
                    startTime: startTime,
                    totalTime: totalTime,
                    ...apiKey && {
                        apiKey: apiKey
                    }
                };
                analyticsWebClient.sendOperationalEvent({
                    action: action,
                    actionSubject: 'featureGatesClient',
                    attributes: attributes,
                    tags: [
                        'measurement'
                    ],
                    source: '@atlaskit/feature-gate-js-client'
                });
            }).catch((err)=>{
                if ($34aed4a1ebe00811$var$FeatureGates.initOptions.environment !== (0, $iPfIg.FeatureGateEnvironment).Production) console.error('Analytics web client promise did not resolve', err);
            });
        }
        static async initializeFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
            if ($34aed4a1ebe00811$var$FeatureGates.initPromise) {
                if (!$34aed4a1ebe00811$var$FeatureGates.shallowEquals(clientOptions, $34aed4a1ebe00811$var$FeatureGates.initOptions)) console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                return $34aed4a1ebe00811$var$FeatureGates.initPromise;
            }
            const startTime = performance.now();
            $34aed4a1ebe00811$var$FeatureGates.initOptions = clientOptions;
            $34aed4a1ebe00811$var$FeatureGates.initPromise = $34aed4a1ebe00811$var$FeatureGates.initFromValues(clientOptions, identifiers, customAttributes, initializeValues).then(()=>{
                $34aed4a1ebe00811$var$FeatureGates.initCompleted = true;
            }).finally(()=>{
                const endTime = performance.now();
                const totalTime = endTime - startTime;
                $34aed4a1ebe00811$var$FeatureGates.fireClientEvent(startTime, totalTime, 'initializeFromValues', $34aed4a1ebe00811$var$FeatureGates.initCompleted);
            });
            return $34aed4a1ebe00811$var$FeatureGates.initPromise;
        }
        static async updateUser(fetchOptions, identifiers, customAttributes) {
            const initializeValuesProducer = ()=>(0, $kuwjR.default).fetchExperimentValues(fetchOptions, identifiers, customAttributes).then(({ experimentValues: experimentValues, customAttributes: customAttributes })=>({
                        experimentValues: experimentValues,
                        customAttributesFromFetch: customAttributes
                    }));
            await $34aed4a1ebe00811$var$FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
        }
        static async updateUserWithProvider(identifiers, customAttributes) {
            if (!$34aed4a1ebe00811$var$FeatureGates.provider) throw new Error('Cannot update user using provider as the client was not initialised with a provider');
            await $34aed4a1ebe00811$var$FeatureGates.updateUserUsingInitializeValuesProducer(()=>$34aed4a1ebe00811$var$FeatureGates.provider.getExperimentValues($34aed4a1ebe00811$var$FeatureGates.initOptions, identifiers, customAttributes), identifiers, customAttributes);
        }
        static async updateUserWithValues(identifiers, customAttributes, initializeValues = {}) {
            const initializeValuesProducer = ()=>Promise.resolve({
                    experimentValues: initializeValues,
                    customAttributesFromFetch: customAttributes
                });
            await $34aed4a1ebe00811$var$FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
        }
        static initializeCalled() {
            return $34aed4a1ebe00811$var$FeatureGates.initPromise != null;
        }
        static initializeCompleted() {
            return $34aed4a1ebe00811$var$FeatureGates.initCompleted;
        }
        static checkGate(gateName, options = {}) {
            try {
                const { fireGateExposure: fireGateExposure = true } = options;
                const evalMethod = fireGateExposure ? (0, ($parcel$interopDefault($avKkz))).checkGate.bind((0, ($parcel$interopDefault($avKkz)))) : (0, ($parcel$interopDefault($avKkz))).checkGateWithExposureLoggingDisabled.bind((0, ($parcel$interopDefault($avKkz))));
                return evalMethod(gateName);
            } catch (error) {
                if (!$34aed4a1ebe00811$var$FeatureGates.hasCheckGateErrorOccurred) {
                    console.warn({
                        msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                        gateName: gateName,
                        error: error
                    });
                    $34aed4a1ebe00811$var$FeatureGates.hasCheckGateErrorOccurred = true;
                }
                return false;
            }
        }
        static manuallyLogGateExposure(gateName) {
            (0, ($parcel$interopDefault($avKkz))).manuallyLogGateExposure(gateName);
        }
        static getExperiment(experimentName, options = {}) {
            try {
                const { fireExperimentExposure: fireExperimentExposure = true } = options;
                const evalMethod = fireExperimentExposure ? (0, ($parcel$interopDefault($avKkz))).getExperiment.bind((0, ($parcel$interopDefault($avKkz)))) : (0, ($parcel$interopDefault($avKkz))).getExperimentWithExposureLoggingDisabled.bind((0, ($parcel$interopDefault($avKkz))));
                return evalMethod(experimentName);
            } catch (error) {
                if (!$34aed4a1ebe00811$var$FeatureGates.hasGetExperimentErrorOccurred) {
                    console.warn({
                        msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                        experimentName: experimentName,
                        error: error
                    });
                    $34aed4a1ebe00811$var$FeatureGates.hasGetExperimentErrorOccurred = true;
                }
                return new (0, $avKkz.DynamicConfig)(experimentName, {}, '', {
                    time: Date.now(),
                    reason: (0, $avKkz.EvaluationReason).Error
                });
            }
        }
        static getExperimentValue(experimentName, parameterName, defaultValue, options = {}) {
            const experiment = $34aed4a1ebe00811$var$FeatureGates.getExperiment(experimentName, options);
            try {
                const { typeGuard: typeGuard } = options;
                return experiment.get(parameterName, defaultValue, typeGuard);
            } catch (error) {
                if (!$34aed4a1ebe00811$var$FeatureGates.hasGetExperimentValueErrorOccurred) {
                    console.warn({
                        msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                        experimentName: experimentName,
                        defaultValue: defaultValue,
                        options: options,
                        error: error
                    });
                    $34aed4a1ebe00811$var$FeatureGates.hasGetExperimentValueErrorOccurred = true;
                }
                return defaultValue;
            }
        }
        static manuallyLogExperimentExposure(experimentName) {
            (0, ($parcel$interopDefault($avKkz))).manuallyLogExperimentExposure(experimentName);
        }
        static manuallyLogLayerExposure(layerName, parameterName) {
            (0, ($parcel$interopDefault($avKkz))).manuallyLogLayerParameterExposure(layerName, parameterName);
        }
        static shutdownStatsig() {
            (0, ($parcel$interopDefault($avKkz))).shutdown();
        }
        static overrideGate(gateName, value) {
            (0, ($parcel$interopDefault($avKkz))).overrideGate(gateName, value);
        }
        static clearGateOverride(gateName) {
            (0, ($parcel$interopDefault($avKkz))).overrideGate(gateName, null);
        }
        static overrideConfig(experimentName, values) {
            (0, ($parcel$interopDefault($avKkz))).overrideConfig(experimentName, values);
        }
        static clearConfigOverride(experimentName) {
            (0, ($parcel$interopDefault($avKkz))).overrideConfig(experimentName, null);
        }
        static setOverrides(overrides) {
            (0, ($parcel$interopDefault($avKkz))).setOverrides({
                gates: {},
                configs: {},
                layers: {},
                ...overrides
            });
        }
        static getOverrides() {
            return (0, ($parcel$interopDefault($avKkz))).getOverrides();
        }
        static clearAllOverrides() {
            (0, ($parcel$interopDefault($avKkz))).setOverrides(null);
        }
        static isCurrentUser(identifiers, customAttributes) {
            return $34aed4a1ebe00811$var$FeatureGates.shallowEquals($34aed4a1ebe00811$var$FeatureGates.currentIdentifiers, identifiers) && $34aed4a1ebe00811$var$FeatureGates.shallowEquals($34aed4a1ebe00811$var$FeatureGates.currentAttributes, customAttributes);
        }
        static onGateUpdated(gateName, callback, options = {}) {
            const wrapCallback = (value)=>{
                const { fireGateExposure: fireGateExposure = true } = options;
                if (fireGateExposure) $34aed4a1ebe00811$var$FeatureGates.manuallyLogGateExposure(gateName);
                try {
                    callback(value);
                } catch (error) {
                    console.warn(`Error calling callback for gate ${gateName} with value ${value}`, error);
                }
            };
            return $34aed4a1ebe00811$var$FeatureGates.subscriptions.onGateUpdated(gateName, wrapCallback, $34aed4a1ebe00811$var$FeatureGates.checkGate, options);
        }
        static onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, options = {}) {
            const wrapCallback = (value)=>{
                const { fireExperimentExposure: fireExperimentExposure = true } = options;
                if (fireExperimentExposure) $34aed4a1ebe00811$var$FeatureGates.manuallyLogExperimentExposure(experimentName);
                try {
                    callback(value);
                } catch (error) {
                    console.warn(`Error calling callback for experiment ${experimentName} with value ${value}`, error);
                }
            };
            return $34aed4a1ebe00811$var$FeatureGates.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, $34aed4a1ebe00811$var$FeatureGates.getExperimentValue, options);
        }
        static onAnyUpdated(callback) {
            return $34aed4a1ebe00811$var$FeatureGates.subscriptions?.onAnyUpdated(callback);
        }
        static async init(clientOptions, identifiers, customAttributes) {
            const fromValuesClientOptions = {
                ...clientOptions,
                disableCurrentPageLogging: true
            };
            let experimentValues;
            let customAttributesFromResult;
            try {
                const clientSdkKeyPromise = (0, $kuwjR.default).fetchClientSdk(clientOptions).then((value)=>fromValuesClientOptions.sdkKey = value.clientSdkKey);
                const experimentValuesPromise = (0, $kuwjR.default).fetchExperimentValues(clientOptions, identifiers, customAttributes);
                const [, experimentValuesResult] = await Promise.all([
                    clientSdkKeyPromise,
                    experimentValuesPromise
                ]);
                experimentValues = experimentValuesResult.experimentValues;
                customAttributesFromResult = experimentValuesResult.customAttributes;
            } catch (error) {
                if (error instanceof Error) console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
                console.warn(`Initialising Statsig client without values`);
                await $34aed4a1ebe00811$var$FeatureGates.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                throw error;
            }
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
        }
        static async initWithProvider(baseClientOptions, identifiers, customAttributes) {
            const fromValuesClientOptions = {
                ...baseClientOptions,
                disableCurrentPageLogging: true
            };
            let experimentValues;
            let customAttributesFromResult;
            try {
                const clientSdkKeyPromise = $34aed4a1ebe00811$var$FeatureGates.provider.getClientSdkKey(baseClientOptions).then((value)=>fromValuesClientOptions.sdkKey = value);
                const experimentValuesPromise = $34aed4a1ebe00811$var$FeatureGates.provider.getExperimentValues(baseClientOptions, identifiers, customAttributes);
                const [, experimentValuesResult] = await Promise.all([
                    clientSdkKeyPromise,
                    experimentValuesPromise
                ]);
                experimentValues = experimentValuesResult.experimentValues;
                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
            } catch (error) {
                if (error instanceof Error) console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
                console.warn(`Initialising Statsig client without values`);
                await $34aed4a1ebe00811$var$FeatureGates.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                throw error;
            }
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
        }
        static async initFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
            const user = this.toStatsigUser(identifiers, customAttributes);
            $34aed4a1ebe00811$var$FeatureGates.currentIdentifiers = identifiers;
            $34aed4a1ebe00811$var$FeatureGates.currentAttributes = customAttributes;
            if (!clientOptions.sdkKey) clientOptions.sdkKey = $34aed4a1ebe00811$var$DEFAULT_CLIENT_KEY;
            if (!clientOptions.eventLoggingApi) clientOptions.eventLoggingApi = $34aed4a1ebe00811$var$DEFAULT_EVENT_LOGGING_API;
            if (clientOptions.perimeter === (0, $iPfIg.PerimeterType).FEDRAMP_MODERATE) clientOptions.disableAllLogging = true;
            const { sdkKey: sdkKey } = clientOptions;
            const statsigOptions = this.toStatsigOptions(clientOptions, initializeValues);
            try {
                await (0, ($parcel$interopDefault($avKkz))).initialize(sdkKey, user, statsigOptions);
            } catch (error) {
                if (error instanceof Error) console.error(`Error occurred when trying to initialise the Statsig client, error: ${error?.message}`);
                console.warn(`Initialising Statsig client with default sdk key and without values`);
                await (0, ($parcel$interopDefault($avKkz))).initialize($34aed4a1ebe00811$var$DEFAULT_CLIENT_KEY, user, {
                    ...statsigOptions,
                    initializeValues: {}
                });
                throw error;
            }
        }
        static toStatsigUser(identifiers, customAttributes) {
            const user = {
                customIDs: identifiers,
                custom: customAttributes
            };
            if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
            return user;
        }
        static async updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
            if (!$34aed4a1ebe00811$var$FeatureGates.initPromise) throw new Error('The FeatureGates client must be initialized before you can update the user.');
            if ($34aed4a1ebe00811$var$FeatureGates.isCurrentUser(identifiers, customAttributes)) return $34aed4a1ebe00811$var$FeatureGates.initPromise;
            const originalInitPromise = $34aed4a1ebe00811$var$FeatureGates.initPromise;
            try {
                await $34aed4a1ebe00811$var$FeatureGates.initPromise;
            } catch (err) {}
            const initializeValuesPromise = getInitializeValues();
            const updateUserPromise = $34aed4a1ebe00811$var$FeatureGates.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes);
            $34aed4a1ebe00811$var$FeatureGates.initPromise = updateUserPromise.catch(()=>{
                $34aed4a1ebe00811$var$FeatureGates.initPromise = originalInitPromise;
            });
            return updateUserPromise;
        }
        static async updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes) {
            let initializeValues, user;
            try {
                initializeValues = await initializeValuesPromise;
                user = $34aed4a1ebe00811$var$FeatureGates.toStatsigUser(identifiers, initializeValues.customAttributesFromFetch);
            } catch (err) {
                const errMsg = err instanceof Error ? err.message : JSON.stringify(err);
                $34aed4a1ebe00811$var$FeatureGates.initOptions.updateUserCompletionCallback?.(false, errMsg);
                throw err;
            }
            const success = (0, ($parcel$interopDefault($avKkz))).updateUserWithValues(user, initializeValues.experimentValues);
            if (success) {
                $34aed4a1ebe00811$var$FeatureGates.currentIdentifiers = identifiers;
                $34aed4a1ebe00811$var$FeatureGates.currentAttributes = customAttributes;
            } else throw new Error('Failed to update user. An unexpected error occured.');
        }
        static toStatsigOptions(options, initializeValues) {
            const { sdkKey: sdkKey, updateUserCompletionCallback: updateUserCompletionCallback, perimeter: perimeter, ...restClientOptions } = options;
            return {
                ...restClientOptions,
                initializeValues: initializeValues,
                environment: {
                    tier: options.environment
                },
                disableCurrentPageLogging: true,
                ...options.updateUserCompletionCallback && {
                    updateUserCompletionCallback: $34aed4a1ebe00811$var$FeatureGates.toStatsigUpdateUserCompletionCallback(options.updateUserCompletionCallback)
                }
            };
        }
        static toStatsigUpdateUserCompletionCallback(callback) {
            return (_duration, success, message)=>{
                callback(success, message);
            };
        }
        static shallowEquals(objectA, objectB) {
            if (!objectA && !objectB) return true;
            if (!objectA || !objectB) return false;
            const aEntries = Object.entries(objectA);
            const bEntries = Object.entries(objectB);
            if (aEntries.length !== bEntries.length) return false;
            const ascendingKeyOrder = ([key1], [key2])=>key1.localeCompare(key2);
            aEntries.sort(ascendingKeyOrder);
            bEntries.sort(ascendingKeyOrder);
            for(let i = 0; i < aEntries.length; i++){
                const [, aValue] = aEntries[i];
                const [, bValue] = bEntries[i];
                if (aValue !== bValue) return false;
            }
            return true;
        }
        static getPackageVersion() {
            return 0, $jnl6I.CLIENT_VERSION;
        }
        static getLayer(layerName, options = {}) {
            try {
                const { fireLayerExposure: fireLayerExposure = true } = options;
                const evalMethod = fireLayerExposure ? (0, ($parcel$interopDefault($avKkz))).getLayer.bind((0, ($parcel$interopDefault($avKkz)))) : (0, ($parcel$interopDefault($avKkz))).getLayerWithExposureLoggingDisabled.bind((0, ($parcel$interopDefault($avKkz))));
                return evalMethod(layerName);
            } catch (error) {
                if (!$34aed4a1ebe00811$var$FeatureGates.hasGetLayerErrorOccurred) {
                    console.warn({
                        msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                        layerName: layerName,
                        error: error
                    });
                    $34aed4a1ebe00811$var$FeatureGates.hasGetLayerErrorOccurred = true;
                }
                return (0, $avKkz.Layer)._create(layerName, {}, '', {
                    time: Date.now(),
                    reason: (0, $avKkz.EvaluationReason).Error
                });
            }
        }
        static getLayerValue(layerName, parameterName, defaultValue, options = {}) {
            const layer = $34aed4a1ebe00811$var$FeatureGates.getLayer(layerName, options);
            try {
                const { typeGuard: typeGuard } = options;
                return layer.get(parameterName, defaultValue, typeGuard);
            } catch (error) {
                if (!$34aed4a1ebe00811$var$FeatureGates.hasGetLayerValueErrorOccurred) {
                    console.warn({
                        msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                        layerName: layerName,
                        defaultValue: defaultValue,
                        options: options,
                        error: error
                    });
                    $34aed4a1ebe00811$var$FeatureGates.hasGetLayerValueErrorOccurred = true;
                }
                return defaultValue;
            }
        }
    }
    let $34aed4a1ebe00811$var$boundFGJS = $34aed4a1ebe00811$var$FeatureGates;
    if (typeof window !== 'undefined') {
        if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $34aed4a1ebe00811$var$FeatureGates;
        else {
            $34aed4a1ebe00811$var$boundFGJS = window.__FEATUREGATES_JS__;
            const boundVersion = $34aed4a1ebe00811$var$boundFGJS?.getPackageVersion?.() || '4.10.0 or earlier';
            if (boundVersion !== (0, $jnl6I.CLIENT_VERSION)) {
                const message = `Multiple versions of FeatureGateClients found on the current page.
      The currently bound version is ${boundVersion} when module version ${(0, $jnl6I.CLIENT_VERSION)} was loading.`;
                console.warn(message);
            }
        }
    }
    var $34aed4a1ebe00811$export$2e2bcd8739ae039 = $34aed4a1ebe00811$var$boundFGJS;
});
parcelRegister("jg0YP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ae584c4cb648a9e$export$2e2bcd8739ae039);
    var $4FH8r = parcelRequire("4FH8r");
    const $2ae584c4cb648a9e$export$a66cbd9b2289cd78 = '@all-features';
    class $2ae584c4cb648a9e$export$2e2bcd8739ae039 {
        constructor(){
            this.eventToValue = new Map();
            this.emitter = new (0, $4FH8r.EventEmitter2)();
        }
        onGateUpdated(gateName, callback, checkGate, options) {
            const value = checkGate(gateName, {
                ...options,
                fireGateExposure: false
            });
            if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
            const wrapCallback = ()=>{
                const value = checkGate(gateName, {
                    ...options,
                    fireGateExposure: false
                });
                const existingValue = this.eventToValue.get(callback);
                if (existingValue !== value) {
                    this.eventToValue.set(callback, value);
                    callback(value);
                }
            };
            this.emitter.on(gateName, wrapCallback);
            return ()=>{
                this.emitter.off(gateName, wrapCallback);
            };
        }
        onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
            const experimentEventName = `${experimentName}.${parameterName}`;
            const value = getExperimentValue(experimentName, parameterName, defaultValue, {
                ...options,
                fireExperimentExposure: false
            });
            if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
            const wrapCallback = ()=>{
                const value = getExperimentValue(experimentName, parameterName, defaultValue, {
                    ...options,
                    fireExperimentExposure: false
                });
                const existingValue = this.eventToValue.get(callback);
                if (existingValue !== value) {
                    this.eventToValue.set(callback, value);
                    callback(value);
                }
            };
            this.emitter.on(experimentEventName, wrapCallback);
            return ()=>{
                this.emitter.off(experimentEventName, wrapCallback);
            };
        }
        onAnyUpdated(callback) {
            this.emitter.on($2ae584c4cb648a9e$export$a66cbd9b2289cd78, callback);
            return ()=>{
                this.emitter.off($2ae584c4cb648a9e$export$a66cbd9b2289cd78, callback);
            };
        }
        anyUpdated() {
            this.emitter.emit($2ae584c4cb648a9e$export$a66cbd9b2289cd78);
            this.emitter.eventNames().filter((name)=>name !== $2ae584c4cb648a9e$export$a66cbd9b2289cd78).forEach((event)=>{
                this.emitter.emit(event);
            });
        }
    }
});
parcelRegister("kuwjR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$30e2913f9dd5f256$export$2e2bcd8739ae039);
    var $iPfIg = parcelRequire("iPfIg");
    var $jnl6I = parcelRequire("jnl6I");
    var $8mxXJ = parcelRequire("8mxXJ");
    const $30e2913f9dd5f256$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
    const $30e2913f9dd5f256$var$PROD_BASE_URL = 'https://api.atlassian.com/flags';
    const $30e2913f9dd5f256$var$STAGING_BASE_URL = 'https://api.stg.atlassian.com/flags';
    const $30e2913f9dd5f256$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
    const $30e2913f9dd5f256$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
    const $30e2913f9dd5f256$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
    const $30e2913f9dd5f256$export$450bd8fb2a6d7ace = '/gateway/api/flags';
    class $30e2913f9dd5f256$export$2e2bcd8739ae039 {
        static async fetchClientSdk(fetcherOptions) {
            const { targetApp: targetApp } = fetcherOptions;
            const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
            try {
                return await this.fetchRequest(url, 'GET', fetcherOptions);
            } catch (error) {
                if (error instanceof Error) throw error;
                throw Error('Failed to retrieve client sdk key');
            }
        }
        static async fetchExperimentValues(fetcherOptions, identifiers, customAttributes) {
            const requestBody = {
                identifiers: identifiers,
                customAttributes: customAttributes,
                targetApp: fetcherOptions.targetApp
            };
            try {
                return await this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
            } catch (error) {
                if (error instanceof Error) throw error;
                throw Error('Failed to retrieve experiment values');
            }
        }
        static async handleResponseError(response) {
            if (!response.ok) {
                const body = await response.text();
                throw new (0, $8mxXJ.ResponseError)(`Non 2xx response status received, status: ${response.status}, body: ${JSON.stringify(body)}`);
            }
            if (response.status === 204) throw new (0, $8mxXJ.ResponseError)('Unexpected 204 response');
        }
        static async extractResponseBody(response) {
            const value = await response.text();
            return JSON.parse(value);
        }
        static getBaseUrl(serviceEnv, useGatewayUrl = false, perimeter = (0, $iPfIg.PerimeterType).COMMERCIAL) {
            if (useGatewayUrl) return $30e2913f9dd5f256$export$450bd8fb2a6d7ace;
            if (perimeter === (0, $iPfIg.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                case (0, $iPfIg.FeatureGateEnvironment).Production:
                    return $30e2913f9dd5f256$export$18c93900db9358a4;
                case (0, $iPfIg.FeatureGateEnvironment).Staging:
                    return $30e2913f9dd5f256$export$1a401a0da8da3565;
                default:
                    throw new Error(`Invalid environment "${serviceEnv}" for "${perimeter}" perimeter`);
            }
            else if (perimeter === (0, $iPfIg.PerimeterType).COMMERCIAL) switch(serviceEnv){
                case (0, $iPfIg.FeatureGateEnvironment).Development:
                    return $30e2913f9dd5f256$export$f058dbf75c3bc647;
                case (0, $iPfIg.FeatureGateEnvironment).Staging:
                    return $30e2913f9dd5f256$var$STAGING_BASE_URL;
                default:
                    return $30e2913f9dd5f256$var$PROD_BASE_URL;
            }
            else throw new Error(`Invalid perimeter "${perimeter}"`);
        }
        static async fetchRequest(path, method, fetcherOptions, body) {
            const baseUrl = $30e2913f9dd5f256$export$2e2bcd8739ae039.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
            const fetchTimeout = fetcherOptions.fetchTimeoutMs || $30e2913f9dd5f256$var$DEFAULT_REQUEST_TIMEOUT_MS;
            let abortSignal;
            if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
            else if (AbortController) {
                const abortController = new AbortController();
                abortSignal = abortController.signal;
                setTimeout(()=>abortController.abort(), fetchTimeout);
            }
            const response = await fetch(`${baseUrl}${path}`, {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                    'X-Client-Name': 'feature-gate-js-client',
                    'X-Client-Version': (0, $jnl6I.CLIENT_VERSION),
                    'X-API-KEY': fetcherOptions.apiKey
                },
                signal: abortSignal,
                ...body && {
                    body: JSON.stringify(body)
                }
            });
            await this.handleResponseError(response);
            return await this.extractResponseBody(response);
        }
    }
});
parcelRegister("iPfIg", function(module, exports) {
    $parcel$export(module.exports, "FeatureGateEnvironment", ()=>$5a018857d7d246f5$export$479e7351a733299);
    $parcel$export(module.exports, "PerimeterType", ()=>$5a018857d7d246f5$export$c42b7bbc5e7ba555);
    var $5a018857d7d246f5$export$479e7351a733299;
    (function(FeatureGateEnvironment) {
        FeatureGateEnvironment["Development"] = "development";
        FeatureGateEnvironment["Staging"] = "staging";
        FeatureGateEnvironment["Production"] = "production";
    })($5a018857d7d246f5$export$479e7351a733299 || ($5a018857d7d246f5$export$479e7351a733299 = {}));
    var $5a018857d7d246f5$export$c42b7bbc5e7ba555;
    (function(PerimeterType) {
        PerimeterType["COMMERCIAL"] = "commercial";
        PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    })($5a018857d7d246f5$export$c42b7bbc5e7ba555 || ($5a018857d7d246f5$export$c42b7bbc5e7ba555 = {}));
});
parcelRegister("jnl6I", function(module, exports) {
    $parcel$export(module.exports, "CLIENT_VERSION", ()=>$a74d0f780284aad7$export$a59f8d67326bd1cb);
    const $a74d0f780284aad7$export$a59f8d67326bd1cb = "0.0.0-use.local";
});
parcelRegister("8mxXJ", function(module, exports) {
    $parcel$export(module.exports, "ResponseError", ()=>$1c2d71a7a00c314d$export$286baf652d0b1206);
    class $1c2d71a7a00c314d$export$286baf652d0b1206 extends Error {
        constructor(message){
            super(message);
        }
    }
});
parcelRegister("apAS2", function(module, exports) {
    $parcel$export(module.exports, "allFeatureFlagsAccessed", ()=>$95cfc3969909f809$export$5b78c989c8db2561);
    $parcel$export(module.exports, "currentFeatureFlagsAccessed", ()=>$95cfc3969909f809$export$2a5c8df26bb89760);
    $parcel$export(module.exports, "addFeatureFlagAccessed", ()=>$95cfc3969909f809$export$47fade9662f71000);
    var $cISEu = parcelRequire("cISEu");
    const $95cfc3969909f809$export$5b78c989c8db2561 = new Map();
    const $95cfc3969909f809$export$2a5c8df26bb89760 = new Map();
    const $95cfc3969909f809$export$47fade9662f71000 = (featureFlagName, featureFlagValue)=>{
        try {
            if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
        } catch (_e) {}
        const value = (0, $cISEu.redactValue)(featureFlagValue);
        $95cfc3969909f809$export$5b78c989c8db2561.set(featureFlagName, value);
        $95cfc3969909f809$export$2a5c8df26bb89760.set(featureFlagName, value);
    };
});
parcelRegister("cISEu", function(module, exports) {
    $parcel$export(module.exports, "redactValue", ()=>$c43836aa02e7a7b0$export$fcc03ee4c944962f);
    const $c43836aa02e7a7b0$var$startsAsObject = (value)=>{
        try {
            if (value.charAt(0) === '{') return true;
        } catch (e) {
            return false;
        }
        return false;
    };
    const $c43836aa02e7a7b0$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
    const $c43836aa02e7a7b0$var$isString = (input)=>{
        let result;
        try {
            result = typeof input === 'string' || input instanceof String;
        } catch (err) {
            result = false;
        }
        return result;
    };
    const $c43836aa02e7a7b0$export$7b4abba432e57989 = (value)=>$c43836aa02e7a7b0$var$isString(value) && $c43836aa02e7a7b0$var$startsAsObject(value) || $c43836aa02e7a7b0$var$isObject(value);
    const $c43836aa02e7a7b0$export$fcc03ee4c944962f = (featureFlagValue)=>$c43836aa02e7a7b0$export$7b4abba432e57989(featureFlagValue) ? (0, $f942f47f86835a92$export$42f4885608027d0c) : featureFlagValue;
});
const $f942f47f86835a92$export$42f4885608027d0c = 'non_boolean';
parcelRegister("atsKT", function(module, exports) {
    $parcel$export(module.exports, "isFedRamp", ()=>$c74a2e3c8b259eb9$export$64d6499adf9b2e51);
    function $c74a2e3c8b259eb9$export$64d6499adf9b2e51() {
        const global = globalThis;
        const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
        if (env) return env === (0, $787fd3b165b120a2$export$ce553301d55c2fd8);
        const matches = global.location?.hostname?.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
        return matches ? matches.length > 0 : false;
    }
});
const $787fd3b165b120a2$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $787fd3b165b120a2$export$f005e2e9f707cb5f = 'commercial';
const $787fd3b165b120a2$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $787fd3b165b120a2$export$a739cd5aac835909 = 'stg';
const $787fd3b165b120a2$export$42dd0cdd351a4a9 = 'prod';
const $787fd3b165b120a2$export$404582bc18fe4d9e = 'dev';
parcelRegister("3M6sI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>(parcelRequire("4do3D")).default);
    var $4do3D = parcelRequire("4do3D");
    var $1gSD1 = parcelRequire("1gSD1");
});
parcelRegister("4do3D", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2f188f67f3cfa7c9$export$2e2bcd8739ae039);
    var $1gSD1 = parcelRequire("1gSD1");
    var $fXqwP = parcelRequire("fXqwP");
    var $5hDSz = parcelRequire("5hDSz");
    var $e7l5w = parcelRequire("e7l5w");
    class $2f188f67f3cfa7c9$export$2e2bcd8739ae039 {
        constructor(options){
            (0, $fXqwP.enforceAttributes)(options, [
                'analyticsHandler'
            ], 'Feature Flag Client');
            const { flags: flags, analyticsHandler: analyticsHandler, isAutomaticExposuresEnabled: isAutomaticExposuresEnabled, ignoreTypes: ignoreTypes } = options;
            this.flags = new Map();
            this.flagWrapperCache = new Map();
            this.customAttributesExposuresCache = new Set();
            this.trackedFlags = new Set();
            this.isAutomaticExposuresEnabled = isAutomaticExposuresEnabled || false;
            this.ignoreTypes = ignoreTypes || false;
            this.setFlags(flags || {});
            this.setAnalyticsHandler(analyticsHandler);
        }
        setFlags(flags) {
            if (!(0, $fXqwP.isObject)(flags)) return;
            Object.entries(flags).forEach(([flagKey, flag])=>{
                this.flags.set(flagKey, flag);
            });
            for (const flagKey of this.flagWrapperCache.keys())if (flags.hasOwnProperty(flagKey)) this.flagWrapperCache.delete(flagKey);
        }
        setAnalyticsHandler(analyticsHandler) {
            this.analyticsHandler = analyticsHandler;
        }
        setIsAutomaticExposuresEnabled(isEnabled) {
            this.isAutomaticExposuresEnabled = isEnabled;
        }
        getFlagWrapper(flagKey) {
            let wrapper = this.flagWrapperCache.get(flagKey);
            if (wrapper !== undefined) return wrapper;
            const flag = this.flags.get(flagKey);
            if (flag) wrapper = new (0, $e7l5w.default)(flagKey, flag, this._trackExposure.bind(this), this.sendAutomaticExposure.bind(this), this.ignoreTypes);
            else wrapper = new (0, $5hDSz.default)();
            this.flagWrapperCache.set(flagKey, wrapper);
            return wrapper;
        }
        clear() {
            this.flags.clear();
            this.flagWrapperCache.clear();
            this.trackedFlags.clear();
        }
        getBooleanValue(flagKey, options) {
            (0, $fXqwP.enforceAttributes)(options, [
                'default'
            ], 'getBooleanValue');
            const wrapper = this.getFlagWrapper(flagKey);
            return wrapper.getBooleanValue(options);
        }
        getVariantValue(flagKey, options) {
            (0, $fXqwP.enforceAttributes)(options, [
                'default',
                'oneOf'
            ], 'getVariantValue');
            const wrapper = this.getFlagWrapper(flagKey);
            return wrapper.getVariantValue(options);
        }
        getJSONValue(flagKey) {
            const wrapper = this.getFlagWrapper(flagKey);
            return wrapper.getJSONValue();
        }
        getRawValue(flagKey, options) {
            (0, $fXqwP.enforceAttributes)(options, [
                'default'
            ], 'getRawValue');
            const wrapper = this.getFlagWrapper(flagKey);
            return wrapper.getRawValue(options);
        }
        getFlagEvaluation(flagKey, options) {
            (0, $fXqwP.enforceAttributes)(options, [
                'default'
            ], 'getRawValue');
            const wrapper = this.getFlagWrapper(flagKey);
            return wrapper.getFlagEvaluation(options);
        }
        trackFeatureFlag(flagKey, options = {}) {
            const triggerReason = options?.triggerReason ? options.triggerReason : (0, $1gSD1.ExposureTriggerReason).Manual;
            const isValueSet = this.flags.has(flagKey) || 'value' in options;
            if (!isValueSet) {
                console.warn(`No value associated with the flagKey: ${flagKey} with an exposure trigger reason of: ${triggerReason}`);
                return;
            }
            const flagValue = 'value' in options ? options.value : this.flags.get(flagKey)?.value;
            const flagExplanation = options?.explanation ? options.explanation : this.flags.get(flagKey)?.explanation;
            if (triggerReason === (0, $1gSD1.ExposureTriggerReason).AutoExposure) this.sendAutomaticExposure(flagKey, flagValue, flagExplanation);
            else this._trackExposure(flagKey, {
                value: flagValue,
                explanation: flagExplanation
            }, triggerReason);
        }
        trackExposure(flagKey, flag, exposureData = {}) {
            return this._trackExposure(flagKey, flag, (0, $1gSD1.ExposureTriggerReason).Manual, exposureData);
        }
        _trackExposure(flagKey, flag, exposureTriggerReason, exposureData) {
            if (!(flag && flag.explanation && this.shouldSendEvent(flagKey, exposureData))) return;
            (0, $fXqwP.checkForReservedAttributes)(exposureData);
            const flagAttributes = {
                flagKey: flagKey,
                reason: flag.explanation.kind,
                ruleId: flag.explanation.ruleId,
                value: flag.value
            };
            this.sendExposureEvent(flagAttributes, exposureTriggerReason, exposureData);
        }
        shouldSendEvent(flagKey, customAttributes) {
            return this.analyticsHandler !== undefined && (!this.trackedFlags.has(flagKey) || !(0, $fXqwP.isObjectEmptyOrUndefined)(customAttributes) && !this.customAttributesExposuresCache.has(flagKey));
        }
        sendAutomaticExposure(flagKey, value, flagExplanation) {
            if (!(flagExplanation && this.isAutomaticExposuresEnabled && this.shouldSendEvent(flagKey))) return;
            const flagAttributes = {
                flagKey: flagKey,
                value: value,
                reason: flagExplanation.kind || 'SIMPLE_EVAL',
                ruleId: flagExplanation.ruleId,
                errorKind: flagExplanation.errorKind
            };
            this.sendExposureEvent(flagAttributes, (0, $1gSD1.ExposureTriggerReason).AutoExposure);
        }
        sendExposureEvent(attributes, exposureTriggerReason, customAttributes) {
            if (!this.trackedFlags.has(attributes.flagKey)) {
                const exposureEvent = {
                    action: 'exposed',
                    actionSubject: 'feature',
                    attributes: attributes,
                    tags: [
                        'measurement',
                        exposureTriggerReason
                    ],
                    highPriority: false,
                    source: '@atlaskit/feature-flag-client'
                };
                this.analyticsHandler?.sendOperationalEvent(exposureEvent);
                this.trackedFlags.add(attributes.flagKey);
            }
            if (!(0, $fXqwP.isObjectEmptyOrUndefined)(customAttributes)) {
                const customeAttributesExposureEvent = {
                    action: 'exposed',
                    actionSubject: 'feature',
                    attributes: Object.assign({}, attributes, customAttributes),
                    tags: [
                        'measurement',
                        (0, $1gSD1.ExposureTriggerReason).hasCustomAttributes,
                        exposureTriggerReason
                    ],
                    highPriority: true,
                    source: '@atlaskit/feature-flag-client'
                };
                this.analyticsHandler?.sendOperationalEvent(customeAttributesExposureEvent);
                this.customAttributesExposuresCache.add(attributes.flagKey);
            }
        }
        getFlagStats() {
            const flagStats = {};
            for (const [flagKey, wrapper] of this.flagWrapperCache){
                const { evaluationCount: evaluationCount } = wrapper;
                flagStats[flagKey] = {
                    evaluationCount: evaluationCount
                };
            }
            return flagStats;
        }
    }
});
parcelRegister("1gSD1", function(module, exports) {
    $parcel$export(module.exports, "ExposureTriggerReason", ()=>$bd494c4fe1caefcb$export$2c20ffeba7dbc068);
    var $bd494c4fe1caefcb$export$2c20ffeba7dbc068;
    (function(ExposureTriggerReason) {
        ExposureTriggerReason["OptIn"] = "optInExposure";
        ExposureTriggerReason["Manual"] = "manualExposure";
        ExposureTriggerReason["Default"] = "defaultExposure";
        ExposureTriggerReason["AutoExposure"] = "autoExposure";
        ExposureTriggerReason["hasCustomAttributes"] = "hasCustomAttributes";
    })($bd494c4fe1caefcb$export$2c20ffeba7dbc068 || ($bd494c4fe1caefcb$export$2c20ffeba7dbc068 = {}));
});
parcelRegister("fXqwP", function(module, exports) {
    $parcel$export(module.exports, "isObject", ()=>$1d6c3cf5d320e376$export$a6cdc56e425d0d0a);
    $parcel$export(module.exports, "isObjectEmptyOrUndefined", ()=>$1d6c3cf5d320e376$export$8ed1df9dbe2e9a7d);
    $parcel$export(module.exports, "enforceAttributes", ()=>$1d6c3cf5d320e376$export$c7d37910dd25ecbf);
    $parcel$export(module.exports, "checkForReservedAttributes", ()=>$1d6c3cf5d320e376$export$891630e169ca14a4);
    const $1d6c3cf5d320e376$export$a6cdc56e425d0d0a = (value)=>typeof value === 'object';
    const $1d6c3cf5d320e376$export$8ed1df9dbe2e9a7d = (obj)=>{
        return obj ? Object.keys(obj).length === 0 : true;
    };
    const $1d6c3cf5d320e376$export$c7d37910dd25ecbf = (obj, attributes, identifier)=>{
        attributes.forEach((attribute)=>{
            if (!(attribute in obj)) {
                const title = identifier ? `${identifier}: ` : '';
                throw new Error(`${title}Missing ${attribute}`);
            }
        });
    };
    const $1d6c3cf5d320e376$export$891630e169ca14a4 = (customAttributes)=>{
        const reservedAttributes = [
            'flagKey',
            'ruleId',
            'reason',
            'value',
            'errorKind'
        ];
        const keys = customAttributes ? Object.keys(customAttributes) : [];
        if (reservedAttributes.some((attribute)=>keys.includes(attribute))) throw new TypeError(`exposureData contains a reserved attribute. Reserved attributes are: ${reservedAttributes.join(', ')}`);
    };
    const $1d6c3cf5d320e376$var$validateFlag = (flagKey, flag)=>{
        if ($1d6c3cf5d320e376$export$a6cdc56e425d0d0a(flag) && 'value' in flag) return true;
    };
    const $1d6c3cf5d320e376$export$410eec87ab950965 = (flags)=>{
        Object.keys(flags).forEach((key)=>$1d6c3cf5d320e376$var$validateFlag(key, flags[key]));
    };
});
parcelRegister("5hDSz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$deacd3c6823edc08$export$2e2bcd8739ae039);
    const $deacd3c6823edc08$export$933245d8afcc8872 = {
        kind: 'ERROR',
        errorKind: 'FLAG_NOT_FOUND'
    };
    class $deacd3c6823edc08$export$2e2bcd8739ae039 {
        evaluate(defaultValue) {
            return defaultValue;
        }
        getBooleanValue(options) {
            return this.evaluate(options.default);
        }
        getVariantValue(options) {
            return this.evaluate(options.default);
        }
        getJSONValue() {
            return this.evaluate({});
        }
        getRawValue(options) {
            return this.evaluate(options.default);
        }
        getFlagEvaluation(options) {
            const value = this.evaluate(options.default);
            return {
                value: value,
                explanation: $deacd3c6823edc08$export$933245d8afcc8872
            };
        }
        constructor(){
            this.evaluationCount = -1;
        }
    }
});
parcelRegister("e7l5w", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f63d4e17965177ea$export$2e2bcd8739ae039);
    var $1gSD1 = parcelRequire("1gSD1");
    class $f63d4e17965177ea$export$2e2bcd8739ae039 {
        constructor(flagKey, flag, trackExposure, sendAutomaticExposure, ignoreTypes){
            this.flagKey = flagKey;
            this.flag = flag;
            this.evaluationCount = 0;
            this.trackExposure = trackExposure;
            this.sendAutomaticExposure = sendAutomaticExposure;
            this.ignoreTypes = ignoreTypes;
        }
        getCachedResultOrCompute(defaultValue, { shouldTrackExposureEvent: shouldTrackExposureEvent, exposureData: exposureData, oneOf: oneOf, ignoreTypes: ignoreTypes }) {
            let exposureTriggerReason = (0, $1gSD1.ExposureTriggerReason).OptIn;
            if (shouldTrackExposureEvent === undefined) {
                shouldTrackExposureEvent = true;
                exposureTriggerReason = (0, $1gSD1.ExposureTriggerReason).Default;
            }
            if (this.evaluationResult === undefined) this.evaluationResult = this.computeWithValidation(defaultValue, {
                oneOf: oneOf,
                ignoreTypes: ignoreTypes
            });
            let value = this.evaluationResult.value;
            if (this.evaluationResult.didFallbackToDefaultValue) value = defaultValue;
            else if (shouldTrackExposureEvent) this.trackExposure(this.flagKey, this.flag, exposureTriggerReason, exposureData);
            this.sendAutomaticExposure(this.flagKey, value, this.evaluationResult.explanation);
            this.evaluationCount++;
            return {
                value: value,
                explanation: this.evaluationResult.explanation
            };
        }
        computeWithValidation(defaultValue, { oneOf: oneOf, ignoreTypes: ignoreTypes }) {
            let result = {
                value: this.flag.value,
                explanation: this.flag.explanation,
                didFallbackToDefaultValue: false
            };
            if (!ignoreTypes && typeof this.flag.value !== typeof defaultValue) {
                result.value = defaultValue;
                result.didFallbackToDefaultValue = true;
                result.explanation = {
                    ...result.explanation || {},
                    kind: 'ERROR',
                    errorKind: 'WRONG_TYPE'
                };
            } else if (oneOf !== undefined && !oneOf.includes(this.flag.value)) {
                result.value = defaultValue;
                result.didFallbackToDefaultValue = true;
                result.explanation = {
                    ...result.explanation || {},
                    kind: 'ERROR',
                    errorKind: 'VALIDATION_ERROR'
                };
            }
            return result;
        }
        getBooleanValue(options) {
            const flag = this.getCachedResultOrCompute(options.default, {
                exposureData: options.exposureData,
                shouldTrackExposureEvent: options.shouldTrackExposureEvent,
                oneOf: undefined,
                ignoreTypes: this.ignoreTypes || false
            });
            return flag.value;
        }
        getVariantValue(options) {
            const flag = this.getCachedResultOrCompute(options.default, {
                exposureData: options.exposureData,
                shouldTrackExposureEvent: options.shouldTrackExposureEvent,
                oneOf: options.oneOf,
                ignoreTypes: this.ignoreTypes || false
            });
            return flag.value;
        }
        getJSONValue() {
            return this.getCachedResultOrCompute({}, {
                shouldTrackExposureEvent: false,
                ignoreTypes: this.ignoreTypes
            }).value;
        }
        getRawValue(options) {
            return this.getCachedResultOrCompute(options.default, {
                shouldTrackExposureEvent: options.shouldTrackExposureEvent,
                exposureData: options.exposureData,
                oneOf: undefined,
                ignoreTypes: true
            }).value;
        }
        getFlagEvaluation(options) {
            return this.getCachedResultOrCompute(options.default, {
                shouldTrackExposureEvent: options.shouldTrackExposureEvent,
                exposureData: options.exposureData,
                ignoreTypes: this.ignoreTypes || false
            });
        }
    }
});
parcelRegister("17RWd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a5ffd344beb0368f$export$2e2bcd8739ae039);
    var $dFBS3 = parcelRequire("dFBS3");
    var $1nBQ6 = parcelRequire("1nBQ6");
    var $eN6fN = parcelRequire("eN6fN");
    var $eHfwt = parcelRequire("eHfwt");
    var $dbRTG = parcelRequire("dbRTG");
    var $RhS2U = parcelRequire("RhS2U");
    var $beD8L = parcelRequire("beD8L");
    var $Jk7t2 = parcelRequire("Jk7t2");
    var $5tOYt = parcelRequire("5tOYt");
    var $ggFHJ = parcelRequire("ggFHJ");
    var $6LpTJ = parcelRequire("6LpTJ");
    var $2EcjH = parcelRequire("2EcjH");
    var $9pIlK = parcelRequire("9pIlK");
    var $8A3OQ = parcelRequire("8A3OQ");
    var $5KYdd = parcelRequire("5KYdd");
    var $e9fcB = parcelRequire("e9fcB");
    var $eBko8 = parcelRequire("eBko8");
    var $hQ0CZ = parcelRequire("hQ0CZ");
    var $knSwe = parcelRequire("knSwe");
    var $8G3nl = parcelRequire("8G3nl");
    const $a5ffd344beb0368f$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
    const $a5ffd344beb0368f$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
    class $a5ffd344beb0368f$export$2e2bcd8739ae039 {
        constructor(productInfo, settings = {}){
            this._useStargate = (useStargate)=>{
                if (useStargate == null) return true;
                return useStargate;
            };
            this._endsWith = (str, suffix)=>str.indexOf(suffix, str.length - suffix.length) !== -1;
            this._changeInternalUserId = (userId, anonymousId)=>{
                this.eventProcessor.getUser().setUserId(userId);
                if (anonymousId && anonymousId !== this.eventProcessor.getUser().getAnonymousId()) this.eventProcessor.getUser().setAnonymousId(anonymousId);
            };
            this._createSubproductGetter = (subproduct)=>(0, $eHfwt.default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.');
            this._createEmbeddedProductGetter = (embeddedProduct)=>(0, $eHfwt.default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.');
            this._getLastScreenEvent = ()=>{
                try {
                    return JSON.parse(this._safeSessionStorage.getItem($a5ffd344beb0368f$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
                } catch (err) {
                    this._safeSessionStorage.removeItem($a5ffd344beb0368f$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                    return null;
                }
            };
            this._setLastScreenEvent = (event)=>{
                this._safeSessionStorage.setItem($a5ffd344beb0368f$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                    name: event.name,
                    attributes: event.attributes
                }));
            };
            this._shouldEventBeDelayed = (event)=>{
                if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
                const isEventHighPriority = event.highPriority !== false;
                return this.eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
            };
            this._fireEvent = (identifier, builtEvent, context, callback)=>{
                switch(builtEvent.eventType){
                    case (0, $1nBQ6.eventType).UI:
                    case (0, $1nBQ6.eventType).OPERATIONAL:
                    case (0, $1nBQ6.eventType).TRACK:
                        return this.eventProcessor.track(identifier, builtEvent, context, callback);
                    case (0, $1nBQ6.eventType).SCREEN:
                        return this.eventProcessor.page(identifier, builtEvent, context, callback);
                    case (0, $1nBQ6.eventType).IDENTIFY:
                        return this.eventProcessor.identify(identifier, builtEvent, context, callback);
                    default:
                        throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
                }
            };
            this._fireDelayedEvent = (identifier, builtEvent, context, userInfo)=>{
                try {
                    this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                    builtEvent.tags = [
                        ...builtEvent.tags || [],
                        'sentWithDelay'
                    ];
                    this._fireEvent(identifier, builtEvent, context, undefined);
                } finally{
                    this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
                }
            };
            this._delayEvent = (identifier, builtEvent, context, userInfo, callback)=>{
                this.eventDelayQueue.push(identifier, builtEvent, context, userInfo);
                if (callback) callback();
            };
            this._processEvent = (identifier, builtEvent, context, callback)=>{
                this._testingCache.saveEvent(builtEvent);
                if (this._shouldEventBeDelayed(builtEvent)) {
                    this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                    return Promise.resolve();
                } else return this._fireEvent(identifier, builtEvent, context, callback);
            };
            this.setEmbeddedProduct = (embeddedProduct)=>{
                this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
                this.resetUIViewedTimers();
            };
            this.clearEmbeddedProduct = ()=>{
                this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
            };
            this.setSubproduct = (subproduct)=>{
                this._productInfo.subproduct = this._createSubproductGetter(subproduct);
                this.resetUIViewedTimers();
            };
            this.setOriginTracingHandlers = (originParamHandlerMapping)=>{
                const capturedOriginTraces = this.originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
                Object.keys(capturedOriginTraces).forEach((x)=>{
                    if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this.task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
                });
                const originAttributes = {};
                Object.keys(capturedOriginTraces).forEach((x)=>{
                    if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                    else console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
                });
                if (Object.keys(capturedOriginTraces).length > 0) return this.sendOperationalEvent({
                    action: 'landed',
                    actionSubject: 'origin',
                    source: 'webClient',
                    attributes: {
                        originTracesLanded: originAttributes
                    }
                }, ()=>{});
                return Promise.resolve();
            };
            this.setTenantInfo = (tenantIdType, tenantId)=>{
                if (!tenantIdType) throw new Error('Missing tenantIdType');
                if (tenantIdType !== (0, $1nBQ6.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
                if (!(0, $1nBQ6.isType)((0, $1nBQ6.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $1nBQ6.objectValues)((0, $1nBQ6.tenantType))}]`);
                this._tenantInfo = {
                    tenantIdType: tenantIdType,
                    tenantId: tenantId
                };
            };
            this.clearTenantInfo = ()=>{
                this._tenantInfo = {};
            };
            this.setOrgInfo = (orgId)=>{
                if (!orgId) throw new Error('Missing orgId');
                this._orgInfo = {
                    orgId: orgId
                };
            };
            this.clearOrgInfo = ()=>{
                this._orgInfo = {};
            };
            this.setWorkspaceInfo = (workspaceId)=>{
                if (!workspaceId) throw new Error('Missing workspaceId');
                this._workspaceInfo = {
                    workspaceId: workspaceId
                };
            };
            this.clearWorkspaceInfo = ()=>{
                this._workspaceInfo = {};
            };
            this.setUserInfo = (userIdType, userId)=>{
                (0, $beD8L.validateIdentifyEvent)(userIdType, userId);
                this._changeInternalUserId(userId);
                this._userInfo = {
                    userIdType: userIdType,
                    userId: userId,
                    anonymousId: this.eventProcessor.getUser().getAnonymousId()
                };
            };
            this.clearUserInfo = ()=>{
                this._changeInternalUserId(undefined);
                this._userInfo = {
                    anonymousId: this.eventProcessor.getUser().getAnonymousId()
                };
            };
            this.setAlias = (aliasKeyType, alias)=>{
                if (!aliasKeyType) throw new Error('Missing aliasType');
                if (!(0, $1nBQ6.isType)((0, $1nBQ6.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $1nBQ6.objectValues)((0, $1nBQ6.aliasType))}]`);
                this._aliases[aliasKeyType] = alias;
            };
            this.clearAlias = ()=>{
                this._aliases = {};
            };
            this.setGroup = (groupsKeyType, group)=>{
                if (!groupsKeyType) throw new Error('Missing groupType');
                if (!(0, $1nBQ6.isType)((0, $1nBQ6.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $1nBQ6.objectValues)((0, $1nBQ6.groupType))}]`);
                this._groups[groupsKeyType] = group;
            };
            this.clearGroup = ()=>{
                this._groups = {};
            };
            this.getAnonymousId = ()=>this._userInfo.anonymousId;
            this.setUIViewedAttributes = (uiViewedAttributes)=>{
                if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
                if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
                this._uiViewedAttributes = {
                    ...uiViewedAttributes
                };
            };
            this.getUIViewedAttributes = ()=>{
                return this._uiViewedAttributes;
            };
            this.clearUIViewedAttributes = ()=>{
                this._uiViewedAttributes = {};
            };
            this.sendIdentifyEvent = (userIdType, userId, callback)=>{
                this.setUserInfo(userIdType, userId);
                const builtEvent = {
                    userIdType: userIdType,
                    eventType: (0, $1nBQ6.eventType).IDENTIFY
                };
                return this._processEvent(userId, builtEvent, this._context, callback);
            };
            this.sendPageEvent = (name, callback)=>{
                return this.sendScreenEvent(name, callback);
            };
            this.sendScreenEvent = (event, callback, attributes)=>{
                let screenName;
                let screenAttributes;
                let screenContainers;
                let screenTags;
                if (typeof event === 'object') {
                    screenName = event.name;
                    screenAttributes = event.attributes;
                    screenContainers = event.containers;
                    screenTags = event.tags;
                } else {
                    screenName = event;
                    screenAttributes = attributes;
                }
                (0, $beD8L.validateScreenEvent)(screenName);
                (0, $beD8L.validateContainers)(screenContainers);
                const builtEvent = (0, $dbRTG.buildScreenEvent)(this._productInfo, this._tenantInfo, this._userInfo, screenAttributes, event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, event, screenContainers, this._aliases, this._groups);
                const builtEventWithName = {
                    name: screenName,
                    ...builtEvent
                };
                this._setLastScreenEvent(builtEventWithName);
                return this._processEvent(screenName, builtEventWithName, this._context, (0, $knSwe.default)(callback, builtEventWithName));
            };
            this.sendTrackEvent = (event, callback)=>{
                (0, $beD8L.validateTrackEvent)(event);
                const builtEvent = (0, $dbRTG.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $1nBQ6.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
                return this._processEvent((0, $dbRTG.buildActionName)(event), builtEvent, this._context, (0, $knSwe.default)(callback, builtEvent));
            };
            this.sendUIEvent = (event, callback)=>{
                (0, $beD8L.validateUIEvent)(event);
                const builtEvent = (0, $dbRTG.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $1nBQ6.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
                return this._processEvent((0, $dbRTG.buildActionName)(event), builtEvent, this._context, (0, $knSwe.default)(callback, builtEvent));
            };
            this.sendOperationalEvent = (event, callback)=>{
                (0, $beD8L.validateOperationalEvent)(event);
                const builtEvent = (0, $dbRTG.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $1nBQ6.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
                return this._processEvent((0, $dbRTG.buildActionName)(event), builtEvent, this._context, (0, $knSwe.default)(callback, builtEvent));
            };
            this.startUIViewedEvent = (callback)=>{
                this.stopUIViewedEvent();
                this._uiViewedEvent = new (0, $eBko8.default)(this._productInfo, ()=>({
                        embeddedProduct: this._productInfo.embeddedProduct(),
                        subproduct: this._productInfo.subproduct(),
                        tenantIdType: this._tenantInfo.tenantIdType,
                        tenantId: this._tenantInfo.tenantId,
                        userId: this._userInfo.userId,
                        lastScreenEvent: this._getLastScreenEvent(),
                        attributes: this._uiViewedAttributes
                    }), (event)=>this.sendUIEvent(event, callback));
                this._uiViewedEvent.start();
            };
            this.stopUIViewedEvent = ()=>{
                if (this._uiViewedEvent) {
                    this._uiViewedEvent.stop();
                    this._uiViewedEvent = null;
                }
            };
            this.resetUIViewedTimers = ()=>{
                if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
            };
            this.startApdexEvent = (apdexEvent)=>{
                this._apdexEvent.start(apdexEvent);
            };
            this.getApdexStart = (apdexEvent)=>this._apdexEvent.getStart(apdexEvent);
            this.stopApdexEvent = (apdexEvent, callback)=>{
                this._apdexEvent.stop(apdexEvent, callback);
            };
            this.startLowPriorityEventDelay = (timeout, callback)=>{
                this.eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
            };
            this.stopLowPriorityEventDelay = ()=>{
                this.eventDelayQueue.stopLowPriorityEventDelay();
            };
            this.onEvent = (_analyticsId, analyticsData)=>{
                if (!analyticsData) throw new Error('Missing analyticsData');
                if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
                if (analyticsData.eventType === (0, $1nBQ6.eventType).TRACK) return this.sendTrackEvent(analyticsData);
                else if (analyticsData.eventType === (0, $1nBQ6.eventType).UI) return this.sendUIEvent(analyticsData);
                else if (analyticsData.eventType === (0, $1nBQ6.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
                else if (analyticsData.eventType === (0, $1nBQ6.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
                else if (analyticsData.eventType === (0, $1nBQ6.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
                throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $1nBQ6.objectValues)((0, $1nBQ6.eventType))}]`);
            };
            if (!productInfo) throw new Error('Missing productInfo');
            if (!productInfo.env) throw new Error('Missing productInfo.env');
            if (!productInfo.product) throw new Error('Missing productInfo.product');
            if (!(0, $1nBQ6.isType)((0, $1nBQ6.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $1nBQ6.objectValues)((0, $1nBQ6.envType))}]`);
            if (productInfo.perimeter && !(0, $1nBQ6.isType)((0, $1nBQ6.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be an perimeterType: [${(0, $1nBQ6.objectValues)((0, $1nBQ6.perimeterType))}]`);
            if (!productInfo.origin) productInfo.origin = (0, $1nBQ6.originType).WEB;
            else if (!(0, $1nBQ6.isType)((0, $1nBQ6.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $1nBQ6.objectValues)((0, $1nBQ6.originType))}]`);
            if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $1nBQ6.originType).WEB ? (0, $1nBQ6.platformType).WEB : (0, $1nBQ6.platformType).DESKTOP;
            else (0, $beD8L.validatePlatform)(productInfo);
            this.logger = settings.logger || console;
            this._productInfo = {
                ...productInfo,
                subproduct: this._createSubproductGetter(productInfo.subproduct),
                embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
            };
            this._tenantInfo = {};
            this._orgInfo = {};
            this._uiViewedAttributes = {};
            this._context = (0, $dbRTG.buildContext)(this._productInfo);
            this._safeSessionStorage = new (0, $9pIlK.default)();
            const useStargate = this._useStargate(settings.useStargate);
            const apiHost = settings.apiHost || (0, $6LpTJ.selectHost)({
                useStargate: useStargate,
                env: productInfo.env,
                useLegacyUrl: settings.useLegacyUrl,
                perimeter: productInfo.perimeter,
                envOverride: productInfo.envOverride
            });
            const apiHostProtocol = settings.apiHostProtocol || 'https';
            const minRetryDelay = settings.minRetryDelay || 1000;
            const retryQueueOptions = {
                maxRetryDelay: 60000,
                minRetryDelay: minRetryDelay,
                backoffFactor: 2,
                flushWaitMs: settings.flushWaitInterval,
                flushBeforeUnload: settings.flushBeforeUnload
            };
            const retryQueuePrefix = `awc-${productInfo.env}`;
            const xidPromiseGetter = ()=>(0, $8G3nl.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
            const disableCookiePersistence = settings.disableCookiePersistence || false;
            this.eventProcessor = new (0, $Jk7t2.default)({
                apiHost: apiHost,
                apiHostProtocol: apiHostProtocol,
                product: productInfo.product,
                retryQueuePrefix: retryQueuePrefix,
                retryQueueOptions: retryQueueOptions,
                xidPromiseGetter: xidPromiseGetter,
                logger: this.logger,
                disableCookiePersistence: disableCookiePersistence
            });
            this._userInfo = {
                anonymousId: this.eventProcessor.getUser().getAnonymousId(settings?.customAnonymousIdGenerator)
            };
            this._pageVisibility = new (0, $ggFHJ.default)();
            this._tabTracking = new (0, $8A3OQ.default)();
            this._sessionTracking = new (0, $2EcjH.default)({
                sessionExpiryTime: settings.sessionExpiryTime,
                onNewSessionStarted: settings.onNewSessionStarted
            });
            this.task = new (0, $5KYdd.default)();
            this.originTracing = new (0, $5tOYt.default)();
            this._apdexEvent = new (0, $eN6fN.default)(this.sendOperationalEvent, this._pageVisibility);
            this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, $hQ0CZ.defaultHistoryReplaceFn);
            this.eventDelayQueue = new (0, $RhS2U.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
            this._testingCache = new (0, $e9fcB.default)();
            this._pageLoadId = (0, ($parcel$interopDefault($dFBS3)))();
            this._workspaceInfo = {};
            this._aliases = {};
            this._groups = {};
        }
    }
});
parcelRegister("1nBQ6", function(module, exports) {
    $parcel$export(module.exports, "envType", ()=>$dbc64b001058ad62$export$56ac8ebc9870b1b9);
    $parcel$export(module.exports, "eventType", ()=>$dbc64b001058ad62$export$4c045e605d532c98);
    $parcel$export(module.exports, "platformType", ()=>$dbc64b001058ad62$export$6b4f396210e539f3);
    $parcel$export(module.exports, "originType", ()=>$dbc64b001058ad62$export$f73e9fcd368bb695);
    $parcel$export(module.exports, "tenantType", ()=>$dbc64b001058ad62$export$496f06ac2a964da2);
    $parcel$export(module.exports, "userType", ()=>$dbc64b001058ad62$export$1827adfd178b4870);
    $parcel$export(module.exports, "apdexType", ()=>$dbc64b001058ad62$export$99b37380a464d794);
    $parcel$export(module.exports, "desktopPlatforms", ()=>$dbc64b001058ad62$export$809831be6c4c6227);
    $parcel$export(module.exports, "webPlatforms", ()=>$dbc64b001058ad62$export$19c579398ad213e7);
    $parcel$export(module.exports, "originTracingType", ()=>$dbc64b001058ad62$export$62a500c02dc63ee);
    $parcel$export(module.exports, "objectValues", ()=>$dbc64b001058ad62$export$ad1854f4a08c15f8);
    $parcel$export(module.exports, "isType", ()=>$dbc64b001058ad62$export$26b9f946b448f23e);
    $parcel$export(module.exports, "perimeterType", ()=>$dbc64b001058ad62$export$bdd41749d2096e4b);
    $parcel$export(module.exports, "aliasType", ()=>$dbc64b001058ad62$export$a8c99e46b781d936);
    $parcel$export(module.exports, "groupType", ()=>$dbc64b001058ad62$export$e73680b18d9b7c6e);
    var $dbc64b001058ad62$export$56ac8ebc9870b1b9;
    (function(envType) {
        envType["LOCAL"] = "local";
        envType["DEV"] = "dev";
        envType["STAGING"] = "staging";
        envType["PROD"] = "prod";
    })($dbc64b001058ad62$export$56ac8ebc9870b1b9 || ($dbc64b001058ad62$export$56ac8ebc9870b1b9 = {}));
    var $dbc64b001058ad62$export$4c045e605d532c98;
    (function(eventType) {
        eventType["TRACK"] = "track";
        eventType["UI"] = "ui";
        eventType["OPERATIONAL"] = "operational";
        eventType["SCREEN"] = "screen";
        eventType["IDENTIFY"] = "identify";
    })($dbc64b001058ad62$export$4c045e605d532c98 || ($dbc64b001058ad62$export$4c045e605d532c98 = {}));
    var $dbc64b001058ad62$export$6b4f396210e539f3;
    (function(platformType) {
        platformType["MAC"] = "mac";
        platformType["LINUX"] = "linux";
        platformType["WINDOWS"] = "windows";
        platformType["DESKTOP"] = "desktop";
        platformType["WEB"] = "web";
        platformType["MOBILE_WEB"] = "mobileWeb";
    })($dbc64b001058ad62$export$6b4f396210e539f3 || ($dbc64b001058ad62$export$6b4f396210e539f3 = {}));
    var $dbc64b001058ad62$export$f73e9fcd368bb695;
    (function(originType) {
        originType["DESKTOP"] = "desktop";
        originType["WEB"] = "web";
    })($dbc64b001058ad62$export$f73e9fcd368bb695 || ($dbc64b001058ad62$export$f73e9fcd368bb695 = {}));
    var $dbc64b001058ad62$export$496f06ac2a964da2;
    (function(tenantType) {
        tenantType["CLOUD_ID"] = "cloudId";
        tenantType["ORG_ID"] = "orgId";
        tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
        tenantType["HALP_TEAM_ID"] = "halpTeamId";
        tenantType["LOOM_ORG_ID"] = "loomOrgId";
        tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
        tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
        tenantType["NONE"] = "none";
    })($dbc64b001058ad62$export$496f06ac2a964da2 || ($dbc64b001058ad62$export$496f06ac2a964da2 = {}));
    var $dbc64b001058ad62$export$1827adfd178b4870;
    (function(userType) {
        userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
        userType["HASHED_EMAIL"] = "hashedEmail";
        userType["LOOM"] = "loom";
        userType["TRELLO"] = "trello";
        userType["OPSGENIE"] = "opsgenie";
        userType["HALP"] = "halp";
    })($dbc64b001058ad62$export$1827adfd178b4870 || ($dbc64b001058ad62$export$1827adfd178b4870 = {}));
    var $dbc64b001058ad62$export$99b37380a464d794;
    (function(apdexType) {
        apdexType["TRANSITION"] = "transition";
        apdexType["INITIAL_LOAD"] = "initialLoad";
    })($dbc64b001058ad62$export$99b37380a464d794 || ($dbc64b001058ad62$export$99b37380a464d794 = {}));
    const $dbc64b001058ad62$export$809831be6c4c6227 = Object.freeze([
        "desktop",
        "mac",
        "linux",
        "windows"
    ]);
    const $dbc64b001058ad62$export$19c579398ad213e7 = Object.freeze([
        "web",
        "mobileWeb"
    ]);
    var $dbc64b001058ad62$export$62a500c02dc63ee;
    (function(originTracingType) {
        originTracingType["ATL_ORIGIN"] = "atlOrigin";
    })($dbc64b001058ad62$export$62a500c02dc63ee || ($dbc64b001058ad62$export$62a500c02dc63ee = {}));
    function $dbc64b001058ad62$export$ad1854f4a08c15f8(object) {
        return Object.values(object);
    }
    function $dbc64b001058ad62$export$26b9f946b448f23e(type, value) {
        return Object.values(type).indexOf(value) > -1;
    }
    var $dbc64b001058ad62$export$bdd41749d2096e4b;
    (function(perimeterType) {
        perimeterType["C5"] = "c5";
        perimeterType["COMMERCIAL"] = "commercial";
        perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
        perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    })($dbc64b001058ad62$export$bdd41749d2096e4b || ($dbc64b001058ad62$export$bdd41749d2096e4b = {}));
    var $dbc64b001058ad62$export$a8c99e46b781d936;
    $dbc64b001058ad62$export$a8c99e46b781d936 || ($dbc64b001058ad62$export$a8c99e46b781d936 = {});
    var $dbc64b001058ad62$export$e73680b18d9b7c6e;
    (function(groupType) {
        groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    })($dbc64b001058ad62$export$e73680b18d9b7c6e || ($dbc64b001058ad62$export$e73680b18d9b7c6e = {}));
    var $dbc64b001058ad62$export$12b75c708da5a04b;
    $dbc64b001058ad62$export$12b75c708da5a04b || ($dbc64b001058ad62$export$12b75c708da5a04b = {});
});
parcelRegister("eN6fN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ad7107be7b017c0e$export$2e2bcd8739ae039);
    var $1nBQ6 = parcelRequire("1nBQ6");
    var $ggFHJ = parcelRequire("ggFHJ");
    var $bm7kD = parcelRequire("bm7kD");
    class $ad7107be7b017c0e$export$2e2bcd8739ae039 {
        constructor(onEvent, pageVisibility){
            this._getEventKey = ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task;
            this._getEventTimingByName = (name)=>{
                const eventTimings = this._performance.getEntriesByName(name);
                const eventTiming = eventTimings[eventTimings.length - 1];
                return eventTiming;
            };
            this._getApdexFields = (event)=>{
                const apdexTimings = this._getApdexTimings(event);
                const apdexScore = this._calculateApdex({
                    duration: apdexTimings.duration,
                    threshold: event.threshold
                });
                return {
                    ...apdexTimings,
                    apdex: apdexScore
                };
            };
            this._getApdexTimings = (event)=>{
                const eventKey = this._getEventKey(event);
                const eventStartName = `${eventKey}-start`;
                const startTime = event.startTime || this._getStartTime(event, eventStartName);
                const stopTime = event.stopTime || this._getStopTime();
                this._cleanApdexState(eventKey);
                return {
                    startTime: startTime,
                    stopTime: stopTime,
                    duration: stopTime - startTime
                };
            };
            this._getStartTime = (event, eventName)=>{
                let startTime;
                const timeOrigin = this._performance.getTimeOrigin();
                if (event.type === (0, $1nBQ6.apdexType).INITIAL_LOAD) startTime = timeOrigin;
                else {
                    const eventTiming = this._getEventTimingByName(eventName);
                    startTime = timeOrigin + eventTiming.startTime;
                }
                return startTime;
            };
            this._getStopTime = ()=>this._performance.getTimeOrigin() + this._performance.now();
            this._cleanApdexState = (eventKey)=>{
                this._performance.clearMarks(`${eventKey}-start`);
                this._performance.clearMarks(`${eventKey}-stop`);
                this._startedEvents.delete(eventKey);
            };
            this._getVisibilityFields = (event)=>{
                let isActiveTab;
                if (event.type === (0, $1nBQ6.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
                else if (event.type === (0, $1nBQ6.apdexType).TRANSITION) {
                    const eventKey = this._getEventKey(event);
                    isActiveTab = this._isActiveEvents.get(eventKey);
                }
                if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
                return {
                    isActiveTab: isActiveTab
                };
            };
            this._calculateApdex = ({ duration: duration, threshold: threshold = this._threshold })=>{
                let apdex;
                const satisfiedThreshold = threshold;
                const tolerableThreshold = threshold * 4;
                if (duration <= satisfiedThreshold) apdex = 1;
                else if (duration <= tolerableThreshold) apdex = 0.5;
                else apdex = 0;
                return apdex;
            };
            this._validateStartEvent = (event)=>{
                if (!event) throw new Error('Missing "event" in Apdex start event');
                if (!event.task) throw new Error('Missing "task" in Apdex start event');
                if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
                if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
            };
            this._validateStopEvent = (event)=>{
                if (!event) throw new Error('Missing "event" in Apdex stop event');
                if (!event.task) throw new Error('Missing "task" in Apdex stop event');
                if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
                if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
                if (!event.type) throw new Error('Missing "type" in Apdex stop event');
                if (event.type && !(0, $1nBQ6.isType)((0, $1nBQ6.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
                if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
                if (!event.startTime && event.type === (0, $1nBQ6.apdexType).TRANSITION) {
                    const eventKey = this._getEventKey(event);
                    if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
                }
                if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
                if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
                if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
            };
            this._shouldSendEvent = (event)=>{
                if (!event) return false;
                if (typeof event.apdex !== 'number') return false;
                return true;
            };
            this._sendEvent = (event, callback)=>{
                if (this._shouldSendEvent(event)) this._onEvent({
                    source: 'ui',
                    action: 'readyForUser',
                    actionSubject: 'ui',
                    attributes: {
                        ...event.additionalAttributes,
                        task: event.task,
                        taskId: event.taskId,
                        type: event.type,
                        threshold: event.threshold || this._threshold,
                        apdex: event.apdex,
                        startTime: event.startTime,
                        stopTime: event.stopTime,
                        duration: event.duration,
                        isActiveTab: event.isActiveTab
                    }
                }, callback);
            };
            if (!onEvent) throw new Error('Missing onEvent callback');
            if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
            if (!(pageVisibility instanceof (0, $ggFHJ.default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
            this._startedEvents = new Map();
            this._performance = new (0, $bm7kD.default)();
            this._onEvent = onEvent;
            this._threshold = 1000;
            this._wasPreviouslyHidden = pageVisibility.getIsHidden();
            this._isActiveEvents = new Map();
            this._pageVisibility = pageVisibility;
            this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
                this.onVisibilityChange(!isHidden);
            });
        }
        start(event) {
            this._validateStartEvent(event);
            if (!this._performance.isAvailable()) return;
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            this._startedEvents.set(eventKey, true);
            this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
            this._performance.clearMarks(eventStartName);
            this._performance.mark(eventStartName);
        }
        getStart(event) {
            this._validateStartEvent(event);
            if (!this._performance.isAvailable()) return undefined;
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            return this._getEventTimingByName(eventStartName);
        }
        stop(event, callback) {
            this._validateStopEvent(event);
            if (!this._performance.isAvailable()) return;
            const apdexFields = this._getApdexFields(event);
            const visibilityFields = this._getVisibilityFields(event);
            this._sendEvent({
                ...event,
                ...apdexFields,
                ...visibilityFields
            }, callback);
        }
        onVisibilityChange(isActive) {
            if (!isActive) {
                this._wasPreviouslyHidden = true;
                Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
            }
        }
    }
});
parcelRegister("ggFHJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ba22ee6ef63e93dd$export$2e2bcd8739ae039);
    class $ba22ee6ef63e93dd$export$2e2bcd8739ae039 {
        constructor(){
            this._bindEventListeners = ()=>{
                document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
            };
            this._handleVisibilityChange = ()=>{
                const isHidden = document[this._hidden];
                this._isHidden = isHidden;
                this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
            };
            this._isHidden = false;
            this._callbacks = new Map();
            this._hidden = undefined;
            this._visibilityChange = undefined;
            if (typeof document !== 'undefined') {
                if (typeof document.hidden !== 'undefined') {
                    this._isHidden = document.hidden;
                    this._hidden = 'hidden';
                    this._visibilityChange = 'visibilitychange';
                } else if (typeof document.msHidden !== 'undefined') {
                    this._isHidden = document.msHidden;
                    this._hidden = 'msHidden';
                    this._visibilityChange = 'msvisibilitychange';
                } else if (typeof document.webkitHidden !== 'undefined') {
                    this._isHidden = document.webkitHidden;
                    this._hidden = 'webkitHidden';
                    this._visibilityChange = 'webkitvisibilitychange';
                }
                if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
            }
        }
        addCallback(name, fn) {
            if (typeof name !== 'string') throw new Error('Invalid name, must be string');
            if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
            this._callbacks.set(name, fn);
        }
        removeCallback(name) {
            if (this._callbacks.has(name)) this._callbacks.delete(name);
        }
        getIsHidden() {
            return this._isHidden;
        }
    }
});
parcelRegister("bm7kD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f8fcb2d64e099a53$export$2e2bcd8739ae039);
    class $f8fcb2d64e099a53$export$2e2bcd8739ae039 {
        constructor(){
            this._performance = window.performance;
        }
        clearMarks(...args) {
            if (!this._performance || !this._performance.clearMarks) return;
            this._performance.clearMarks(...args);
        }
        mark(...args) {
            if (!this._performance || !this._performance.mark) return;
            this._performance.mark(...args);
        }
        getEntriesByName(...args) {
            if (!this._performance || !this._performance.getEntriesByName) return [];
            return this._performance.getEntriesByName(...args);
        }
        getTimeOrigin() {
            if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
            return this._performance.timeOrigin || this._performance.timing.navigationStart;
        }
        now() {
            if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
            return this._performance.now();
        }
        isAvailable() {
            return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
        }
    }
});
parcelRegister("eHfwt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ca83bdb32895ac4$export$2e2bcd8739ae039);
    const $2ca83bdb32895ac4$var$isFunction = (possibleFn)=>typeof possibleFn === 'function';
    var $2ca83bdb32895ac4$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
        return ()=>{
            if ($2ca83bdb32895ac4$var$isFunction(possibleFn)) try {
                return possibleFn();
            } catch (e) {
                console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
                return undefined;
            }
            return possibleFn;
        };
    };
});
parcelRegister("dbRTG", function(module, exports) {
    $parcel$export(module.exports, "buildActionFields", ()=>$34b97618d35df935$export$655ecf7241feac42);
    $parcel$export(module.exports, "buildScreenEvent", ()=>$34b97618d35df935$export$c7d9a5f56acc4b19);
    $parcel$export(module.exports, "buildActionName", ()=>$34b97618d35df935$export$9c5623a792efc9b0);
    $parcel$export(module.exports, "buildContext", ()=>$34b97618d35df935$export$3a7fe28f9bf4f3d9);
    $parcel$export(module.exports, "buildActionEvent", ()=>$34b97618d35df935$export$7bf451af4a8e3dd9);
    var $1nBQ6 = parcelRequire("1nBQ6");
    var $aityt = parcelRequire("aityt");
    const $34b97618d35df935$var$libraryVersion = "0.0.0-use.local";
    function $34b97618d35df935$var$buildTenantFields(tenantInfo) {
        return {
            tenantIdType: tenantInfo.tenantIdType,
            tenantId: tenantInfo.tenantId
        };
    }
    function $34b97618d35df935$var$buildUserFields(userInfo) {
        return {
            userIdType: userInfo.userIdType
        };
    }
    function $34b97618d35df935$var$buildOrgFields(orgInfo) {
        return {
            orgId: orgInfo.orgId
        };
    }
    function $34b97618d35df935$var$buildWorkspaceFields(workspaceInfo) {
        return {
            workspaceId: workspaceInfo.workspaceId
        };
    }
    function $34b97618d35df935$var$buildAliases(aliases) {
        if ($34b97618d35df935$var$isNotEmptyObject(aliases)) return {
            aliases: aliases
        };
        return undefined;
    }
    function $34b97618d35df935$var$buildGroups(groups) {
        if ($34b97618d35df935$var$isNotEmptyObject(groups)) return {
            groups: groups
        };
        return undefined;
    }
    function $34b97618d35df935$var$buildEventOverrides(event) {
        if (event.anonymousId) return {
            anonymousId: event.anonymousId
        };
        return {};
    }
    function $34b97618d35df935$var$getProductField(field, override) {
        return override === undefined ? field : override;
    }
    function $34b97618d35df935$var$buildProductFields(productInfo, productOverrides) {
        const overrides = productOverrides || {};
        const env = $34b97618d35df935$var$getProductField(productInfo.env, overrides.env);
        const product = $34b97618d35df935$var$getProductField(productInfo.product, overrides.product);
        const subproduct = $34b97618d35df935$var$getProductField(productInfo.subproduct(), overrides.subproduct);
        const version = $34b97618d35df935$var$getProductField(productInfo.version, overrides.version);
        const origin = $34b97618d35df935$var$getProductField(productInfo.origin, overrides.origin);
        const platform = $34b97618d35df935$var$getProductField(productInfo.platform, overrides.platform);
        return {
            env: env,
            product: product,
            subproduct: subproduct,
            version: version,
            origin: origin,
            platform: platform
        };
    }
    function $34b97618d35df935$var$isNotEmptyObject(obj) {
        return (0, $aityt.isPlainObject)(obj) && Object.keys(obj).length > 0;
    }
    function $34b97618d35df935$var$buildAttributesWithName(name, attrObject) {
        return $34b97618d35df935$var$isNotEmptyObject(attrObject) ? {
            [name]: attrObject
        } : undefined;
    }
    function $34b97618d35df935$var$buildAttributes(attributes) {
        return $34b97618d35df935$var$buildAttributesWithName('attributes', attributes);
    }
    function $34b97618d35df935$export$3f5115a568819c1a(containers) {
        const validContainers = {};
        Object.keys(containers).forEach((key)=>{
            const value = containers[key];
            validContainers[key] = {
                id: value.id,
                type: value.type
            };
        });
        return validContainers;
    }
    function $34b97618d35df935$export$f045f238d77c002a(containers) {
        if ($34b97618d35df935$var$isNotEmptyObject(containers)) {
            const validContainers = $34b97618d35df935$export$3f5115a568819c1a(containers);
            return $34b97618d35df935$var$buildAttributesWithName('containers', validContainers);
        }
        return undefined;
    }
    function $34b97618d35df935$export$655ecf7241feac42(event, actionEventType) {
        return {
            containerType: event.containerType,
            containerId: event.containerId,
            source: event.source,
            objectType: event.objectType,
            objectId: event.objectId,
            actionSubject: event.actionSubject,
            action: event.action,
            actionSubjectId: event.actionSubjectId,
            attributes: event.attributes,
            nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
            tags: event.tags,
            highPriority: event.highPriority,
            eventType: actionEventType,
            ...$34b97618d35df935$export$f045f238d77c002a(event.containers)
        };
    }
    function $34b97618d35df935$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
        return $34b97618d35df935$var$buildAttributesWithName('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
    }
    function $34b97618d35df935$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, event, containers, aliases, groups) {
        const productFields = $34b97618d35df935$var$buildProductFields(productInfo);
        const tenantFields = $34b97618d35df935$var$buildTenantFields(tenantInfo);
        const userFields = $34b97618d35df935$var$buildUserFields(userInfo);
        const orgFields = $34b97618d35df935$var$buildOrgFields(orgInfo);
        const workspaceFields = $34b97618d35df935$var$buildWorkspaceFields(workspaceInfo);
        const overrides = {
            title: '',
            path: '',
            url: '',
            referrer: '',
            search: '',
            eventType: (0, $1nBQ6.eventType).SCREEN
        };
        return {
            ...productFields,
            ...tenantFields,
            ...userFields,
            ...orgFields,
            ...overrides,
            ...$34b97618d35df935$var$buildAttributes(attributes),
            ...$34b97618d35df935$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes),
            ...$34b97618d35df935$export$f045f238d77c002a(containers),
            ...$34b97618d35df935$var$buildEventOverrides(event),
            tags: tags,
            tabId: tabId,
            sessionId: sessionId,
            taskSessions: taskSessions,
            pageLoadId: pageLoadId,
            ...workspaceFields,
            ...$34b97618d35df935$var$buildAliases(aliases),
            ...$34b97618d35df935$var$buildGroups(groups)
        };
    }
    function $34b97618d35df935$export$9c5623a792efc9b0(event) {
        return `${event.actionSubject} ${event.action}`;
    }
    function $34b97618d35df935$export$3a7fe28f9bf4f3d9(productInfo) {
        const screen = window.screen || {};
        return {
            context: {
                locale: productInfo.locale,
                screen: {
                    width: screen.width,
                    height: screen.height,
                    density: window.devicePixelRatio
                },
                library: {
                    name: 'analytics.js',
                    version: $34b97618d35df935$var$libraryVersion
                }
            }
        };
    }
    function $34b97618d35df935$export$e3d99b4bfec06f6e(event) {
        const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
        return {
            env: env,
            product: product,
            subproduct: subproduct,
            version: version,
            origin: origin,
            platform: platform
        };
    }
    function $34b97618d35df935$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, aliases, groups) {
        const productFields = $34b97618d35df935$var$buildProductFields(productInfo, $34b97618d35df935$export$e3d99b4bfec06f6e(event));
        const tenantFields = $34b97618d35df935$var$buildTenantFields(tenantInfo);
        const orgFields = $34b97618d35df935$var$buildOrgFields(orgInfo);
        const workspaceFields = $34b97618d35df935$var$buildWorkspaceFields(workspaceInfo);
        const userFields = $34b97618d35df935$var$buildUserFields(userInfo);
        const actionFields = $34b97618d35df935$export$655ecf7241feac42(event, actionEventType);
        return {
            ...productFields,
            ...tenantFields,
            ...orgFields,
            ...userFields,
            ...actionFields,
            ...$34b97618d35df935$var$buildEventOverrides(event),
            tabId: tabId,
            sessionId: sessionId,
            taskSessions: taskSessions,
            pageLoadId: pageLoadId,
            ...workspaceFields,
            ...$34b97618d35df935$var$buildAliases(aliases),
            ...$34b97618d35df935$var$buildGroups(groups)
        };
    }
});
parcelRegister("aityt", function(module, exports) {
    $parcel$export(module.exports, "isPlainObject", ()=>$cd93d8242b6bc713$export$53b83ca8eaab0383);
    function $cd93d8242b6bc713$var$isObject(val) {
        return val !== null && typeof val === 'object' && Array.isArray(val) === false;
    }
    function $cd93d8242b6bc713$var$isObjectObject(o) {
        return $cd93d8242b6bc713$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
    }
    function $cd93d8242b6bc713$export$53b83ca8eaab0383(o) {
        if ($cd93d8242b6bc713$var$isObjectObject(o) === false) return false;
        const ctor = o.constructor;
        if (typeof ctor !== 'function') return false;
        const prot = ctor.prototype;
        if ($cd93d8242b6bc713$var$isObjectObject(prot) === false) return false;
        if (!('isPrototypeOf' in prot)) return false;
        return true;
    }
});
parcelRegister("RhS2U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0d56ab81e9a85d1c$export$2e2bcd8739ae039);
    var $j4hdV = parcelRequire("j4hdV");
    var $8vW8W = parcelRequire("8vW8W");
    class $0d56ab81e9a85d1c$export$2e2bcd8739ae039 {
        constructor(fireDelayedEvent, compressors){
            this.push = (identifier, builtEvent, context, userInfo)=>{
                this.delayQueue.push(identifier, builtEvent, context, userInfo);
            };
            this.startLowPriorityEventDelay = (timeout = (0, $dfeb95986f3b0a8b$export$cf090d5281b5ae06), callback)=>{
                if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
                if (this.delayTimeout) clearTimeout(this.delayTimeout);
                const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $dfeb95986f3b0a8b$export$8575e30be0feb909)) : (0, $dfeb95986f3b0a8b$export$8575e30be0feb909);
                this.delayCallback = callback;
                this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $8vW8W.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
                this.delayQueue.cancelFlush();
                this.isDelaying = true;
            };
            this.stopLowPriorityEventDelay = (reason = (0, $8vW8W.StopLowPriorityEventDelayReason).MANUAL)=>{
                if (this.delayTimeout) {
                    clearTimeout(this.delayTimeout);
                    this.delayTimeout = undefined;
                }
                this.delayQueue.startFlush();
                this.isDelaying = false;
                this.delayCallback?.(reason);
                this.delayCallback = undefined;
            };
            this.isDelayingLowPriorityEvents = ()=>this.isDelaying;
            this.isDelaying = false;
            this.delayQueue = new (0, $j4hdV.default)(fireDelayedEvent, compressors);
        }
    }
});
const $dfeb95986f3b0a8b$export$cf090d5281b5ae06 = 10000;
const $dfeb95986f3b0a8b$export$8575e30be0feb909 = 30000;
parcelRegister("j4hdV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5f03aa195737b011$export$2e2bcd8739ae039);
    var $dbRTG = parcelRequire("dbRTG");
    var $6jXwZ = parcelRequire("6jXwZ");
    var $iAEbS = parcelRequire("iAEbS");
    const $5f03aa195737b011$var$FLUSH_BATCH_SIZE = 7;
    const $5f03aa195737b011$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
    class $5f03aa195737b011$export$2e2bcd8739ae039 {
        constructor(processFn, compressionRules){
            this.push = (identifier, builtEvent, context, userInfo)=>{
                this.eventArgs.push({
                    identifier: identifier,
                    builtEvent: builtEvent,
                    context: context,
                    userInfo: userInfo
                });
            };
            this.size = ()=>this.eventArgs.length;
            this.startFlush = ()=>{
                try {
                    this.eventArgs = this.compressEventArgs(this.eventArgs);
                } catch (e) {
                    console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
                }
                this.flushNextBatch();
            };
            this.cancelFlush = ()=>{
                if (this.flushBatchTimeout) {
                    clearTimeout(this.flushBatchTimeout);
                    this.flushBatchTimeout = null;
                }
            };
            this.flushNextBatch = ()=>{
                const batch = this.eventArgs.splice(0, $5f03aa195737b011$var$FLUSH_BATCH_SIZE);
                batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
                if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $5f03aa195737b011$var$FLUSH_BATCH_BACKOFF_PERIOD);
                else this.flushBatchTimeout = null;
            };
            this.compressEventArgs = (eventArgs)=>{
                const [compressibleEventArgs, incompressibleEventArgs] = (0, $6jXwZ.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
                const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                    const matchingGroup = groups.find((group)=>(0, $6jXwZ.equals)(group.userInfo, args.userInfo) && (0, $6jXwZ.equals)(group.context, args.context));
                    if (matchingGroup) matchingGroup.eventArgs.push(args);
                    else groups.push({
                        userInfo: args.userInfo,
                        context: args.context,
                        eventArgs: [
                            args
                        ]
                    });
                    return groups;
                }, []);
                const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                    try {
                        const events = group.eventArgs.map((args)=>args.builtEvent);
                        const compressedEvents = this.compressor.compress(events);
                        const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                                identifier: (0, $dbRTG.buildActionName)(compressedEvent),
                                builtEvent: compressedEvent,
                                userInfo: group.userInfo,
                                context: group.context
                            }));
                        return acc.concat(compressedEventArgs);
                    } catch (e) {
                        console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                        return group.eventArgs;
                    }
                }, []);
                incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
                return allCompressedEventArgs;
            };
            this.processFn = processFn;
            this.flushBatchTimeout = null;
            this.eventArgs = [];
            this.compressor = new (0, $iAEbS.default)(compressionRules);
        }
    }
});
parcelRegister("6jXwZ", function(module, exports) {
    $parcel$export(module.exports, "mapKeys", ()=>$fa5b4713847f297a$export$781522908e4e76a1);
    $parcel$export(module.exports, "pick", ()=>$fa5b4713847f297a$export$357523c63a2253b9);
    $parcel$export(module.exports, "omitBy", ()=>$fa5b4713847f297a$export$d7a617dda645b4e3);
    $parcel$export(module.exports, "pickBy", ()=>$fa5b4713847f297a$export$b460b275d6c6aa0);
    $parcel$export(module.exports, "omit", ()=>$fa5b4713847f297a$export$30a06c8d3562193f);
    $parcel$export(module.exports, "equals", ()=>$fa5b4713847f297a$export$e9bab7fafb253603);
    $parcel$export(module.exports, "partition", ()=>$fa5b4713847f297a$export$b29f828819edca8d);
    const $fa5b4713847f297a$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
            const key = fn(obj[k], k, obj);
            acc[key] = obj[k];
            return acc;
        }, {});
    const $fa5b4713847f297a$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
    const $fa5b4713847f297a$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
    const $fa5b4713847f297a$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
    const $fa5b4713847f297a$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
    const $fa5b4713847f297a$export$e9bab7fafb253603 = (a, b)=>{
        if (a === b) return true;
        if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
        if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
        if (a.prototype !== b.prototype) return false;
        const keys = Object.keys(a);
        if (keys.length !== Object.keys(b).length) return false;
        return keys.every((k)=>$fa5b4713847f297a$export$e9bab7fafb253603(a[k], b[k]));
    };
    const $fa5b4713847f297a$export$b29f828819edca8d = (arr, fn)=>arr.reduce((acc, val, i, arr)=>{
            acc[fn(val, i, arr) ? 0 : 1].push(val);
            return acc;
        }, [
            [],
            []
        ]);
});
parcelRegister("iAEbS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ed012ed14ea42fd$export$2e2bcd8739ae039);
    var $dbRTG = parcelRequire("dbRTG");
    var $6jXwZ = parcelRequire("6jXwZ");
    var $f4Ihp = parcelRequire("f4Ihp");
    class $2ed012ed14ea42fd$export$2e2bcd8739ae039 {
        constructor(compressionRules = []){
            this.canCompress = (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event));
            this.compress = (events)=>{
                const groups = this.createGroups(events);
                return groups.reduce((allCompressedEvents, group)=>{
                    const groupCompressedEvents = this.compressGroup(group);
                    return allCompressedEvents.concat(groupCompressedEvents);
                }, []);
            };
            this.createGroups = (events)=>events.reduce((groups, event)=>{
                    const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                    let contextFields;
                    if (matchingCompressor) {
                        const actionFields = (0, $dbRTG.buildActionFields)(event, event.eventType);
                        contextFields = (0, $6jXwZ.omit)(event, Object.keys(actionFields));
                    }
                    const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $6jXwZ.equals)(contextFields, group.contextFields));
                    if (matchingGroup) matchingGroup.events.push(event);
                    else groups.push({
                        contextFields: contextFields,
                        compressor: matchingCompressor,
                        events: [
                            event
                        ]
                    });
                    return groups;
                }, []);
            this.compressGroup = (group)=>{
                if (!group.compressor) return group.events;
                try {
                    const compressedEventActionFields = group.compressor.compress(group.events);
                    return compressedEventActionFields.map((actionFields)=>({
                            ...actionFields,
                            ...group.contextFields
                        }));
                } catch (e) {
                    console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.events.length} uncompressed events instead`);
                    return group.events;
                }
            };
            if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
            if (!compressionRules.every((rule)=>rule instanceof (0, $f4Ihp.CompressionRule))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
            this.compressionRules = compressionRules;
        }
    }
});
parcelRegister("f4Ihp", function(module, exports) {
    $parcel$export(module.exports, "CompressionRule", ()=>$b348e05ffe4fd2ac$export$89b3253ddfd2e6e8);
    var $beD8L = parcelRequire("beD8L");
    var $6jXwZ = parcelRequire("6jXwZ");
    class $b348e05ffe4fd2ac$export$89b3253ddfd2e6e8 {
        constructor(predicate, compressFn){
            this.canCompress = (event)=>{
                try {
                    return event && (0, $beD8L.isActionEventType)(event.eventType) && this.predicate(event);
                } catch (e) {
                    return false;
                }
            };
            this.compress = (events)=>{
                const [compatibleEvents, incompatibleEvents] = (0, $6jXwZ.partition)(events, (event)=>this.canCompress(event));
                const compressedEvents = this.compressFn(compatibleEvents);
                if (!compressedEvents) throw new Error('No events were returned from the compression function');
                compressedEvents.forEach((event)=>{
                    (0, $beD8L.validateActionEventType)(event.eventType);
                    (0, $beD8L.validateActionEvent)(event);
                });
                return compressedEvents.concat(incompatibleEvents);
            };
            if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
            if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
            this.predicate = predicate;
            this.compressFn = compressFn;
        }
    }
});
parcelRegister("beD8L", function(module, exports) {
    $parcel$export(module.exports, "validateContainers", ()=>$885a1248414f7515$export$e63ea5d8477971d3);
    $parcel$export(module.exports, "isActionEventType", ()=>$885a1248414f7515$export$d19cebda16f7579a);
    $parcel$export(module.exports, "validateActionEventType", ()=>$885a1248414f7515$export$4a8d7476662aebcc);
    $parcel$export(module.exports, "validateActionEvent", ()=>$885a1248414f7515$export$e0c121325c66ed4c);
    $parcel$export(module.exports, "validateScreenEvent", ()=>$885a1248414f7515$export$dc993432a592dc27);
    $parcel$export(module.exports, "validateTrackEvent", ()=>$885a1248414f7515$export$8c014fd74b0c8b99);
    $parcel$export(module.exports, "validateDwellBaseEvent", ()=>$885a1248414f7515$export$39d6334da9a44984);
    $parcel$export(module.exports, "validateUIEvent", ()=>$885a1248414f7515$export$e5bac0930c812e90);
    $parcel$export(module.exports, "validateOperationalEvent", ()=>$885a1248414f7515$export$1e561554275607ef);
    $parcel$export(module.exports, "validateIdentifyEvent", ()=>$885a1248414f7515$export$c16a4e16aa4026c0);
    $parcel$export(module.exports, "validatePlatform", ()=>$885a1248414f7515$export$801b46c35394d316);
    var $1nBQ6 = parcelRequire("1nBQ6");
    var $aityt = parcelRequire("aityt");
    const $885a1248414f7515$var$actionEventTypes = Object.freeze([
        (0, $1nBQ6.eventType).OPERATIONAL,
        (0, $1nBQ6.eventType).TRACK,
        (0, $1nBQ6.eventType).UI
    ]);
    function $885a1248414f7515$export$df8ff30e3c960006(container) {
        if (!(0, $aityt.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
        if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
        if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
        if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
    }
    function $885a1248414f7515$export$e63ea5d8477971d3(containers) {
        if (!containers) return;
        if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
        Object.values(containers).forEach((container)=>$885a1248414f7515$export$df8ff30e3c960006(container));
    }
    function $885a1248414f7515$export$d19cebda16f7579a(type) {
        switch(type){
            case (0, $1nBQ6.eventType).OPERATIONAL:
            case (0, $1nBQ6.eventType).TRACK:
            case (0, $1nBQ6.eventType).UI:
                return true;
            default:
                return false;
        }
    }
    function $885a1248414f7515$export$4a8d7476662aebcc(type) {
        if (!$885a1248414f7515$export$d19cebda16f7579a(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$885a1248414f7515$var$actionEventTypes}]`);
        return true;
    }
    function $885a1248414f7515$export$e0c121325c66ed4c(event) {
        if (!event) throw new Error('Missing event');
        if (!event.source) throw new Error('Missing event.source');
        if (!event.actionSubject) throw new Error('Missing event.actionSubject');
        if (!event.action) throw new Error('Missing event.action');
        $885a1248414f7515$export$e63ea5d8477971d3(event.containers);
    }
    function $885a1248414f7515$export$dc993432a592dc27(name) {
        if (!name) throw new Error('Missing name');
    }
    function $885a1248414f7515$export$8c014fd74b0c8b99(event) {
        $885a1248414f7515$export$e0c121325c66ed4c(event);
    }
    function $885a1248414f7515$export$39d6334da9a44984(event) {
        if (!event) throw new Error('Missing event');
        if (!event.source) throw new Error('Missing event.source');
        if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    }
    function $885a1248414f7515$export$e5bac0930c812e90(event) {
        $885a1248414f7515$export$e0c121325c66ed4c(event);
    }
    function $885a1248414f7515$export$1e561554275607ef(event) {
        $885a1248414f7515$export$e0c121325c66ed4c(event);
    }
    function $885a1248414f7515$export$c16a4e16aa4026c0(userIdType, userId) {
        if (!userIdType) throw new Error('Missing userIdType');
        if (!userId) throw new Error('Missing userId');
        if (!(0, $1nBQ6.isType)((0, $1nBQ6.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $1nBQ6.objectValues)((0, $1nBQ6.userType))}]`);
    }
    function $885a1248414f7515$export$801b46c35394d316(productInfo) {
        if (!(0, $1nBQ6.isType)((0, $1nBQ6.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $1nBQ6.objectValues)((0, $1nBQ6.platformType))}]`);
        if (productInfo.origin === (0, $1nBQ6.originType).DESKTOP && !(0, $1nBQ6.isType)((0, $1nBQ6.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
        if (productInfo.origin === (0, $1nBQ6.originType).WEB && !(0, $1nBQ6.isType)((0, $1nBQ6.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
    }
});
parcelRegister("8vW8W", function(module, exports) {
    $parcel$export(module.exports, "StopLowPriorityEventDelayReason", ()=>$0ba5c3a30425e480$export$fa6e3729c21cb8f);
    var $0ba5c3a30425e480$export$fa6e3729c21cb8f;
    (function(StopLowPriorityEventDelayReason) {
        StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
        StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    })($0ba5c3a30425e480$export$fa6e3729c21cb8f || ($0ba5c3a30425e480$export$fa6e3729c21cb8f = {}));
});
parcelRegister("Jk7t2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a18bf3b7e8862b79$export$2e2bcd8739ae039);
    var $dFBS3 = parcelRequire("dFBS3");
    var $bxzpM = parcelRequire("bxzpM");
    var $leaNC = parcelRequire("leaNC");
    var $3uUR7 = parcelRequire("3uUR7");
    var $djMLM = parcelRequire("djMLM");
    var $90kbo = parcelRequire("90kbo");
    var $3hFo4 = parcelRequire("3hFo4");
    var $f5eju = parcelRequire("f5eju");
    var $7rrqM = parcelRequire("7rrqM");
    class $a18bf3b7e8862b79$export$2e2bcd8739ae039 {
        constructor(options){
            this.sendEvents = async (items, callback)=>{
                const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
                const metricsPayload = this.metrics.getMetricsPayload();
                const metadata = {
                    ...metricsPayload,
                    httpRetryCount: httpRetryCount
                };
                for(let key in metadata)if (metadata[key] === 0) delete metadata[key];
                const eventsWithXID = await this.attachXIDs(items);
                const sentAt = new Date().toISOString();
                const unpackagedEvents = eventsWithXID.map((item)=>{
                    item.msg.sentAt = sentAt;
                    return item.msg;
                });
                const batchBody = {
                    batch: unpackagedEvents,
                    sentAt: sentAt,
                    metadata: metadata
                };
                try {
                    const response = await (0, $90kbo.sendEvents)({
                        url: this.gasv3BatchUrl,
                        batch: batchBody,
                        timeout: this.options.requestTimeout
                    });
                    this.metrics.subtractFromMetrics(metricsPayload);
                    callback(null, response);
                } catch (error) {
                    callback(error, null);
                }
            };
            this.options = {
                ...options,
                requestTimeout: options.requestTimeout || (0, $djMLM.DEFAULT_REQUEST_TIMEOUT),
                retryQueueOptions: options.retryQueueOptions || {},
                logger: options.logger || console,
                disableCookiePersistence: options.disableCookiePersistence || false
            };
            this.user = new (0, $f5eju.default)(this.options?.disableCookiePersistence);
            this.xidPromiseCallback = options.xidPromiseGetter();
            this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
            this.metrics = (0, $leaNC.default)();
            this.resilienceQueue = (0, $bxzpM.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
            this.resilienceQueue.start(this.sendEvents);
        }
        getUser() {
            return this.user;
        }
        async track(eventName, builtEvent, context, callback) {
            const baseEvent = this.buildBaseEvent(context, (0, $3hFo4.SegmentEventTypes).TRACK, builtEvent);
            const eventWithoutMessageId = {
                ...baseEvent,
                type: (0, $3hFo4.SegmentEventTypes).TRACK,
                properties: (0, $7rrqM.prepareEventProperties)(builtEvent),
                event: eventName
            };
            const event = {
                ...eventWithoutMessageId,
                messageId: this.createMessageId()
            };
            const packagedEvent = this.packageEvent(event);
            await this.resilienceQueue.addItem(packagedEvent);
            if (callback) callback();
        }
        async page(eventName, builtEvent, context, callback) {
            const baseEvent = this.buildBaseEvent(context, (0, $3hFo4.SegmentEventTypes).PAGE, builtEvent);
            const eventWithoutMessageId = {
                ...baseEvent,
                type: (0, $3hFo4.SegmentEventTypes).PAGE,
                properties: (0, $7rrqM.prepareEventProperties)(builtEvent),
                name: eventName
            };
            const event = {
                ...eventWithoutMessageId,
                messageId: this.createMessageId()
            };
            const packagedEvent = this.packageEvent(event);
            await this.resilienceQueue.addItem(packagedEvent);
            if (callback) callback();
        }
        async identify(_identifier, builtEvent, context, callback) {
            const baseEvent = this.buildBaseEvent(context, (0, $3hFo4.SegmentEventTypes).IDENTIFY, builtEvent);
            const eventWithoutMessageId = {
                ...baseEvent,
                type: (0, $3hFo4.SegmentEventTypes).IDENTIFY,
                traits: (0, $7rrqM.prepareEventProperties)(builtEvent)
            };
            const event = {
                ...eventWithoutMessageId,
                messageId: this.createMessageId()
            };
            const packagedEvent = this.packageEvent(event);
            await this.resilienceQueue.addItem(packagedEvent);
            if (callback) callback();
        }
        buildBaseEvent(context, type, overrides) {
            const clonedContext = (0, $7rrqM.prepareEventProperties)(context);
            const segmentContext = (0, $7rrqM.buildContext)(clonedContext);
            return {
                context: segmentContext,
                timestamp: new Date().toISOString(),
                type: type,
                userId: this.user.getUserId(),
                anonymousId: overrides.anonymousId || this.user.getAnonymousId()
            };
        }
        createMessageId() {
            return `ajs-${(0, ($parcel$interopDefault($dFBS3)))()}`;
        }
        packageEvent(event) {
            const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
            return {
                headers: {
                    'Content-Type': 'text/plain'
                },
                msg: event,
                url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
            };
        }
        async attachXIDs(items) {
            if (this.xidPromiseCallback) return (0, $3uUR7.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
            return Promise.resolve(items);
        }
    }
});
parcelRegister("bxzpM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2f3cd80d54768ae2$export$2e2bcd8739ae039);
    var $8DxEg = parcelRequire("8DxEg");
    var $2f3cd80d54768ae2$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
        return new (0, $8DxEg.default)(retryQueuePrefix, product, options || {}, logger);
    };
});
parcelRegister("8DxEg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3e3b41011c3ed28f$export$2e2bcd8739ae039);
    var $6Fa60 = parcelRequire("6Fa60");
    var $j3BFA = parcelRequire("j3BFA");
    var $lRHtg = parcelRequire("lRHtg");
    var $eF1D7 = parcelRequire("eF1D7");
    var $g99DJ = parcelRequire("g99DJ");
    var $leaNC = parcelRequire("leaNC");
    var $kjGeJ = parcelRequire("kjGeJ");
    var $c97wm = parcelRequire("c97wm");
    var $ghn8q = parcelRequire("ghn8q");
    var $iMzJU = parcelRequire("iMzJU");
    const $3e3b41011c3ed28f$var$ONE_MINUTE = 60000;
    const $3e3b41011c3ed28f$var$LONG_POLLING_OPTIONS = {
        backoffFactor: 0,
        backoffJitterPercentage: 0,
        flushWaitMs: $3e3b41011c3ed28f$var$ONE_MINUTE,
        minRetryDelay: $3e3b41011c3ed28f$var$ONE_MINUTE,
        maxRetryDelay: $3e3b41011c3ed28f$var$ONE_MINUTE
    };
    const $3e3b41011c3ed28f$export$d219df4fe04c04a7 = {
        backoffFactor: 2,
        backoffJitterPercentage: 0.2,
        batchFlushSize: 7,
        flushBeforeUnload: false,
        flushWaitMs: 500,
        maxAttempts: 10,
        maxItems: 1000,
        maxRetryDelay: 30000,
        minRetryDelay: 1000
    };
    class $3e3b41011c3ed28f$export$2e2bcd8739ae039 {
        constructor(queuePrefix, product, options, logger){
            this.queuePrefix = queuePrefix;
            this.resilience = new (0, $eF1D7.default)(product, {
                logger: logger,
                maxAttempts: options?.maxAttempts,
                maxEventLimit: options?.maxItems
            });
            this.options = this.buildOptions(options);
            this.scheduler = new (0, $c97wm.default)({
                ...this.options,
                waitInterval: options?.flushBeforeUnload ? 0 : this.options.flushWaitMs
            }, this.scheduleCallback.bind(this));
            this.longPollingScheduler = new (0, $c97wm.default)({
                ...$3e3b41011c3ed28f$var$LONG_POLLING_OPTIONS,
                waitInterval: $3e3b41011c3ed28f$var$LONG_POLLING_OPTIONS.flushWaitMs
            }, this.scheduleLongCallBack.bind(this));
            this.metricsCollector = (0, $leaNC.default)();
            this.networkStatus = new (0, $kjGeJ.default)((status)=>{
                if (status === (0, $iMzJU.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
                else this.checkEventCountAndReschedule();
            });
        }
        start(flushCallback) {
            this.batchFlushCallback = flushCallback;
            this.longPollingScheduler.schedule();
        }
        stop() {
            this.scheduler.stop();
            this.longPollingScheduler.stop();
        }
        async addItem(item) {
            const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
            const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $g99DJ.GuardPolicy).EVICT);
            this.scheduler.schedule();
            this.metricsCollector.addToEventCount();
            if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
        }
        getGlobalRetryCount() {
            return this.scheduler.getFailureCount();
        }
        async scheduleCallback(done) {
            if (this.networkStatus.getNetworkStatus() === (0, $iMzJU.NetworkStatusEnum).OFFLINE) {
                done((0, $ghn8q.DoneState).NOOP);
                return;
            }
            try {
                const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
                done(result);
            } catch (error) {
                if (error.name === (0, $lRHtg.CallbackProcessingErrorName)) {
                    done((0, $ghn8q.DoneState).ERROR);
                    return;
                }
            } finally{
                await this.checkEventCountAndReschedule();
            }
        }
        async checkEventCountAndReschedule() {
            const eventWaitingCount = await this.resilience.getItemCount();
            if (eventWaitingCount > 0) this.scheduler.schedule({
                immediate: eventWaitingCount >= this.options.batchFlushSize
            });
        }
        async scheduleLongCallBack(done) {
            const numberOfQueuesPurged = (0, $6Fa60.default)(this.queuePrefix);
            this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
            const reclaimMetrics = await (0, $j3BFA.default)(this.queuePrefix, async (localStorageItems)=>{
                const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                        item: localStorageItem.item,
                        retryAttempts: localStorageItem.attemptNumber,
                        id: localStorageItem.id
                    }));
                const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $g99DJ.GuardPolicy).IGNORE);
                if (addedEvents.length === itemsToAdd.length) return {
                    status: 'successful'
                };
                else return {
                    status: 'partial',
                    acceptedItemIds: addedEvents.map((event)=>event.id)
                };
            });
            this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
            await this.checkEventCountAndReschedule();
            done((0, $ghn8q.DoneState).SUCCESS);
            this.longPollingScheduler.schedule();
        }
        flush(wrappedItems, otherMetadata) {
            this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
            const { batchFlushCallback: batchFlushCallback } = this;
            if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
            return new Promise((resolve, reject)=>{
                if (wrappedItems.length <= 0) {
                    resolve((0, $ghn8q.DoneState).NOOP);
                    return;
                }
                const items = wrappedItems.map((wrappedItem)=>{
                    const item = wrappedItem.item;
                    if (wrappedItem.retryAttempts > 0 && item.msg) {
                        if (!item.msg._metadata) item.msg._metadata = {};
                        item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                    }
                    return item;
                });
                batchFlushCallback(items, (error)=>{
                    if (error) {
                        if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                        reject(error);
                    } else resolve((0, $ghn8q.DoneState).SUCCESS);
                });
            });
        }
        buildOptions(options) {
            return {
                backoffFactor: options?.backoffFactor || $3e3b41011c3ed28f$export$d219df4fe04c04a7.backoffFactor,
                backoffJitterPercentage: options?.backoffJitterPercentage !== undefined ? options.backoffJitterPercentage : $3e3b41011c3ed28f$export$d219df4fe04c04a7.backoffJitterPercentage,
                batchFlushSize: options?.batchFlushSize || $3e3b41011c3ed28f$export$d219df4fe04c04a7.batchFlushSize,
                flushBeforeUnload: options?.flushBeforeUnload || $3e3b41011c3ed28f$export$d219df4fe04c04a7.flushBeforeUnload,
                flushWaitMs: options?.flushWaitMs || $3e3b41011c3ed28f$export$d219df4fe04c04a7.flushWaitMs,
                maxItems: options?.maxItems || $3e3b41011c3ed28f$export$d219df4fe04c04a7.maxItems,
                maxAttempts: options?.maxAttempts || $3e3b41011c3ed28f$export$d219df4fe04c04a7.maxAttempts,
                maxRetryDelay: options?.maxRetryDelay || $3e3b41011c3ed28f$export$d219df4fe04c04a7.maxRetryDelay,
                minRetryDelay: options?.minRetryDelay || $3e3b41011c3ed28f$export$d219df4fe04c04a7.minRetryDelay
            };
        }
    }
});
parcelRegister("6Fa60", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7274a3e8337ade98$export$2e2bcd8739ae039);
    var $3jAtv = parcelRequire("3jAtv");
    var $kR326 = parcelRequire("kR326");
    const $7274a3e8337ade98$var$validSuffixs = Object.values((0, $3jAtv.LocalStorageKeySuffix));
    var $7274a3e8337ade98$export$2e2bcd8739ae039 = (prefix)=>{
        if (typeof prefix !== 'string' || prefix.length === 0) return 0;
        try {
            const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && $7274a3e8337ade98$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
                const [, id, suffix] = currentKeys;
                if (accumulator[id] === undefined) accumulator[id] = {};
                accumulator[id][suffix] = true;
                return accumulator;
            }, {});
            const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $3jAtv.LocalStorageKeySuffix).ACK] !== true);
            queuesToPurge.forEach((id)=>{
                const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $kR326.createLocalStorageKeys)(prefix, id);
                localStorage.removeItem(inProgress);
                localStorage.removeItem(queue);
                localStorage.removeItem(reclaimStart);
                localStorage.removeItem(reclaimEnd);
            });
            return queuesToPurge.length;
        } catch (_error) {}
        return 0;
    };
});
parcelRegister("3jAtv", function(module, exports) {
    $parcel$export(module.exports, "LocalStorageKeySuffix", ()=>$bea04862174ad88e$export$ecfa71cbc9b28241);
    $parcel$export(module.exports, "Timers", ()=>$bea04862174ad88e$export$8bb2c1fb2b1765a9);
    var $bea04862174ad88e$export$ecfa71cbc9b28241;
    (function(LocalStorageKeySuffix) {
        LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
        LocalStorageKeySuffix["QUEUE"] = "queue";
        LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
        LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
        LocalStorageKeySuffix["ACK"] = "ack";
    })($bea04862174ad88e$export$ecfa71cbc9b28241 || ($bea04862174ad88e$export$ecfa71cbc9b28241 = {}));
    var $bea04862174ad88e$export$8bb2c1fb2b1765a9;
    (function(Timers) {
        Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
        Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
        Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    })($bea04862174ad88e$export$8bb2c1fb2b1765a9 || ($bea04862174ad88e$export$8bb2c1fb2b1765a9 = {}));
});
parcelRegister("kR326", function(module, exports) {
    $parcel$export(module.exports, "createLocalStorageKeys", ()=>$49262eb673b159c1$export$8433d54f767cbec5);
    var $3jAtv = parcelRequire("3jAtv");
    const $49262eb673b159c1$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
            [(0, $3jAtv.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $3jAtv.LocalStorageKeySuffix).ACK}`,
            [(0, $3jAtv.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $3jAtv.LocalStorageKeySuffix).QUEUE}`,
            [(0, $3jAtv.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $3jAtv.LocalStorageKeySuffix).IN_PROGRESS}`,
            [(0, $3jAtv.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $3jAtv.LocalStorageKeySuffix).RECLAIM_START}`,
            [(0, $3jAtv.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $3jAtv.LocalStorageKeySuffix).RECLAIM_END}`
        });
});
parcelRegister("j3BFA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e78a0625fcc78d6f$export$2e2bcd8739ae039);
    var $dFBS3 = parcelRequire("dFBS3");
    var $3jAtv = parcelRequire("3jAtv");
    var $kR326 = parcelRequire("kR326");
    const $e78a0625fcc78d6f$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
            setTimeout(resolve, msToWait);
        });
    const $e78a0625fcc78d6f$var$findOtherQueues = (queuePrefix)=>{
        try {
            return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
                if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $3jAtv.LocalStorageKeySuffix).ACK) try {
                    const ackTimestamp = localStorage.getItem(split.join('.'));
                    if (ackTimestamp) {
                        const ackTimestampNumber = parseInt(ackTimestamp);
                        return (0, $3jAtv.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                    }
                } catch (error) {}
                return false;
            }).map((split)=>split[1]);
        } catch (_error) {}
        return [];
    };
    const $e78a0625fcc78d6f$var$tryReclaim = async (options, callback)=>{
        const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
        const start = Date.now();
        localStorage.setItem(reclaimStart, options.reclaimProcessId);
        localStorage.setItem(ack, start.toString());
        await $e78a0625fcc78d6f$var$promisedSetTimeout((0, $3jAtv.Timers).RECLAIM_WAIT);
        if (Date.now() > start + (0, $3jAtv.Timers).RECLAIM_WAIT_THRESHOLD || localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
        localStorage.setItem(reclaimEnd, options.reclaimProcessId);
        await $e78a0625fcc78d6f$var$promisedSetTimeout((0, $3jAtv.Timers).RECLAIM_WAIT);
        if (Date.now() > start + (0, $3jAtv.Timers).RECLAIM_WAIT_THRESHOLD || localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
        return $e78a0625fcc78d6f$var$reclaim(options, callback);
    };
    const $e78a0625fcc78d6f$var$reclaim = async (options, callback)=>{
        const { queue: queue, inProgress: inProgress } = options.storageKeys;
        const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
        const eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || '{}');
        const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
            const itemWithId = {
                ...item,
                attemptNumber: item.attemptNumber + 1,
                id: key
            };
            return itemWithId;
        });
        const eventsToProcess = [
            ...eventsInQueue,
            ...arrayOfEventsInProgress
        ];
        if (eventsToProcess.length > 0) {
            const result = await callback(eventsToProcess);
            if (result.status === 'successful') $e78a0625fcc78d6f$var$clearLocalStorageKeys(options.storageKeys);
            else if (result.status === 'partial') {
                const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
                localStorage.removeItem(inProgress);
                localStorage.setItem(queue, JSON.stringify(leftover));
                return {
                    fullReclaim: false
                };
            }
        } else $e78a0625fcc78d6f$var$clearLocalStorageKeys(options.storageKeys);
        return {
            fullReclaim: true
        };
    };
    const $e78a0625fcc78d6f$var$clearLocalStorageKeys = (keys)=>{
        localStorage.removeItem(keys.queue);
        localStorage.removeItem(keys.inProgress);
        localStorage.removeItem(keys.reclaimEnd);
        localStorage.removeItem(keys.reclaimStart);
        localStorage.removeItem(keys.ack);
    };
    var $e78a0625fcc78d6f$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
        if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) return {
            fullReclaims: 0,
            partialReclaims: 0,
            failedReclaims: 0
        };
        const reclaimProcessId = (0, ($parcel$interopDefault($dFBS3)))();
        const queuesToReclaim = $e78a0625fcc78d6f$var$findOtherQueues(queuePrefix);
        const claims = queuesToReclaim.map((id)=>$e78a0625fcc78d6f$var$tryReclaim({
                queuePrefix: queuePrefix,
                reclaimProcessId: reclaimProcessId,
                storageKeys: (0, $kR326.createLocalStorageKeys)(queuePrefix, id)
            }, callback));
        const settledClaims = await Promise.allSettled(claims);
        const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
        const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
        const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
        const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
        return {
            failedReclaims: failedReclaims.length,
            partialReclaims: partialReclaims.length,
            fullReclaims: fullReclaims.length
        };
    };
});
parcelRegister("lRHtg", function(module, exports) {
    $parcel$export(module.exports, "CallbackProcessingErrorName", ()=>$78e99f122ce6cbef$export$a409c8de90e11e14);
    $parcel$export(module.exports, "default", ()=>$78e99f122ce6cbef$export$2e2bcd8739ae039);
    const $78e99f122ce6cbef$export$a409c8de90e11e14 = 'CallbackProcessingError';
    class $78e99f122ce6cbef$export$2e2bcd8739ae039 extends Error {
        constructor(error){
            const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
            const messageFromString = typeof error === 'string' && error;
            const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
            super(`Error thrown while processing events in callback: ${message}`);
            Object.setPrototypeOf(this, $78e99f122ce6cbef$export$2e2bcd8739ae039.prototype);
            this.name = $78e99f122ce6cbef$export$a409c8de90e11e14;
        }
    }
});
parcelRegister("eF1D7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d0b2b51f9d525378$export$2e2bcd8739ae039);
    var $JvQqm = parcelRequire("JvQqm");
    var $g99DJ = parcelRequire("g99DJ");
    var $lRHtg = parcelRequire("lRHtg");
    var $d0b2b51f9d525378$export$2e2bcd8739ae039 = (0, $JvQqm.default);
});
parcelRegister("JvQqm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb55bde555dafda5$export$2e2bcd8739ae039);
    var $g99DJ = parcelRequire("g99DJ");
    var $GsIzE = parcelRequire("GsIzE");
    var $kktRx = parcelRequire("kktRx");
    var $gC8xr = parcelRequire("gC8xr");
    var $5trHB = parcelRequire("5trHB");
    var $FPKyS = parcelRequire("FPKyS");
    class $bb55bde555dafda5$export$2e2bcd8739ae039 {
        constructor(namespace, options = {}){
            this.namespace = namespace;
            this.options = (0, $FPKyS.createOptionsWithDefaults)(options);
            if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
            this.resilience = this.getResilienceMechanism(namespace, options);
        }
        getResilienceMechanism(namespace, options) {
            if (!options.useMemory) try {
                return new (0, $gC8xr.default)(namespace, options);
            } catch (error) {
                if (!(error instanceof (0, $GsIzE.default))) options.logger?.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
            }
            return new (0, $5trHB.default)(this.namespace, options);
        }
        addItem(item, options, policy = (0, $g99DJ.GuardPolicy).ABANDON) {
            return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
        }
        bulkAddItem(itemOptions, policy = (0, $g99DJ.GuardPolicy).ABANDON) {
            return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
        }
        getItems(count) {
            return this.runOrFailOver(()=>this.resilience.getItems(count));
        }
        deleteItems(itemIds) {
            return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
        }
        getItemCount() {
            return this.runOrFailOver(()=>this.resilience.getItemCount());
        }
        processItems(processFn, count) {
            return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
        }
        storeType() {
            return this.resilience.storeType();
        }
        async runOrFailOver(runnable) {
            try {
                return await runnable();
            } catch (error) {
                if ((0, $kktRx.shouldIgnoreResilienceDbError)(error)) throw error;
                else if (this.resilience.storeType() === (0, $g99DJ.StoreType).INDEXEDDB) await this.failOver();
                return runnable();
            }
        }
        async failOver() {
            const oldResilience = this.resilience;
            const newResilience = new (0, $5trHB.default)(this.namespace, this.options);
            this.resilience = newResilience;
            try {
                const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
                if (items.length > 0) {
                    const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $g99DJ.GuardPolicy).IGNORE);
                    const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                    await oldResilience.deleteItems(addedItemIds);
                }
            } catch (error) {
                this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
            }
        }
    }
});
parcelRegister("g99DJ", function(module, exports) {
    $parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", ()=>$da2b7207b44288dc$export$d21fbb25eb37b5bf);
    $parcel$export(module.exports, "RESILIENCE_DB_NAME", ()=>$da2b7207b44288dc$export$8cad224051643259);
    $parcel$export(module.exports, "RESILIENCE_STORE_NAME", ()=>$da2b7207b44288dc$export$3d8420be07b276ab);
    $parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", ()=>$da2b7207b44288dc$export$a512a65455fce2a6);
    $parcel$export(module.exports, "TIME_ADDED_INDEX", ()=>$da2b7207b44288dc$export$89d9c1ff8ac91862);
    $parcel$export(module.exports, "RETRY_INDEX", ()=>$da2b7207b44288dc$export$a37d385bcd713809);
    $parcel$export(module.exports, "INDEXEDDB_TIMEOUT", ()=>$da2b7207b44288dc$export$6d8635fed0e4b14d);
    $parcel$export(module.exports, "StoreType", ()=>$da2b7207b44288dc$export$39337ab5872e9457);
    $parcel$export(module.exports, "GuardPolicy", ()=>$da2b7207b44288dc$export$7710d69e6f450f20);
    const $da2b7207b44288dc$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
    const $da2b7207b44288dc$export$8cad224051643259 = 'analytics-web-client';
    const $da2b7207b44288dc$export$3d8420be07b276ab = 'analytics-resilience';
    const $da2b7207b44288dc$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
    const $da2b7207b44288dc$export$89d9c1ff8ac91862 = 'timeAdded';
    const $da2b7207b44288dc$export$a37d385bcd713809 = 'retryAttempts';
    const $da2b7207b44288dc$export$6d8635fed0e4b14d = 15000;
    var $da2b7207b44288dc$export$39337ab5872e9457;
    (function(StoreType) {
        StoreType["INDEXEDDB"] = "indexeddb";
        StoreType["MEMORY"] = "memory";
    })($da2b7207b44288dc$export$39337ab5872e9457 || ($da2b7207b44288dc$export$39337ab5872e9457 = {}));
    var $da2b7207b44288dc$export$7710d69e6f450f20;
    (function(GuardPolicy) {
        GuardPolicy["IGNORE"] = "ignore";
        GuardPolicy["ABANDON"] = "abandon";
        GuardPolicy["EVICT"] = "evict";
    })($da2b7207b44288dc$export$7710d69e6f450f20 || ($da2b7207b44288dc$export$7710d69e6f450f20 = {}));
});
parcelRegister("GsIzE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b64d9f68c370e19c$export$2e2bcd8739ae039);
    const $b64d9f68c370e19c$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
    class $b64d9f68c370e19c$export$2e2bcd8739ae039 extends Error {
        constructor(){
            super('window.indexeddb is undefined.');
            Object.setPrototypeOf(this, $b64d9f68c370e19c$export$2e2bcd8739ae039.prototype);
            this.name = $b64d9f68c370e19c$export$fc14cf6dcea0f8ed;
        }
    }
});
parcelRegister("kktRx", function(module, exports) {
    $parcel$export(module.exports, "shouldIgnoreResilienceDbError", ()=>$9af87a30599f91aa$export$74101021e0969375);
    var $3A87F = parcelRequire("3A87F");
    var $lRHtg = parcelRequire("lRHtg");
    var $deY8A = parcelRequire("deY8A");
    const $9af87a30599f91aa$export$74101021e0969375 = (error)=>{
        if (error && typeof error === 'object' && 'name' in error) {
            const errorWithName = error;
            return typeof errorWithName.name === 'string' && (errorWithName.name === (0, $3A87F.AbandonWriteErrorName) || errorWithName.name === (0, $lRHtg.CallbackProcessingErrorName) || errorWithName.name === (0, $deY8A.InvalidPolicyErrorName));
        }
        return false;
    };
});
parcelRegister("3A87F", function(module, exports) {
    $parcel$export(module.exports, "AbandonWriteErrorName", ()=>$9dc1e1541cb4d620$export$ba95206613c96b28);
    $parcel$export(module.exports, "default", ()=>$9dc1e1541cb4d620$export$2e2bcd8739ae039);
    const $9dc1e1541cb4d620$export$ba95206613c96b28 = 'AbandonWriteError';
    class $9dc1e1541cb4d620$export$2e2bcd8739ae039 extends Error {
        constructor(source){
            super(`Event Limit reached. Abandoning write to: ${source}`);
            Object.setPrototypeOf(this, $9dc1e1541cb4d620$export$2e2bcd8739ae039.prototype);
            this.name = $9dc1e1541cb4d620$export$ba95206613c96b28;
        }
    }
});
parcelRegister("deY8A", function(module, exports) {
    $parcel$export(module.exports, "InvalidPolicyErrorName", ()=>$4706f7322bab0aa0$export$7e7aee9a953465ec);
    $parcel$export(module.exports, "default", ()=>$4706f7322bab0aa0$export$2e2bcd8739ae039);
    const $4706f7322bab0aa0$export$7e7aee9a953465ec = 'InvalidPolicyError';
    class $4706f7322bab0aa0$export$2e2bcd8739ae039 extends Error {
        constructor(policy, method){
            super(`Method '${method}' cannot be called with policy '${policy}'.`);
            this.name = $4706f7322bab0aa0$export$7e7aee9a953465ec;
        }
    }
});
parcelRegister("gC8xr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4d86ebcd3d0406bb$export$2e2bcd8739ae039);
    var $g99DJ = parcelRequire("g99DJ");
    var $jlssU = parcelRequire("jlssU");
    var $lRHtg = parcelRequire("lRHtg");
    var $deY8A = parcelRequire("deY8A");
    var $GsIzE = parcelRequire("GsIzE");
    var $kktRx = parcelRequire("kktRx");
    var $luSo8 = parcelRequire("luSo8");
    var $FPKyS = parcelRequire("FPKyS");
    class $4d86ebcd3d0406bb$export$2e2bcd8739ae039 {
        constructor(namespace, options = {}){
            this.startDB = async ()=>{
                return new Promise(async (resolve, reject)=>{
                    if (typeof window !== 'undefined') {
                        const dbTimeout = window.setTimeout(()=>{
                            this.logger.warn('IndexedDB timed out.');
                            reject(new (0, $GsIzE.default)());
                        }, (0, $g99DJ.INDEXEDDB_TIMEOUT));
                        const request = window.indexedDB.open((0, $g99DJ.RESILIENCE_DB_NAME), 1);
                        request.onupgradeneeded = (event)=>{
                            if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                            const db = request.result;
                            const store = db.createObjectStore((0, $g99DJ.RESILIENCE_STORE_NAME), {
                                keyPath: 'id'
                            });
                            store.createIndex((0, $g99DJ.TIME_TO_PROCESS_AFTER_INDEX), (0, $g99DJ.TIME_TO_PROCESS_AFTER_INDEX), {
                                unique: false
                            });
                            store.createIndex((0, $g99DJ.RETRY_INDEX), (0, $g99DJ.RETRY_INDEX), {
                                unique: false
                            });
                            store.createIndex((0, $g99DJ.TIME_ADDED_INDEX), (0, $g99DJ.TIME_ADDED_INDEX), {
                                unique: false
                            });
                            store.createIndex((0, $g99DJ.NAMESPACE_AND_TIME_ADDED_INDEX), [
                                'namespace',
                                'timeAdded'
                            ], {
                                unique: false
                            });
                        };
                        try {
                            await (0, $FPKyS.requestToPromise)(request);
                            return resolve(request.result);
                        } catch (error) {
                            this.logger.warn('IndexedDB failed to initialise.', error);
                            reject(new (0, $GsIzE.default)());
                        } finally{
                            window.clearTimeout(dbTimeout);
                        }
                    } else {
                        this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                        reject(new (0, $GsIzE.default)());
                    }
                });
            };
            this.addItem = async (item, options = {}, policy = (0, $g99DJ.GuardPolicy).ABANDON)=>{
                const { logger: logger, namespace: namespace } = this;
                const value = (0, $FPKyS.convertToItemWrapper)(item, namespace, options);
                const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
                if (policy === (0, $g99DJ.GuardPolicy).IGNORE) throw new (0, $deY8A.default)(policy, 'IndexedDbConnector#addItem');
                try {
                    if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                    const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                        value
                    ], policy);
                    if (bulkAddResult.items.length === 1) return {
                        item: bulkAddResult.items[0],
                        numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                    };
                    throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
                } catch (error) {
                    if ((0, $kktRx.shouldIgnoreResilienceDbError)(error)) throw error;
                    logger.log('Failed to add item to table', error);
                    throw new Error('Request to add item to table failed');
                }
            };
            this.bulkAddItem = async (itemOptions, policy = (0, $g99DJ.GuardPolicy).ABANDON)=>{
                const { logger: logger, namespace: namespace } = this;
                const items = itemOptions.map(({ item: item, ...options })=>(0, $FPKyS.convertToItemWrapper)(item, namespace, options));
                const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
                try {
                    return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
                } catch (error) {
                    if ((0, $kktRx.shouldIgnoreResilienceDbError)(error)) throw error;
                    logger.log('Failed to add item to table', error);
                    throw new Error('Request to add item to table failed');
                }
            };
            this.getItems = async (count = (0, $jlssU.GET_ITEM_COUNT))=>{
                const fixedCount = count > 0 ? count : (0, $jlssU.GET_ITEM_COUNT);
                const { logger: logger } = this;
                const maxAttempts = this.options.maxAttempts;
                const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
                const timeIndex = objectStore.index((0, $g99DJ.TIME_TO_PROCESS_AFTER_INDEX));
                const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
                const request = timeIndex.openCursor(upperBoundOpenKeyRange);
                const getResult = await new Promise(async (resolve, reject)=>{
                    const items = [];
                    let numberOfDeletedItems = 0;
                    request.onerror = (error)=>{
                        logger.error('Failed to open cursor:', error);
                        reject('Failed to open cursor');
                    };
                    request.onsuccess = (event)=>{
                        const cursor = event.target.result;
                        if (cursor) {
                            const value = {
                                ...cursor.value
                            };
                            items.push(value);
                            const updatedValue = cursor.value;
                            updatedValue.retryAttempts += 1;
                            updatedValue.timeToBeProcessedAfter = Date.now() + (0, $jlssU.VISIBILITY_TIMEOUT);
                            if (updatedValue.retryAttempts >= maxAttempts) {
                                ++numberOfDeletedItems;
                                const request = cursor.delete();
                                (0, $FPKyS.monitorErrorsOnRequest)(request, logger);
                            } else {
                                const request = cursor.update(updatedValue);
                                (0, $FPKyS.monitorErrorsOnRequest)(request, logger);
                            }
                            if (items.length < fixedCount) cursor.continue();
                            else resolve({
                                items: items,
                                numberOfDeletedItems: numberOfDeletedItems
                            });
                        } else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    };
                });
                await (0, $FPKyS.commitTransaction)(transaction, this.logger);
                return getResult;
            };
            this.deleteItems = async (itemIds)=>{
                const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
                try {
                    const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                    await (0, $FPKyS.commitTransaction)(transaction, this.logger);
                    await Promise.all(deletePromises);
                } catch (error) {
                    this.logger.warn('Failed to delete items from indexeddb.', error);
                    throw error;
                }
            };
            this.getItemCount = async ()=>{
                const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readonly');
                const timeIndex = objectStore.index((0, $g99DJ.TIME_TO_PROCESS_AFTER_INDEX));
                const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
                const request = timeIndex.count(upperBoundOpenKeyRange);
                const event = await (0, $FPKyS.requestToPromise)(request);
                await (0, $FPKyS.commitTransaction)(transaction, this.logger);
                return event.target.result;
            };
            this.processItems = async (processFn, count = (0, $jlssU.GET_ITEM_COUNT))=>{
                const { items: items, ...partialResult } = await this.getItems(count);
                try {
                    const result = await processFn(items, partialResult);
                    const itemIds = items.map((item)=>item.id);
                    await this.deleteItems(itemIds);
                    return result;
                } catch (error) {
                    throw new (0, $lRHtg.default)(error);
                }
            };
            this.deleteItem = async (objectStore, id)=>{
                const { logger: logger } = this;
                try {
                    await (0, $FPKyS.requestToPromise)(objectStore.delete(id));
                } catch (error) {
                    logger.error('Failed to delete item:', id, error);
                    throw error;
                }
            };
            this.getObjectStoreAndTransaction = async (mode)=>{
                const transaction = (await this.db).transaction((0, $g99DJ.RESILIENCE_STORE_NAME), mode);
                const objectStore = transaction.objectStore((0, $g99DJ.RESILIENCE_STORE_NAME));
                return {
                    transaction: transaction,
                    objectStore: objectStore
                };
            };
            this.options = (0, $FPKyS.createOptionsWithDefaults)(options);
            this.namespace = namespace;
            this.logger = this.options.logger;
            if (!window.indexedDB) throw new (0, $GsIzE.default)();
            this.db = this.startDB();
            this.db.catch(()=>{});
            this.globalEventLimitGuard = new (0, $luSo8.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
        }
        storeType() {
            return (0, $g99DJ.StoreType).INDEXEDDB;
        }
    }
});
parcelRegister("jlssU", function(module, exports) {
    $parcel$export(module.exports, "GET_ITEM_COUNT", ()=>$ca7d53598587685e$export$b6df3d334cec060f);
    $parcel$export(module.exports, "VISIBILITY_TIMEOUT", ()=>$ca7d53598587685e$export$14ef152a03a4b6ee);
    $parcel$export(module.exports, "MAX_ATTEMPTS", ()=>$ca7d53598587685e$export$da9ab7b2fd5998e8);
    $parcel$export(module.exports, "EVENT_COUNT_LIMIT", ()=>$ca7d53598587685e$export$1188664dfff364c8);
    const $ca7d53598587685e$export$b6df3d334cec060f = 7;
    const $ca7d53598587685e$export$14ef152a03a4b6ee = 60000;
    const $ca7d53598587685e$export$da9ab7b2fd5998e8 = 10;
    const $ca7d53598587685e$export$1188664dfff364c8 = 5000;
});
parcelRegister("luSo8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d2c5a6bd4d0fbf8$export$2e2bcd8739ae039);
    var $g99DJ = parcelRequire("g99DJ");
    var $3A87F = parcelRequire("3A87F");
    var $FPKyS = parcelRequire("FPKyS");
    class $7d2c5a6bd4d0fbf8$export$2e2bcd8739ae039 {
        constructor(eventLimit, namespace, logger, deleteItemHandler){
            this.deleteOldestNEvents = async (objectStore, count)=>{
                const productTimeAddedIndex = objectStore.index((0, $g99DJ.NAMESPACE_AND_TIME_ADDED_INDEX));
                const keyRangeValues = IDBKeyRange.bound([
                    this.namespace,
                    0
                ], [
                    this.namespace,
                    Date.now()
                ]);
                const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
                const event = await (0, $FPKyS.requestToPromise)(getAllRequest);
                const result = event?.target?.result;
                if (result && Array.isArray(result) && result.length > 0) try {
                    const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                    await Promise.all(deletePromises);
                } catch (error) {
                    this.logger.warn('Failed to delete items from indexeddb.', error);
                    throw error;
                }
            };
            if (eventLimit > 0) this.eventLimit = eventLimit;
            else throw Error('Event Limit has to be set higher than 1');
            this.namespace = namespace;
            this.logger = logger;
            this.deleteItemHandler = deleteItemHandler;
        }
        async insertItems(objectStore, items, policy = (0, $g99DJ.GuardPolicy).ABANDON) {
            const itemsToAdd = [
                ...items
            ];
            let numberOfEvictedItems = 0;
            switch(policy){
                case (0, $g99DJ.GuardPolicy).ABANDON:
                    await this.throwIfNotEnoughSpace(objectStore, items.length);
                    break;
                case (0, $g99DJ.GuardPolicy).EVICT:
                    numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                    break;
                case (0, $g99DJ.GuardPolicy).IGNORE:
                    await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                    break;
            }
            const promises = itemsToAdd.map((item)=>(0, $FPKyS.requestToPromise)(objectStore.add(item)));
            await Promise.all(promises);
            await (0, $FPKyS.commitTransaction)(objectStore.transaction, this.logger);
            return {
                items: itemsToAdd,
                numberOfEvictedItems: numberOfEvictedItems
            };
        }
        async throwIfNotEnoughSpace(objectStore, requiredSpace) {
            const freeSpace = await this.calculateFreeSpace(objectStore);
            if (freeSpace < requiredSpace) throw new (0, $3A87F.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
        }
        async evictIfNotEnoughSpace(objectStore, requiredSpace) {
            const freeSpace = await this.calculateFreeSpace(objectStore);
            if (freeSpace < requiredSpace) {
                const extraSpace = requiredSpace - freeSpace;
                await this.deleteOldestNEvents(objectStore, extraSpace);
                return extraSpace;
            }
            return 0;
        }
        async calculateHowManyEventsWeCanAdd(objectStore, items) {
            const freeSpace = await this.calculateFreeSpace(objectStore);
            if (freeSpace < items.length) {
                const numberOfItemsToRemove = items.length - freeSpace;
                const start = items.length - numberOfItemsToRemove;
                items.splice(start, numberOfItemsToRemove);
            }
        }
        async calculateFreeSpace(objectStore) {
            const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
            return this.eventLimit - numberOfEventsInDb;
        }
        async getCountofEventsInObjectStore(objectStore) {
            const productTimeAddedIndex = objectStore.index((0, $g99DJ.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const request = productTimeAddedIndex.count(keyRangeValues);
            const event = await (0, $FPKyS.requestToPromise)(request);
            return event.target.result;
        }
    }
});
parcelRegister("FPKyS", function(module, exports) {
    $parcel$export(module.exports, "convertToItemWrapper", ()=>$07928901fd86b7e5$export$aec476f33d77be11);
    $parcel$export(module.exports, "createOptionsWithDefaults", ()=>$07928901fd86b7e5$export$ddc6718318090f71);
    $parcel$export(module.exports, "requestToPromise", ()=>$07928901fd86b7e5$export$85ceed0783e42041);
    $parcel$export(module.exports, "commitTransaction", ()=>$07928901fd86b7e5$export$feab8418f018df89);
    $parcel$export(module.exports, "monitorErrorsOnRequest", ()=>$07928901fd86b7e5$export$342d941b6f724995);
    var $dFBS3 = parcelRequire("dFBS3");
    var $jlssU = parcelRequire("jlssU");
    const $07928901fd86b7e5$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
            item: item,
            id: id || (0, ($parcel$interopDefault($dFBS3)))(),
            retryAttempts: retryAttempts || 0,
            timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
            namespace: namespace,
            timeAdded: Date.now()
        });
    const $07928901fd86b7e5$export$ddc6718318090f71 = (options)=>({
            logger: options.logger || console,
            useMemory: options.useMemory || false,
            maxAttempts: options.maxAttempts || (0, $jlssU.MAX_ATTEMPTS),
            maxEventLimit: options.maxEventLimit || (0, $jlssU.EVENT_COUNT_LIMIT)
        });
    const $07928901fd86b7e5$export$85ceed0783e42041 = (request)=>{
        return new Promise((resolve, reject)=>{
            request.onsuccess = (event)=>{
                resolve(event);
            };
            request.onerror = (event)=>{
                reject(event);
            };
        });
    };
    const $07928901fd86b7e5$export$2a5213bce1720b42 = (transaction)=>{
        return new Promise((resolve, reject)=>{
            transaction.oncomplete = ()=>{
                resolve();
            };
            transaction.onerror = (event)=>{
                reject(event);
            };
            transaction.onabort = (event)=>{
                reject(event);
            };
        });
    };
    const $07928901fd86b7e5$export$feab8418f018df89 = (transaction, logger)=>{
        try {
            if (typeof transaction.commit === 'function') transaction.commit();
        } catch (error) {
            logger.error('Failed to force commit transaction:', error);
            throw error;
        }
        return $07928901fd86b7e5$export$2a5213bce1720b42(transaction);
    };
    const $07928901fd86b7e5$export$342d941b6f724995 = (request, logger)=>{
        request.onerror = (event)=>{
            logger.warn('Error thrown from request:', event);
        };
    };
});
parcelRegister("5trHB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50df4e6ac4116f15$export$2e2bcd8739ae039);
    var $g99DJ = parcelRequire("g99DJ");
    var $jlssU = parcelRequire("jlssU");
    var $lRHtg = parcelRequire("lRHtg");
    var $deY8A = parcelRequire("deY8A");
    var $9r6ak = parcelRequire("9r6ak");
    var $FPKyS = parcelRequire("FPKyS");
    class $50df4e6ac4116f15$export$2e2bcd8739ae039 {
        constructor(namespace, options = {}){
            this.namespace = namespace;
            this.memoryStore = [];
            this.options = (0, $FPKyS.createOptionsWithDefaults)(options);
            this.globalEventLimitGuard = new (0, $9r6ak.default)(this.options.maxEventLimit, {
                addItems: this.addItems.bind(this),
                getItemCount: this.getItemCount.bind(this),
                evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
            });
        }
        async addItem(item, options = {}, policy = (0, $g99DJ.GuardPolicy).ABANDON) {
            if (policy === (0, $g99DJ.GuardPolicy).IGNORE) throw new (0, $deY8A.default)(policy, 'IndexedDbConnector#addItem');
            const storedValue = (0, $FPKyS.convertToItemWrapper)(item, this.namespace, options);
            const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
                storedValue
            ], policy);
            return Promise.resolve({
                item: bulkAddItemsResult.items[0],
                numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
            });
        }
        bulkAddItem(itemOptions, policy = (0, $g99DJ.GuardPolicy).ABANDON) {
            const items = itemOptions.map(({ item: item, ...addOptions })=>(0, $FPKyS.convertToItemWrapper)(item, this.namespace, addOptions));
            return this.bulkAddItemWrapperType(items, policy);
        }
        bulkAddItemWrapperType(items, policy = (0, $g99DJ.GuardPolicy).ABANDON) {
            return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
        }
        getItems(count = (0, $jlssU.GET_ITEM_COUNT)) {
            return Promise.resolve(this.synchronousGetItems(count));
        }
        synchronousGetItems(count = (0, $jlssU.GET_ITEM_COUNT)) {
            const fixedCount = count > 0 ? count : (0, $jlssU.GET_ITEM_COUNT);
            const now = Date.now();
            const wrappedItems = [];
            const itemsToRemove = [];
            for (let wrappedItem of this.memoryStore){
                if (wrappedItem.timeToBeProcessedAfter <= now) {
                    wrappedItems.push({
                        ...wrappedItem
                    });
                    wrappedItem.timeToBeProcessedAfter += (0, $jlssU.VISIBILITY_TIMEOUT);
                    wrappedItem.retryAttempts += 1;
                    if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
                }
                if (wrappedItems.length >= fixedCount) break;
            }
            itemsToRemove.forEach((item)=>{
                const index = this.memoryStore.indexOf(item);
                this.memoryStore.splice(index, 1);
            });
            return {
                items: wrappedItems,
                numberOfDeletedItems: itemsToRemove.length
            };
        }
        deleteItems(itemIds) {
            this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
            return Promise.resolve(void 0);
        }
        getItemCount() {
            const now = Date.now();
            const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
            return Promise.resolve(count);
        }
        async processItems(processFn, count) {
            const { items: items, ...partialGetResult } = this.synchronousGetItems(count);
            const itemIds = items.map((i)=>i.id);
            try {
                const result = await processFn(items, partialGetResult);
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                throw new (0, $lRHtg.default)(error);
            }
        }
        storeType() {
            return (0, $g99DJ.StoreType).MEMORY;
        }
        addItems(itemsToAdd) {
            this.memoryStore.push(...itemsToAdd);
            this.memoryStore.sort(function(a, b) {
                return a.timeAdded - b.timeAdded;
            });
        }
        evictEventsIfNeeded(eventLimit) {
            const numberOfEventsInDb = this.memoryStore.length;
            if (numberOfEventsInDb > eventLimit) {
                const m = numberOfEventsInDb - eventLimit;
                this.memoryStore.splice(0, m);
                return m;
            }
            return 0;
        }
    }
});
parcelRegister("9r6ak", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ed6b2b0d60b3949c$export$2e2bcd8739ae039);
    var $g99DJ = parcelRequire("g99DJ");
    var $3A87F = parcelRequire("3A87F");
    class $ed6b2b0d60b3949c$export$2e2bcd8739ae039 {
        constructor(eventLimit, memoryItemHandlers){
            this.insertItemsToMemoryStore = (itemsToAdd, policy)=>{
                switch(policy){
                    case (0, $g99DJ.GuardPolicy).ABANDON:
                        return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                    case (0, $g99DJ.GuardPolicy).EVICT:
                        return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                    case (0, $g99DJ.GuardPolicy).IGNORE:
                        return this.handleAddAsManyAsPossible(itemsToAdd);
                }
            };
            if (eventLimit > 0) this.eventLimit = eventLimit;
            else throw Error('Event Limit has to be set higher than 1');
            this.memoryItemHandlers = memoryItemHandlers;
        }
        async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
            const itemCount = await this.memoryItemHandlers.getItemCount();
            if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $3A87F.default)((0, $g99DJ.StoreType).MEMORY);
            this.memoryItemHandlers.addItems(itemsToAdd);
            return {
                items: itemsToAdd,
                numberOfEvictedItems: 0
            };
        }
        handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
            this.memoryItemHandlers.addItems(itemsToAdd);
            const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
            return {
                items: itemsToAdd,
                numberOfEvictedItems: numberOfEvictedItems
            };
        }
        async handleAddAsManyAsPossible(itemsToAdd) {
            const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
            const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
            this.memoryItemHandlers.addItems(partialEventsToAdd);
            return {
                items: partialEventsToAdd,
                numberOfEvictedItems: 0
            };
        }
    }
});
parcelRegister("leaNC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d009d41ac458a28c$export$2e2bcd8739ae039);
    var $iMzJU = parcelRequire("iMzJU");
    class $d009d41ac458a28c$export$4b62ee5120ab50a8 {
        addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
            this.itemsDiscardedByRetry += numberOfDeletedEvents;
        }
        addToEventCount() {
            this.eventCount++;
        }
        addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
            this.itemsDiscardedByOverflow += numberOfDeletedEvents;
        }
        setResilienceMechanism(mechanism) {
            this.resilienceMechanism = mechanism;
        }
        addToReclaimMetrics(reclaimMetrics) {
            this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
            this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
            this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
        }
        addToPurgedQueuesMetrics(numberOfQueuesPurged) {
            this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
        }
        subtractFromMetrics(sentMetrics) {
            this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
            this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
            this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
            this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
            this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
            this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
            this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
        }
        subtractFromCount(count, subtract) {
            return Math.max(count - (subtract || 0), 0);
        }
        getMetricsPayload() {
            return {
                itemsDiscardedByRetry: this.itemsDiscardedByRetry,
                eventCount: this.eventCount,
                itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
                resilienceMechanism: this.resilienceMechanism,
                localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
                fullReclaims: this.localstorageNumberOfFullReclaims,
                partialReclaims: this.localstorageNumberOfPartialReclaims,
                failedReclaims: this.localstorageNumberOfFailedReclaims
            };
        }
        constructor(){
            this.itemsDiscardedByRetry = 0;
            this.eventCount = 0;
            this.itemsDiscardedByOverflow = 0;
            this.resilienceMechanism = (0, $iMzJU.ResilienceMechanism).INDEXEDDB;
            this.localstorageNumberOfQueuesPurged = 0;
            this.localstorageNumberOfFullReclaims = 0;
            this.localstorageNumberOfPartialReclaims = 0;
            this.localstorageNumberOfFailedReclaims = 0;
        }
    }
    let $d009d41ac458a28c$var$cachedMetricsClient = null;
    var $d009d41ac458a28c$export$2e2bcd8739ae039 = ()=>{
        if (!$d009d41ac458a28c$var$cachedMetricsClient) $d009d41ac458a28c$var$cachedMetricsClient = new $d009d41ac458a28c$export$4b62ee5120ab50a8();
        return $d009d41ac458a28c$var$cachedMetricsClient;
    };
});
parcelRegister("iMzJU", function(module, exports) {
    $parcel$export(module.exports, "ResilienceMechanism", ()=>$e89050c46a1ef727$export$c75161629e3ec34e);
    $parcel$export(module.exports, "NetworkStatusEnum", ()=>$e89050c46a1ef727$export$ee138fa712d11b84);
    var $e89050c46a1ef727$export$c75161629e3ec34e;
    (function(ResilienceMechanism) {
        ResilienceMechanism["INDEXEDDB"] = "indexeddb";
        ResilienceMechanism["MEMORY"] = "memory";
    })($e89050c46a1ef727$export$c75161629e3ec34e || ($e89050c46a1ef727$export$c75161629e3ec34e = {}));
    var $e89050c46a1ef727$export$ee138fa712d11b84;
    (function(NetworkStatusEnum) {
        NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
        NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    })($e89050c46a1ef727$export$ee138fa712d11b84 || ($e89050c46a1ef727$export$ee138fa712d11b84 = {}));
});
parcelRegister("kjGeJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$63cefcbe776919d7$export$2e2bcd8739ae039);
    var $iMzJU = parcelRequire("iMzJU");
    class $63cefcbe776919d7$export$2e2bcd8739ae039 {
        constructor(networkChangeCallback){
            if (typeof window !== 'undefined') {
                window.addEventListener('offline', ()=>networkChangeCallback((0, $iMzJU.NetworkStatusEnum).OFFLINE));
                window.addEventListener('online', ()=>networkChangeCallback((0, $iMzJU.NetworkStatusEnum).ONLINE));
            }
        }
        getNetworkStatus() {
            if (window.navigator.onLine) return (0, $iMzJU.NetworkStatusEnum).ONLINE;
            return (0, $iMzJU.NetworkStatusEnum).OFFLINE;
        }
    }
});
parcelRegister("c97wm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90c3d35a0c0c6c9d$export$2e2bcd8739ae039);
    var $hpIFS = parcelRequire("hpIFS");
    var $ghn8q = parcelRequire("ghn8q");
    const $90c3d35a0c0c6c9d$var$SCHEDULER_OPTIONS_DEFAULT = {
        minRetryDelay: 1000,
        maxRetryDelay: 30000,
        backoffFactor: 2,
        backoffJitterPercentage: 0,
        waitInterval: 500,
        callbackTimeoutPeriod: 5000
    };
    var $90c3d35a0c0c6c9d$export$8bb92baee001fc60;
    (function(QueuedScheduleTypes) {
        QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
        QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
        QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    })($90c3d35a0c0c6c9d$export$8bb92baee001fc60 || ($90c3d35a0c0c6c9d$export$8bb92baee001fc60 = {}));
    class $90c3d35a0c0c6c9d$export$2e2bcd8739ae039 {
        constructor(retryOptions, callback){
            this.schedule = ({ immediate: immediate } = {
                immediate: false
            })=>{
                if (typeof window === 'undefined') return;
                if (this.operationInFlight) {
                    if (immediate) this.queuedSchedule = 1;
                    else if (this.queuedSchedule !== 1) this.queuedSchedule = 2;
                } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                    this.clearTimeout();
                    this.run();
                } else if (this.failureCount > 0 && this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
                else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.options.waitInterval);
            };
            this.stop = ()=>{
                this.clearTimeout();
                this.queuedSchedule = 0;
            };
            this.getFailureCount = ()=>this.failureCount;
            this.getCallbackStatus = ()=>{
                return this.callbackTimer.getCallbackStatus();
            };
            this.clearTimeout = ()=>{
                if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
                    window.clearTimeout(this.scheduledTimeout);
                    this.scheduledTimeout = null;
                }
            };
            this.run = ()=>{
                this.operationInFlight = true;
                this.clearTimeout();
                try {
                    this.callbackTimer.executeCallbackWithTimeout(this.callback, this.done, ()=>this.done((0, $ghn8q.DoneState).ERROR));
                } catch (err) {
                    this.done(err);
                }
            };
            this.done = (state)=>{
                this.operationInFlight = false;
                if (state === (0, $ghn8q.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $hpIFS.CallbackStatus).TIMED_OUT) {
                    this.failureCount++;
                    this.clearTimeout();
                } else if (state === (0, $ghn8q.DoneState).SUCCESS) this.failureCount = 0;
                this.processQueuedSchedule();
            };
            this.processQueuedSchedule = ()=>{
                if (this.queuedSchedule !== 0) {
                    const immediate = this.queuedSchedule === 1;
                    this.queuedSchedule = 0;
                    this.schedule({
                        immediate: immediate
                    });
                } else if (this.failureCount > 0) this.schedule();
            };
            this.calculateBackoff = ()=>{
                const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage } = this.options;
                let ms = minRetryDelay * backoffFactor ** this.failureCount;
                if (backoffJitterPercentage) {
                    const rand = Math.random();
                    const deviation = Math.floor(rand * backoffJitterPercentage * ms);
                    if (Math.floor(rand * 10) < 5) ms -= deviation;
                    else ms += deviation;
                }
                return Number(Math.min(ms, maxRetryDelay).toPrecision(1));
            };
            this.options = {
                minRetryDelay: retryOptions.minRetryDelay || $90c3d35a0c0c6c9d$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
                maxRetryDelay: retryOptions.maxRetryDelay || $90c3d35a0c0c6c9d$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
                backoffFactor: retryOptions.backoffFactor || $90c3d35a0c0c6c9d$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
                backoffJitterPercentage: retryOptions.backoffJitterPercentage || $90c3d35a0c0c6c9d$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
                waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $90c3d35a0c0c6c9d$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
                callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $90c3d35a0c0c6c9d$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
            };
            this.scheduledTimeout = null;
            this.failureCount = 0;
            this.callback = callback;
            this.operationInFlight = false;
            this.queuedSchedule = 0;
            this.callbackTimer = new (0, $hpIFS.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
        }
    }
});
parcelRegister("hpIFS", function(module, exports) {
    $parcel$export(module.exports, "CallbackStatus", ()=>$9612b73713096769$export$ef3353088fca369c);
    $parcel$export(module.exports, "CallbackWithTimeout", ()=>$9612b73713096769$export$590a718599f8f8b3);
    var $9612b73713096769$export$ef3353088fca369c;
    (function(CallbackStatus) {
        CallbackStatus["IDLE"] = "idle";
        CallbackStatus["RUNNING"] = "running";
        CallbackStatus["COMPLETED"] = "completed";
        CallbackStatus["TIMED_OUT"] = "timedOut";
    })($9612b73713096769$export$ef3353088fca369c || ($9612b73713096769$export$ef3353088fca369c = {}));
    var $9612b73713096769$export$def7d978353eaa0;
    (function(CallbackEvent) {
        CallbackEvent["EXECUTE"] = "execute";
        CallbackEvent["COMPLETE"] = "complete";
        CallbackEvent["TIMEOUT"] = "timeout";
    })($9612b73713096769$export$def7d978353eaa0 || ($9612b73713096769$export$def7d978353eaa0 = {}));
    class $9612b73713096769$export$590a718599f8f8b3 {
        constructor(timeoutPeriod){
            this.timeoutHandle = undefined;
            this.callbackStatus = "idle";
            if (timeoutPeriod > 0) {
                this.timeoutPeriod = timeoutPeriod;
                return;
            }
            throw new Error('CallbackWithTimeout requires timeout period higher than 0');
        }
        transitionCallbackStatus(currentStatus, event) {
            switch(currentStatus){
                case "idle":
                case "timedOut":
                case "completed":
                    if (event === "execute") this.callbackStatus = "running";
                    break;
                case "running":
                    switch(event){
                        case "complete":
                            this.callbackStatus = "completed";
                            break;
                        case "timeout":
                            this.callbackStatus = "timedOut";
                            break;
                    }
                    break;
                default:
                    this.callbackStatus = currentStatus;
            }
        }
        executeCallbackWithTimeout(callback, onDone, onTimeout) {
            if (typeof window === 'undefined') return;
            this.transitionCallbackStatus(this.callbackStatus, "execute");
            this.timeoutHandle = window.setTimeout(()=>{
                this.transitionCallbackStatus(this.callbackStatus, "timeout");
                onTimeout();
            }, this.timeoutPeriod);
            callback((state)=>{
                this.cancelTimeout();
                if (this.getCallbackStatus() !== "timedOut") {
                    this.transitionCallbackStatus(this.callbackStatus, "complete");
                    onDone(state);
                }
            });
        }
        getCallbackStatus() {
            return this.callbackStatus;
        }
        cancelTimeout() {
            if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
                window.clearTimeout(this.timeoutHandle);
                this.timeoutHandle = undefined;
            }
        }
    }
});
parcelRegister("ghn8q", function(module, exports) {
    $parcel$export(module.exports, "DoneState", ()=>$f2d156b9fb8628dd$export$f93c40fda808dd0c);
    var $f2d156b9fb8628dd$export$f93c40fda808dd0c;
    (function(DoneState) {
        DoneState[DoneState["NOOP"] = 0] = "NOOP";
        DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
        DoneState[DoneState["ERROR"] = 2] = "ERROR";
    })($f2d156b9fb8628dd$export$f93c40fda808dd0c || ($f2d156b9fb8628dd$export$f93c40fda808dd0c = {}));
});
parcelRegister("3uUR7", function(module, exports) {
    $parcel$export(module.exports, "attachXidToMultipleEvents", ()=>$077496adbe706167$export$c21270cab66ab290);
    var $3hFo4 = parcelRequire("3hFo4");
    function $077496adbe706167$export$c9c3aaf655d6f275(item, xidCallback) {
        if (!(xidCallback && xidCallback instanceof Function)) return item;
        if (item.msg.type === (0, $3hFo4.SegmentEventTypes).PAGE || item.msg.type === (0, $3hFo4.SegmentEventTypes).TRACK) {
            const xid = xidCallback();
            if (xid && Array.isArray(xid)) item.msg.properties = {
                ...item.msg.properties,
                xid: xid
            };
        } else if (item.msg.traits && item.msg.type === (0, $3hFo4.SegmentEventTypes).IDENTIFY) {
            const xid = xidCallback();
            if (xid && Array.isArray(xid)) item.msg.traits = {
                ...item.msg.traits,
                xid: xid
            };
        }
        return item;
    }
    async function $077496adbe706167$export$c21270cab66ab290(items, xidItemPromiseCallback) {
        try {
            const xidCallback = await xidItemPromiseCallback;
            return items.map((item)=>$077496adbe706167$export$c9c3aaf655d6f275(item, xidCallback));
        } catch (error) {
            return items;
        }
    }
});
parcelRegister("3hFo4", function(module, exports) {
    $parcel$export(module.exports, "SegmentEventTypes", ()=>$e8489014eed0830a$export$ddf929981dc6feb3);
    var $e8489014eed0830a$export$ddf929981dc6feb3;
    (function(SegmentEventTypes) {
        SegmentEventTypes["IDENTIFY"] = "identify";
        SegmentEventTypes["PAGE"] = "page";
        SegmentEventTypes["TRACK"] = "track";
    })($e8489014eed0830a$export$ddf929981dc6feb3 || ($e8489014eed0830a$export$ddf929981dc6feb3 = {}));
    var $e8489014eed0830a$export$8d8db47b9b0efb63;
    (function(CrossDomainIdentifierType) {
        CrossDomainIdentifierType["XC"] = "xc";
        CrossDomainIdentifierType["UID"] = "uid";
    })($e8489014eed0830a$export$8d8db47b9b0efb63 || ($e8489014eed0830a$export$8d8db47b9b0efb63 = {}));
    var $e8489014eed0830a$export$2140495465f9e528;
    (function(CrossDomainIdentifierState) {
        CrossDomainIdentifierState["NEW"] = "NEW";
        CrossDomainIdentifierState["CHANGED"] = "CHANGED";
        CrossDomainIdentifierState["EXISTING"] = "EXISTING";
        CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
        CrossDomainIdentifierState["ERROR"] = "ERROR";
        CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
        CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
        CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    })($e8489014eed0830a$export$2140495465f9e528 || ($e8489014eed0830a$export$2140495465f9e528 = {}));
});
parcelRegister("djMLM", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", ()=>$2e1a99617ca13f3e$export$9175ce0e1c95daf2);
    const $2e1a99617ca13f3e$export$9175ce0e1c95daf2 = 10000;
});
parcelRegister("90kbo", function(module, exports) {
    $parcel$export(module.exports, "sendEvents", ()=>$bf509bd9a4d9a87a$export$8e8f0180c1b41fad);
    var $5iWql = parcelRequire("5iWql");
    const $bf509bd9a4d9a87a$export$8e8f0180c1b41fad = async (options)=>{
        const signal = $bf509bd9a4d9a87a$var$createOrGetAbortController(options)?.signal;
        const corsOptions = $bf509bd9a4d9a87a$var$getCorsForUrl(options.url);
        const response = await fetch(options.url, {
            method: 'POST',
            headers: {
                'Content-Type': 'text/plain'
            },
            body: JSON.stringify(options.batch),
            signal: signal,
            ...corsOptions
        });
        if (response.status === 429 || response.status >= 500 && response.status < 600) throw new Error(`HTTP Error ${response.status} (${response.statusText})`);
        return response;
    };
    const $bf509bd9a4d9a87a$var$createOrGetAbortController = (options)=>{
        if (options.abortController) return options.abortController;
        else if (options.timeout) {
            const abortController = new AbortController();
            setTimeout(()=>{
                abortController.abort();
            }, options.timeout);
            return abortController;
        }
    };
    const $bf509bd9a4d9a87a$var$getCorsForUrl = (0, $5iWql.default)((url)=>{
        const origin = new URL(url).origin;
        if (origin === location.origin) return {};
        else return {
            mode: 'cors',
            credentials: 'include'
        };
    });
});
parcelRegister("f5eju", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d14925afcb38526a$export$2e2bcd8739ae039);
    var $d2wNG = parcelRequire("d2wNG");
    var $dFBS3 = parcelRequire("dFBS3");
    var $hbQI0 = parcelRequire("hbQI0");
    var $8enbY = parcelRequire("8enbY");
    var $2Q4NN = parcelRequire("2Q4NN");
    const $d14925afcb38526a$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
    const $d14925afcb38526a$var$SAFE = 'SAFE';
    const $d14925afcb38526a$var$UNSAFE = 'UNSAFE';
    const $d14925afcb38526a$var$NOT_FOUND = 'NOT_FOUND';
    const $d14925afcb38526a$var$COOKIE = 'COOKIE';
    const $d14925afcb38526a$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
    class $d14925afcb38526a$export$2e2bcd8739ae039 {
        constructor(disableCookiePersistence){
            this.store = new (0, $2Q4NN.default)({
                useStoragePrefix: false
            });
            this.cookie = new (0, $8enbY.default)(disableCookiePersistence);
        }
        getUserId() {
            return this.userId || null;
        }
        setUserId(userId) {
            this.userId = userId;
        }
        getAnonymousId(customAnonymousIdGenerator) {
            return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
        }
        setAnonymousId(anonymousId) {
            const stringifyAnonymosId = JSON.stringify(anonymousId);
            this.cookie.set((0, $hbQI0.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
            this.lastAnonymousIdCookieUpdate = Date.now();
            return this.store.setItem((0, $hbQI0.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
        }
        getAnonymousIdFromStorage(source) {
            const rawStorageAnonidValue = source === $d14925afcb38526a$var$LOCAL_STORAGE ? this.store.getItem((0, $hbQI0.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $hbQI0.AWCCookiesKeys).AJS_ANONYMOUS_ID);
            if (rawStorageAnonidValue) {
                const unsafeValue = {
                    type: $d14925afcb38526a$var$UNSAFE,
                    anonymousId: rawStorageAnonidValue
                };
                try {
                    const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                    if (parsedAnonId && typeof parsedAnonId === 'string') return {
                        type: $d14925afcb38526a$var$SAFE,
                        anonymousId: parsedAnonId
                    };
                    return unsafeValue;
                } catch (err) {
                    return unsafeValue;
                }
            }
            return {
                type: $d14925afcb38526a$var$NOT_FOUND
            };
        }
        getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
            const localStorageValue = this.getAnonymousIdFromStorage($d14925afcb38526a$var$LOCAL_STORAGE);
            let shouldUpdateCookie = false;
            if (!this.lastAnonymousIdCookieUpdate || (0, $d2wNG.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $d14925afcb38526a$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
            switch(localStorageValue.type){
                case $d14925afcb38526a$var$SAFE:
                    if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                    return localStorageValue.anonymousId;
                case $d14925afcb38526a$var$UNSAFE:
                    return localStorageValue.anonymousId;
                case $d14925afcb38526a$var$NOT_FOUND:
                default:
                    return null;
            }
        }
        getAnonymousIdFromCookieAndUpdateLocalStorage() {
            const cookieValue = this.getAnonymousIdFromStorage($d14925afcb38526a$var$COOKIE);
            switch(cookieValue.type){
                case $d14925afcb38526a$var$SAFE:
                case $d14925afcb38526a$var$UNSAFE:
                    this.store.setItem((0, $hbQI0.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                    return cookieValue.anonymousId;
                case $d14925afcb38526a$var$NOT_FOUND:
                default:
                    return null;
            }
        }
        generateNewAnonymousId(customAnonymousIdGenerator = (0, ($parcel$interopDefault($dFBS3)))) {
            const newAnonId = customAnonymousIdGenerator();
            this.setAnonymousId(newAnonId);
            return newAnonId;
        }
    }
});
parcelRegister("hbQI0", function(module, exports) {
    $parcel$export(module.exports, "AWCCookiesKeys", ()=>$b028c0a2c7d934c0$export$202d555a5dbfd90c);
    $parcel$export(module.exports, "AllAnalyticsCookies", ()=>$b028c0a2c7d934c0$export$d4cb17942ea57c95);
    var $b028c0a2c7d934c0$export$202d555a5dbfd90c;
    (function(AWCCookiesKeys) {
        AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
        AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
        AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    })($b028c0a2c7d934c0$export$202d555a5dbfd90c || ($b028c0a2c7d934c0$export$202d555a5dbfd90c = {}));
    class $b028c0a2c7d934c0$var$CookieSchema {
        constructor(key, options){
            this.key = key;
            this.options = options;
        }
        getAttributes() {
            return this.options;
        }
        getKey() {
            return this.key;
        }
    }
    const $b028c0a2c7d934c0$var$isSecure = ()=>{
        try {
            return window && window.location && window.location.protocol === 'https:';
        } catch (err) {
            return false;
        }
    };
    const $b028c0a2c7d934c0$export$d4cb17942ea57c95 = {
        ["AWC_TLD_TEST"]: new $b028c0a2c7d934c0$var$CookieSchema('__awc_tld_test__', {
            expires: 365,
            secure: $b028c0a2c7d934c0$var$isSecure(),
            path: '/'
        }),
        ["AWC_ANALYTICS_DEBUG"]: new $b028c0a2c7d934c0$var$CookieSchema('atlassian_analytics_debug', {
            expires: 365,
            secure: $b028c0a2c7d934c0$var$isSecure(),
            path: '/'
        }),
        ["AJS_ANONYMOUS_ID"]: new $b028c0a2c7d934c0$var$CookieSchema('ajs_anonymous_id', {
            expires: 365,
            secure: $b028c0a2c7d934c0$var$isSecure(),
            path: '/'
        })
    };
});
parcelRegister("8enbY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ef7f2be1ea6bc255$export$2e2bcd8739ae039);
    var $M2DFp = parcelRequire("M2DFp");
    var $hbQI0 = parcelRequire("hbQI0");
    var $iET0i = parcelRequire("iET0i");
    var $7tGDo = parcelRequire("7tGDo");
    class $ef7f2be1ea6bc255$export$2e2bcd8739ae039 {
        constructor(disableCookiePersistence){
            this.cookieLike = (0, $7tGDo.canUseCookie)(disableCookiePersistence) ? (0, ($parcel$interopDefault($M2DFp))) : new (0, $iET0i.default)();
        }
        set(name, value, options) {
            if (!(0, $hbQI0.AllAnalyticsCookies)[name]) {
                console.warn(`Unknown cookie key ${name} provided, not set.`);
                return;
            }
            return this.cookieLike.set((0, $hbQI0.AllAnalyticsCookies)[name].getKey(), value, {
                ...(0, $hbQI0.AllAnalyticsCookies)[name].getAttributes(),
                domain: (0, $7tGDo.getTld)(),
                ...options
            });
        }
        get(name) {
            if (!(0, $hbQI0.AllAnalyticsCookies)[name]) {
                console.warn(`Unknown cookie key ${name} provided, not fetched.`);
                return;
            }
            return this.cookieLike.get((0, $hbQI0.AllAnalyticsCookies)[name].getKey());
        }
        remove(name, options) {
            if (!(0, $hbQI0.AllAnalyticsCookies)[name]) {
                console.warn(`Unknown cookie key ${name} provided, not removed.`);
                return;
            }
            this.cookieLike.remove((0, $hbQI0.AllAnalyticsCookies)[name].getKey(), {
                ...options
            });
        }
    }
});
parcelRegister("iET0i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e1fafea8d26e0149$export$2e2bcd8739ae039);
    var $2Q4NN = parcelRequire("2Q4NN");
    class $e1fafea8d26e0149$export$2e2bcd8739ae039 {
        constructor(){
            this.safeStorage = new (0, $2Q4NN.default)({
                useStoragePrefix: false
            });
        }
        set(name, value) {
            this.safeStorage.setItem(name, value);
            return value;
        }
        get(name) {
            const value = this.safeStorage.getItem(name);
            return value || undefined;
        }
        remove(name) {
            this.safeStorage.removeItem(name);
        }
    }
});
parcelRegister("2Q4NN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62064df70326b260$export$2e2bcd8739ae039);
    var $8mau1 = parcelRequire("8mau1");
    var $59ji6 = parcelRequire("59ji6");
    class $62064df70326b260$export$2e2bcd8739ae039 extends (0, $59ji6.default) {
        constructor(options){
            let storageToUse;
            try {
                storageToUse = window.localStorage || (0, $8mau1.default);
            } catch (err) {
                storageToUse = (0, $8mau1.default);
            }
            super(storageToUse, options);
        }
    }
});
parcelRegister("8mau1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$88fa578e60b93d85$export$2e2bcd8739ae039);
    class $88fa578e60b93d85$export$90e3e001bcac59c7 {
        constructor(){
            this._data = {};
            this.length = 0;
            this.setItem = (key, value)=>{
                this._data[key] = value;
                this.length = Object.keys(this._data).length;
                return value;
            };
            this.getItem = (key)=>{
                if (key in this._data) return this._data[key];
                return null;
            };
            this.removeItem = (key)=>{
                if (key in this._data) delete this._data[key];
                this.length = Object.keys(this._data).length;
                return null;
            };
            this.clear = ()=>{
                this._data = {};
                this.length = 0;
            };
            this.key = (index)=>Object.keys(this._data)[index];
        }
    }
    var $88fa578e60b93d85$export$2e2bcd8739ae039 = new $88fa578e60b93d85$export$90e3e001bcac59c7();
});
parcelRegister("59ji6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ec693ddc2cd17d8$export$2e2bcd8739ae039);
    var $1nBQ6 = parcelRequire("1nBQ6");
    var $8mau1 = parcelRequire("8mau1");
    const $9ec693ddc2cd17d8$export$41c06fdd37b7e9a5 = 'awc';
    const $9ec693ddc2cd17d8$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
    function $9ec693ddc2cd17d8$export$48c17662a6902497(store) {
        const TEST_VALUE = 'test_value';
        if (!store) return false;
        try {
            const key = 'awc.storage.support';
            store.setItem(key, TEST_VALUE);
            const value = store.getItem(key);
            store.removeItem(key);
            return value === TEST_VALUE;
        } catch (e) {
            return false;
        }
    }
    function $9ec693ddc2cd17d8$export$6325979d1c67607f(e) {
        let quotaExceeded = false;
        if (e.code) switch(e.code){
            case 22:
                quotaExceeded = true;
                break;
            case 1014:
                if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') quotaExceeded = true;
                break;
            default:
                break;
        }
        else if (e.number === -2147024882) quotaExceeded = true;
        return quotaExceeded;
    }
    class $9ec693ddc2cd17d8$export$2e2bcd8739ae039 {
        constructor(storageToUse, options = {}){
            this.getStore = ()=>this._store;
            this.getItem = (key)=>this._store.getItem(this.createKey(key));
            this.removeItem = (key)=>this._store.removeItem(this.createKey(key));
            this.setItem = (key, value)=>{
                try {
                    this._store.setItem(this.createKey(key), value);
                } catch (err) {
                    if ($9ec693ddc2cd17d8$export$6325979d1c67607f(err)) {
                        this.swapToInMemory();
                        this._store.setItem(this.createKey(key), value);
                    }
                }
            };
            this.swapToInMemory = ()=>{
                if (this._store === (0, $8mau1.default) || typeof window === 'undefined') return;
                const keys = Object.keys(this._store || {});
                let inMemoryStorage;
                if ($9ec693ddc2cd17d8$export$48c17662a6902497(window[$9ec693ddc2cd17d8$export$770aa8bc07b3de03])) inMemoryStorage = window[$9ec693ddc2cd17d8$export$770aa8bc07b3de03];
                else {
                    inMemoryStorage = (0, $8mau1.default);
                    if (!window[$9ec693ddc2cd17d8$export$770aa8bc07b3de03]) window[$9ec693ddc2cd17d8$export$770aa8bc07b3de03] = (0, $8mau1.default);
                }
                keys.forEach((key)=>{
                    if (key.indexOf(this.getPrefix()) === 0) {
                        const value = this._store.getItem(key);
                        if (value) inMemoryStorage.setItem(key, value);
                    }
                });
                this._store = inMemoryStorage;
            };
            this.clear = ()=>this._store.clear();
            this.key = (index)=>this._store.key(index);
            this.getPrefix = ()=>this._prefix;
            this.createKey = (key)=>{
                if (this._prefix) return `${this.getPrefix()}.${key}`;
                return key;
            };
            this.options = options;
            const prefixes = [];
            if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($9ec693ddc2cd17d8$export$41c06fdd37b7e9a5);
            if (options.envPrefix && options.envPrefix !== (0, $1nBQ6.envType).PROD) prefixes.push(options.envPrefix);
            this._prefix = prefixes.join('-');
            if ($9ec693ddc2cd17d8$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
            else this.swapToInMemory();
        }
    }
});
parcelRegister("7tGDo", function(module, exports) {
    $parcel$export(module.exports, "canUseCookie", ()=>$a8661ad914b04b2b$export$a9330601ee8f4d95);
    $parcel$export(module.exports, "getTld", ()=>$a8661ad914b04b2b$export$de6821eed3d5f32d);
    var $M2DFp = parcelRequire("M2DFp");
    var $5iWql = parcelRequire("5iWql");
    var $hbQI0 = parcelRequire("hbQI0");
    const $a8661ad914b04b2b$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
        if (disableCookiePersistence) return false;
        return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
    };
    const $a8661ad914b04b2b$export$eb80e1beaa8dacf8 = (0, $hbQI0.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
    const $a8661ad914b04b2b$export$19164982d36535d8 = 'tld_test';
    const $a8661ad914b04b2b$export$de6821eed3d5f32d = (0, $5iWql.default)(()=>{
        if (typeof location === 'undefined') return '';
        const { hostname: hostname } = location;
        const splitHostname = hostname.split('.');
        for(let i = 1; i <= splitHostname.length; i++){
            const domainParts = splitHostname.slice(i * -1);
            const domain = `.${domainParts.join('.')}`;
            (0, ($parcel$interopDefault($M2DFp))).set($a8661ad914b04b2b$export$eb80e1beaa8dacf8, $a8661ad914b04b2b$export$19164982d36535d8, {
                domain: domain
            });
            if ((0, ($parcel$interopDefault($M2DFp))).get($a8661ad914b04b2b$export$eb80e1beaa8dacf8) === $a8661ad914b04b2b$export$19164982d36535d8) {
                (0, ($parcel$interopDefault($M2DFp))).remove($a8661ad914b04b2b$export$eb80e1beaa8dacf8, {
                    domain: domain
                });
                return domain;
            }
        }
        return hostname;
    });
});
parcelRegister("7rrqM", function(module, exports) {
    $parcel$export(module.exports, "buildContext", ()=>$8c25a34579c1ad48$export$3a7fe28f9bf4f3d9);
    $parcel$export(module.exports, "prepareEventProperties", ()=>$8c25a34579c1ad48$export$44d22e5fb02cc68e);
    var $kpOtk = parcelRequire("kpOtk");
    const $8c25a34579c1ad48$export$3a7fe28f9bf4f3d9 = (context)=>{
        return {
            ...context.context,
            userAgent: navigator.userAgent
        };
    };
    const $8c25a34579c1ad48$export$44d22e5fb02cc68e = (properties)=>{
        const propertiesWithoutUndefined = $8c25a34579c1ad48$export$2250ccecd1e040fd(properties);
        return (0, ($parcel$interopDefault($kpOtk)))(propertiesWithoutUndefined);
    };
    const $8c25a34579c1ad48$export$2250ccecd1e040fd = (obj)=>{
        if (obj === null || typeof obj !== 'object') return obj;
        const clone = {};
        Object.keys(obj).forEach((key)=>{
            const value = $8c25a34579c1ad48$var$getValueOfObject(obj, key);
            if (value !== undefined) {
                if (Array.isArray(value)) clone[key] = value.map((i)=>$8c25a34579c1ad48$export$2250ccecd1e040fd(i));
                else if (typeof value === 'object' && value !== null) clone[key] = $8c25a34579c1ad48$export$2250ccecd1e040fd(value);
                else clone[key] = value;
            }
        });
        return clone;
    };
    const $8c25a34579c1ad48$var$getValueOfObject = (obj, key)=>{
        return obj[key];
    };
});
parcelRegister("5tOYt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6071f4979350d61e$export$2e2bcd8739ae039);
    var $1nBQ6 = parcelRequire("1nBQ6");
    var $hQ0CZ = parcelRequire("hQ0CZ");
    class $6071f4979350d61e$export$2e2bcd8739ae039 {
        constructor(){
            this.handleOriginParameters = (originParamHandlerMapping, historyReplaceFn)=>{
                const originParamLabelList = Object.keys(originParamHandlerMapping);
                if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
                const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $1nBQ6.originTracingType)).indexOf(x) < 0);
                if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
                const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
                const capturedURLParams = (0, $hQ0CZ.default)(isCaptureParam, historyReplaceFn);
                const applyHandlerFunction = (key)=>{
                    const x = originParamHandlerMapping[key](capturedURLParams[key]);
                    return {
                        [key]: x
                    };
                };
                const extractedOriginID = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
                return extractedOriginID;
            };
            this._originStore = {};
        }
    }
});
parcelRegister("hQ0CZ", function(module, exports) {
    $parcel$export(module.exports, "defaultHistoryReplaceFn", ()=>$4a507624576c3047$export$600dd5bf1b049f11);
    $parcel$export(module.exports, "default", ()=>$4a507624576c3047$export$2e2bcd8739ae039);
    var $4k2zk = parcelRequire("4k2zk");
    var $6jXwZ = parcelRequire("6jXwZ");
    const $4a507624576c3047$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, '', newUrl);
    const $4a507624576c3047$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = $4a507624576c3047$export$600dd5bf1b049f11)=>{
        const originalUrl = window.location.href;
        const fragmentHash = window.location.hash;
        const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
        const { url: url, query: query } = (0, $4k2zk.parseUrl)(removedFragmentURL);
        const captureParams = (0, $6jXwZ.pickBy)(query, isCaptureParam);
        if (Object.keys(captureParams).length > 0) {
            const queryWithoutCaptureParams = (0, $6jXwZ.omitBy)(query, isCaptureParam);
            if (Object.keys(queryWithoutCaptureParams).length > 0) {
                const newUrl = `${url}?${(0, $4k2zk.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
                historyReplaceFn(newUrl);
            } else historyReplaceFn(`${url}${fragmentHash}`);
        }
        return captureParams;
    };
    var $4a507624576c3047$export$2e2bcd8739ae039 = $4a507624576c3047$var$urlParamExtractor;
});
parcelRegister("4k2zk", function(module, exports) {
    $parcel$export(module.exports, "extract", ()=>$325b05cedc9c95fe$export$f9380c9a627682d3, (v)=>$325b05cedc9c95fe$export$f9380c9a627682d3 = v);
    $parcel$export(module.exports, "parse", ()=>$325b05cedc9c95fe$export$98e6a39c04603d36, (v)=>$325b05cedc9c95fe$export$98e6a39c04603d36 = v);
    $parcel$export(module.exports, "stringify", ()=>$325b05cedc9c95fe$export$fac44ee5b035f737, (v)=>$325b05cedc9c95fe$export$fac44ee5b035f737 = v);
    $parcel$export(module.exports, "parseUrl", ()=>$325b05cedc9c95fe$export$7a5253c0f62e0150, (v)=>$325b05cedc9c95fe$export$7a5253c0f62e0150 = v);
    $parcel$export(module.exports, "stringifyUrl", ()=>$325b05cedc9c95fe$export$a8c1621ea79325d3, (v)=>$325b05cedc9c95fe$export$a8c1621ea79325d3 = v);
    $parcel$export(module.exports, "pick", ()=>$325b05cedc9c95fe$export$357523c63a2253b9, (v)=>$325b05cedc9c95fe$export$357523c63a2253b9 = v);
    var $325b05cedc9c95fe$export$f9380c9a627682d3;
    var $325b05cedc9c95fe$export$98e6a39c04603d36;
    var $325b05cedc9c95fe$export$fac44ee5b035f737;
    var $325b05cedc9c95fe$export$7a5253c0f62e0150;
    var $325b05cedc9c95fe$export$a8c1621ea79325d3;
    var $325b05cedc9c95fe$export$357523c63a2253b9;
    var $325b05cedc9c95fe$export$44c361b8ec72ef7f;
    'use strict';
    var $hXDaG = parcelRequire("hXDaG");
    var $bJEvY = parcelRequire("bJEvY");
    var $9CHQr = parcelRequire("9CHQr");
    var $aARfw = parcelRequire("aARfw");
    const $325b05cedc9c95fe$var$isNullOrUndefined = (value)=>value === null || value === undefined;
    const $325b05cedc9c95fe$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
    function $325b05cedc9c95fe$var$encoderForArrayFormat(options) {
        switch(options.arrayFormat){
            case 'index':
                return (key)=>(result, value)=>{
                        const index = result.length;
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        if (value === null) return [
                            ...result,
                            [
                                $325b05cedc9c95fe$var$encode(key, options),
                                '[',
                                index,
                                ']'
                            ].join('')
                        ];
                        return [
                            ...result,
                            [
                                $325b05cedc9c95fe$var$encode(key, options),
                                '[',
                                $325b05cedc9c95fe$var$encode(index, options),
                                ']=',
                                $325b05cedc9c95fe$var$encode(value, options)
                            ].join('')
                        ];
                    };
            case 'bracket':
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        if (value === null) return [
                            ...result,
                            [
                                $325b05cedc9c95fe$var$encode(key, options),
                                '[]'
                            ].join('')
                        ];
                        return [
                            ...result,
                            [
                                $325b05cedc9c95fe$var$encode(key, options),
                                '[]=',
                                $325b05cedc9c95fe$var$encode(value, options)
                            ].join('')
                        ];
                    };
            case 'colon-list-separator':
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        if (value === null) return [
                            ...result,
                            [
                                $325b05cedc9c95fe$var$encode(key, options),
                                ':list='
                            ].join('')
                        ];
                        return [
                            ...result,
                            [
                                $325b05cedc9c95fe$var$encode(key, options),
                                ':list=',
                                $325b05cedc9c95fe$var$encode(value, options)
                            ].join('')
                        ];
                    };
            case 'comma':
            case 'separator':
            case 'bracket-separator':
                {
                    const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                    return (key)=>(result, value)=>{
                            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                            value = value === null ? '' : value;
                            if (result.length === 0) return [
                                [
                                    $325b05cedc9c95fe$var$encode(key, options),
                                    keyValueSep,
                                    $325b05cedc9c95fe$var$encode(value, options)
                                ].join('')
                            ];
                            return [
                                [
                                    result,
                                    $325b05cedc9c95fe$var$encode(value, options)
                                ].join(options.arrayFormatSeparator)
                            ];
                        };
                }
            default:
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        if (value === null) return [
                            ...result,
                            $325b05cedc9c95fe$var$encode(key, options)
                        ];
                        return [
                            ...result,
                            [
                                $325b05cedc9c95fe$var$encode(key, options),
                                '=',
                                $325b05cedc9c95fe$var$encode(value, options)
                            ].join('')
                        ];
                    };
        }
    }
    function $325b05cedc9c95fe$var$parserForArrayFormat(options) {
        let result;
        switch(options.arrayFormat){
            case 'index':
                return (key, value, accumulator)=>{
                    result = /\[(\d*)\]$/.exec(key);
                    key = key.replace(/\[\d*\]$/, '');
                    if (!result) {
                        accumulator[key] = value;
                        return;
                    }
                    if (accumulator[key] === undefined) accumulator[key] = {};
                    accumulator[key][result[1]] = value;
                };
            case 'bracket':
                return (key, value, accumulator)=>{
                    result = /(\[\])$/.exec(key);
                    key = key.replace(/\[\]$/, '');
                    if (!result) {
                        accumulator[key] = value;
                        return;
                    }
                    if (accumulator[key] === undefined) {
                        accumulator[key] = [
                            value
                        ];
                        return;
                    }
                    accumulator[key] = [].concat(accumulator[key], value);
                };
            case 'colon-list-separator':
                return (key, value, accumulator)=>{
                    result = /(:list)$/.exec(key);
                    key = key.replace(/:list$/, '');
                    if (!result) {
                        accumulator[key] = value;
                        return;
                    }
                    if (accumulator[key] === undefined) {
                        accumulator[key] = [
                            value
                        ];
                        return;
                    }
                    accumulator[key] = [].concat(accumulator[key], value);
                };
            case 'comma':
            case 'separator':
                return (key, value, accumulator)=>{
                    const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                    const isEncodedArray = typeof value === 'string' && !isArray && $325b05cedc9c95fe$var$decode(value, options).includes(options.arrayFormatSeparator);
                    value = isEncodedArray ? $325b05cedc9c95fe$var$decode(value, options) : value;
                    const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$325b05cedc9c95fe$var$decode(item, options)) : value === null ? value : $325b05cedc9c95fe$var$decode(value, options);
                    accumulator[key] = newValue;
                };
            case 'bracket-separator':
                return (key, value, accumulator)=>{
                    const isArray = /(\[\])$/.test(key);
                    key = key.replace(/\[\]$/, '');
                    if (!isArray) {
                        accumulator[key] = value ? $325b05cedc9c95fe$var$decode(value, options) : value;
                        return;
                    }
                    const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$325b05cedc9c95fe$var$decode(item, options));
                    if (accumulator[key] === undefined) {
                        accumulator[key] = arrayValue;
                        return;
                    }
                    accumulator[key] = [].concat(accumulator[key], arrayValue);
                };
            default:
                return (key, value, accumulator)=>{
                    if (accumulator[key] === undefined) {
                        accumulator[key] = value;
                        return;
                    }
                    accumulator[key] = [].concat(accumulator[key], value);
                };
        }
    }
    function $325b05cedc9c95fe$var$validateArrayFormatSeparator(value) {
        if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
    }
    function $325b05cedc9c95fe$var$encode(value, options) {
        if (options.encode) return options.strict ? $hXDaG(value) : encodeURIComponent(value);
        return value;
    }
    function $325b05cedc9c95fe$var$decode(value, options) {
        if (options.decode) return $bJEvY(value);
        return value;
    }
    function $325b05cedc9c95fe$var$keysSorter(input) {
        if (Array.isArray(input)) return input.sort();
        if (typeof input === 'object') return $325b05cedc9c95fe$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
        return input;
    }
    function $325b05cedc9c95fe$var$removeHash(input) {
        const hashStart = input.indexOf('#');
        if (hashStart !== -1) input = input.slice(0, hashStart);
        return input;
    }
    function $325b05cedc9c95fe$var$getHash(url) {
        let hash = '';
        const hashStart = url.indexOf('#');
        if (hashStart !== -1) hash = url.slice(hashStart);
        return hash;
    }
    function $325b05cedc9c95fe$var$extract(input) {
        input = $325b05cedc9c95fe$var$removeHash(input);
        const queryStart = input.indexOf('?');
        if (queryStart === -1) return '';
        return input.slice(queryStart + 1);
    }
    function $325b05cedc9c95fe$var$parseValue(value, options) {
        if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
        else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
        return value;
    }
    function $325b05cedc9c95fe$var$parse(query, options) {
        options = Object.assign({
            decode: true,
            sort: true,
            arrayFormat: 'none',
            arrayFormatSeparator: ',',
            parseNumbers: false,
            parseBooleans: false
        }, options);
        $325b05cedc9c95fe$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
        const formatter = $325b05cedc9c95fe$var$parserForArrayFormat(options);
        const ret = Object.create(null);
        if (typeof query !== 'string') return ret;
        query = query.trim().replace(/^[?#&]/, '');
        if (!query) return ret;
        for (const param of query.split('&')){
            if (param === '') continue;
            let [key, value] = $9CHQr(options.decode ? param.replace(/\+/g, ' ') : param, '=');
            value = value === undefined ? null : [
                'comma',
                'separator',
                'bracket-separator'
            ].includes(options.arrayFormat) ? value : $325b05cedc9c95fe$var$decode(value, options);
            formatter($325b05cedc9c95fe$var$decode(key, options), value, ret);
        }
        for (const key of Object.keys(ret)){
            const value = ret[key];
            if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $325b05cedc9c95fe$var$parseValue(value[k], options);
            else ret[key] = $325b05cedc9c95fe$var$parseValue(value, options);
        }
        if (options.sort === false) return ret;
        return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
            const value = ret[key];
            if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) result[key] = $325b05cedc9c95fe$var$keysSorter(value);
            else result[key] = value;
            return result;
        }, Object.create(null));
    }
    $325b05cedc9c95fe$export$f9380c9a627682d3 = $325b05cedc9c95fe$var$extract;
    $325b05cedc9c95fe$export$98e6a39c04603d36 = $325b05cedc9c95fe$var$parse;
    $325b05cedc9c95fe$export$fac44ee5b035f737 = (object, options)=>{
        if (!object) return '';
        options = Object.assign({
            encode: true,
            strict: true,
            arrayFormat: 'none',
            arrayFormatSeparator: ','
        }, options);
        $325b05cedc9c95fe$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
        const shouldFilter = (key)=>options.skipNull && $325b05cedc9c95fe$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
        const formatter = $325b05cedc9c95fe$var$encoderForArrayFormat(options);
        const objectCopy = {};
        for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
        const keys = Object.keys(objectCopy);
        if (options.sort !== false) keys.sort(options.sort);
        return keys.map((key)=>{
            const value = object[key];
            if (value === undefined) return '';
            if (value === null) return $325b05cedc9c95fe$var$encode(key, options);
            if (Array.isArray(value)) {
                if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $325b05cedc9c95fe$var$encode(key, options) + '[]';
                return value.reduce(formatter(key), []).join('&');
            }
            return $325b05cedc9c95fe$var$encode(key, options) + '=' + $325b05cedc9c95fe$var$encode(value, options);
        }).filter((x)=>x.length > 0).join('&');
    };
    $325b05cedc9c95fe$export$7a5253c0f62e0150 = (url, options)=>{
        options = Object.assign({
            decode: true
        }, options);
        const [url_, hash] = $9CHQr(url, '#');
        return Object.assign({
            url: url_.split('?')[0] || '',
            query: $325b05cedc9c95fe$var$parse($325b05cedc9c95fe$var$extract(url), options)
        }, options && options.parseFragmentIdentifier && hash ? {
            fragmentIdentifier: $325b05cedc9c95fe$var$decode(hash, options)
        } : {});
    };
    $325b05cedc9c95fe$export$a8c1621ea79325d3 = (object, options)=>{
        options = Object.assign({
            encode: true,
            strict: true,
            [$325b05cedc9c95fe$var$encodeFragmentIdentifier]: true
        }, options);
        const url = $325b05cedc9c95fe$var$removeHash(object.url).split('?')[0] || '';
        const queryFromUrl = $325b05cedc9c95fe$export$f9380c9a627682d3(object.url);
        const parsedQueryFromUrl = $325b05cedc9c95fe$export$98e6a39c04603d36(queryFromUrl, {
            sort: false
        });
        const query = Object.assign(parsedQueryFromUrl, object.query);
        let queryString = $325b05cedc9c95fe$export$fac44ee5b035f737(query, options);
        if (queryString) queryString = `?${queryString}`;
        let hash = $325b05cedc9c95fe$var$getHash(object.url);
        if (object.fragmentIdentifier) hash = `#${options[$325b05cedc9c95fe$var$encodeFragmentIdentifier] ? $325b05cedc9c95fe$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
        return `${url}${queryString}${hash}`;
    };
    $325b05cedc9c95fe$export$357523c63a2253b9 = (input, filter, options)=>{
        options = Object.assign({
            parseFragmentIdentifier: true,
            [$325b05cedc9c95fe$var$encodeFragmentIdentifier]: false
        }, options);
        const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $325b05cedc9c95fe$export$7a5253c0f62e0150(input, options);
        return $325b05cedc9c95fe$export$a8c1621ea79325d3({
            url: url,
            query: $aARfw(query, filter),
            fragmentIdentifier: fragmentIdentifier
        }, options);
    };
    $325b05cedc9c95fe$export$44c361b8ec72ef7f = (input, filter, options)=>{
        const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
        return $325b05cedc9c95fe$export$357523c63a2253b9(input, exclusionFilter, options);
    };
});
parcelRegister("6LpTJ", function(module, exports) {
    $parcel$export(module.exports, "selectHost", ()=>$de055c1ccac096b8$export$18c0b81944902eae);
    var $1nBQ6 = parcelRequire("1nBQ6");
    const $de055c1ccac096b8$var$PROD_HOST = 'as.atlassian.com/api/v1';
    const $de055c1ccac096b8$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
    const $de055c1ccac096b8$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
    const $de055c1ccac096b8$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
    const $de055c1ccac096b8$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
    const $de055c1ccac096b8$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
    const $de055c1ccac096b8$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
    const $de055c1ccac096b8$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
    const $de055c1ccac096b8$var$STARGATE_PROXY_PATH = '/gateway/api/gasv3/api/v1';
    const $de055c1ccac096b8$var$handleFedRampStagingDirect = ()=>{
        return $de055c1ccac096b8$var$FEDRAMP_STAGING_HOST;
    };
    const $de055c1ccac096b8$var$handleFedRampStagingStargate = ()=>{
        return $de055c1ccac096b8$var$STARGATE_FEDRAMP_STAGING_HOST;
    };
    const $de055c1ccac096b8$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
        if (env === (0, $1nBQ6.envType).LOCAL || env === (0, $1nBQ6.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
        if (env === (0, $1nBQ6.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
        if (!useStargate) return env === (0, $1nBQ6.envType).PROD ? $de055c1ccac096b8$var$FEDRAMP_PROD_HOST : $de055c1ccac096b8$var$handleFedRampStagingDirect();
        if (useLegacyUrl) return env === (0, $1nBQ6.envType).PROD ? $de055c1ccac096b8$var$STARGATE_FEDRAMP_PROD_HOST : $de055c1ccac096b8$var$handleFedRampStagingStargate();
        return window.location.host + $de055c1ccac096b8$var$STARGATE_PROXY_PATH;
    };
    const $de055c1ccac096b8$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
        if (!useStargate) return env === (0, $1nBQ6.envType).PROD ? $de055c1ccac096b8$var$PROD_HOST : $de055c1ccac096b8$var$STAGING_HOST;
        if (useLegacyUrl) return env === (0, $1nBQ6.envType).PROD ? $de055c1ccac096b8$var$STARGATE_PROD_HOST : $de055c1ccac096b8$var$STARGATE_STAGING_HOST;
        return window.location.host + $de055c1ccac096b8$var$STARGATE_PROXY_PATH;
    };
    function $de055c1ccac096b8$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, envOverride: envOverride }) {
        if (perimeter === (0, $1nBQ6.perimeterType).FEDRAMP_MODERATE) return $de055c1ccac096b8$var$handleFedRampModerate({
            useStargate: useStargate,
            env: env,
            useLegacyUrl: useLegacyUrl,
            envOverride: envOverride
        });
        return $de055c1ccac096b8$var$handleCommercial({
            useStargate: useStargate,
            env: env,
            useLegacyUrl: useLegacyUrl
        });
    }
});
parcelRegister("2EcjH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$110b37ba41bcd958$export$2e2bcd8739ae039);
    var $2Q4NN = parcelRequire("2Q4NN");
    const $110b37ba41bcd958$var$SESSION_ID_STORAGE_KEY = 'session.id';
    const $110b37ba41bcd958$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
    const $110b37ba41bcd958$var$ONLY_NUMBERS_REGEX = /^\d+$/;
    const $110b37ba41bcd958$export$285f6bddd927a06d = 1800000;
    const $110b37ba41bcd958$export$a92e915d70316eb2 = 5000;
    const $110b37ba41bcd958$export$de43760b2dc10c19 = 0.9;
    const $110b37ba41bcd958$export$5702a91a6f42969f = ()=>{};
    class $110b37ba41bcd958$export$2e2bcd8739ae039 {
        constructor(options = {}){
            this._generateNewSessionId = ()=>{
                const newSessionId = Date.now().toString();
                this._safeLocalStorage.setItem($110b37ba41bcd958$var$SESSION_ID_STORAGE_KEY, newSessionId);
                this._onNewSessionStarted && this._onNewSessionStarted();
                return newSessionId;
            };
            this._updateSessionExpiry = ()=>{
                const expiry = Date.now() + this._sessionExpiryTime;
                this._safeLocalStorage.setItem($110b37ba41bcd958$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
                return expiry;
            };
            this._debouncedUpdateSessionExpiry = (currentExpiry)=>{
                const { _updateSessionExpiry: _updateSessionExpiry } = this;
                if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) return _updateSessionExpiry();
                else {
                    if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                    this._sessionExpiryDebounceTimer = setTimeout(()=>{
                        _updateSessionExpiry();
                    }, this._sessionExpiryDebounce);
                }
            };
            this._sessionExpiryTime = options.sessionExpiryTime || $110b37ba41bcd958$export$285f6bddd927a06d;
            this._sessionExpiryDebounce = options.sessionExpiryDebounce || $110b37ba41bcd958$export$a92e915d70316eb2;
            this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $110b37ba41bcd958$export$de43760b2dc10c19;
            this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $110b37ba41bcd958$export$5702a91a6f42969f;
            this._safeLocalStorage = new (0, $2Q4NN.default)();
        }
        getCurrentSessionId() {
            const sessionId = this._safeLocalStorage.getItem($110b37ba41bcd958$var$SESSION_ID_STORAGE_KEY);
            const sessionExpiry = parseInt(this._safeLocalStorage.getItem($110b37ba41bcd958$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
            this._debouncedUpdateSessionExpiry(sessionExpiry);
            if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
            if (!$110b37ba41bcd958$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
            return sessionId;
        }
    }
});
parcelRegister("9pIlK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f781708e8a7da530$export$2e2bcd8739ae039);
    var $8mau1 = parcelRequire("8mau1");
    var $59ji6 = parcelRequire("59ji6");
    class $f781708e8a7da530$export$2e2bcd8739ae039 extends (0, $59ji6.default) {
        constructor(options){
            let storageToUse;
            try {
                storageToUse = window.sessionStorage || (0, $8mau1.default);
            } catch (err) {
                storageToUse = (0, $8mau1.default);
            }
            super(storageToUse, options);
        }
    }
});
parcelRegister("8A3OQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2235cac9e22c2c20$export$2e2bcd8739ae039);
    var $dFBS3 = parcelRequire("dFBS3");
    var $9pIlK = parcelRequire("9pIlK");
    const $2235cac9e22c2c20$var$STORAGE_KEY = 'tab.id';
    class $2235cac9e22c2c20$export$2e2bcd8739ae039 {
        constructor(){
            this._generateNewTabId = ()=>{
                const newTabId = (0, ($parcel$interopDefault($dFBS3)))();
                this._safeSessionStorage.setItem($2235cac9e22c2c20$var$STORAGE_KEY, newTabId);
                return newTabId;
            };
            this._safeSessionStorage = new (0, $9pIlK.default)();
        }
        getCurrentTabId() {
            let tabId = this._safeSessionStorage.getItem($2235cac9e22c2c20$var$STORAGE_KEY);
            if (!tabId) tabId = this._generateNewTabId();
            return tabId;
        }
    }
});
parcelRegister("5KYdd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d56280abf6971a1a$export$2e2bcd8739ae039);
    var $4k2zk = parcelRequire("4k2zk");
    var $dFBS3 = parcelRequire("dFBS3");
    var $1nBQ6 = parcelRequire("1nBQ6");
    var $6jXwZ = parcelRequire("6jXwZ");
    var $9pIlK = parcelRequire("9pIlK");
    var $hQ0CZ = parcelRequire("hQ0CZ");
    const $d56280abf6971a1a$var$STORAGE_KEY = 'taskSessions';
    const $d56280abf6971a1a$var$INIT_KEY = 'taskSessionsInit';
    const $d56280abf6971a1a$var$AWC_PARAM_PREFIX = 'awc.';
    const $d56280abf6971a1a$var$TASK_SESSION_RELOAD_TIME = 3000;
    class $d56280abf6971a1a$export$2e2bcd8739ae039 {
        constructor(){
            this._taskSessionsNotRecentlyInitialised = (currentTimestamp)=>this._safeSessionStorage.getItem($d56280abf6971a1a$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($d56280abf6971a1a$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($d56280abf6971a1a$var$INIT_KEY) || '0', 10) < currentTimestamp - $d56280abf6971a1a$var$TASK_SESSION_RELOAD_TIME;
            this._removeTaskSessionPrefix = (_, taskSessionName)=>taskSessionName.split($d56280abf6971a1a$var$AWC_PARAM_PREFIX)[1];
            this._isTaskSessionQueryParam = (_, taskSessionName)=>taskSessionName.startsWith($d56280abf6971a1a$var$AWC_PARAM_PREFIX);
            this.getAllTaskSessions = ()=>{
                try {
                    return JSON.parse(this._safeSessionStorage.getItem($d56280abf6971a1a$var$STORAGE_KEY) || '');
                } catch (e) {
                    return {};
                }
            };
            this._writeToSessionStorage = (taskSessions)=>{
                try {
                    this._safeSessionStorage.setItem($d56280abf6971a1a$var$STORAGE_KEY, JSON.stringify(taskSessions));
                } catch (e) {}
            };
            this._appendTaskSessions = (newTaskSessions)=>{
                const currentState = this.getAllTaskSessions();
                const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
                this._writeToSessionStorage(newState);
            };
            this._safelyRemoveKey = (currentState, taskSessionName)=>{
                if (currentState === null) return {};
                delete currentState[taskSessionName];
                return currentState;
            };
            this.createTaskSession = (taskSessionName)=>{
                const taskSessionId = (0, ($parcel$interopDefault($dFBS3)))();
                const newTaskSessions = {};
                newTaskSessions[taskSessionName] = taskSessionId;
                this._appendTaskSessions(newTaskSessions);
                return taskSessionId;
            };
            this.createTaskSessionWithProvidedId = (taskSessionName, taskSessionId)=>{
                if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
                const newTaskSessions = {};
                newTaskSessions[taskSessionName] = taskSessionId;
                this._appendTaskSessions(newTaskSessions);
            };
            this.completeTaskSession = (taskSessionName)=>{
                const currentState = this.getAllTaskSessions();
                const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
                this._writeToSessionStorage(updatedState);
            };
            this.formatTaskSessionQueryString = ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
                const { url: url, query: query } = (0, $4k2zk.parseUrl)(uri);
                const currentState = this.getAllTaskSessions();
                const filteredTaskSessions = includedTaskSessions ? (0, $6jXwZ.pick)(currentState, includedTaskSessions) : (0, $6jXwZ.omit)(currentState, Object.values((0, $1nBQ6.originTracingType)));
                if (Object.keys(filteredTaskSessions).length === 0) return uri;
                const queryWithTaskSessions = {
                    ...(0, $6jXwZ.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$d56280abf6971a1a$var$AWC_PARAM_PREFIX + taskSessionName),
                    ...query
                };
                return `${url}?${(0, $4k2zk.stringify)(queryWithTaskSessions)}`;
            };
            this.stripQueryParameters = ()=>{
                const extractedTaskSessions = (0, $6jXwZ.mapKeys)((0, $hQ0CZ.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
                this._appendTaskSessions(extractedTaskSessions);
            };
            const currentTimestamp = Date.now();
            this._safeSessionStorage = new (0, $9pIlK.default)();
            try {
                if (this._taskSessionsNotRecentlyInitialised(currentTimestamp)) {
                    this._writeToSessionStorage({});
                    this._safeSessionStorage.setItem($d56280abf6971a1a$var$INIT_KEY, currentTimestamp.toString());
                }
            } catch (e) {}
        }
    }
});
parcelRegister("e9fcB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ac9c02deb377e2c$export$2e2bcd8739ae039);
    var $M2DFp = parcelRequire("M2DFp");
    var $hbQI0 = parcelRequire("hbQI0");
    const $2ac9c02deb377e2c$var$MAX_CACHE_SIZE = 100;
    const $2ac9c02deb377e2c$var$COOKIE_NAME = (0, $hbQI0.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
    const $2ac9c02deb377e2c$var$DEBUG_TAG = 'synthetic';
    const $2ac9c02deb377e2c$var$getDebugCookie = ()=>{
        try {
            return JSON.parse((0, ($parcel$interopDefault($M2DFp))).get($2ac9c02deb377e2c$var$COOKIE_NAME) || 'false');
        } catch (error) {
            (0, ($parcel$interopDefault($M2DFp))).remove($2ac9c02deb377e2c$var$COOKIE_NAME);
        }
        return false;
    };
    class $2ac9c02deb377e2c$var$TestingCache {
        constructor(){
            this._bind = ()=>{
                if (typeof window === 'undefined' || window.testAnalytics) return;
                window.testAnalytics = {
                    eventCache: [],
                    events: ()=>window.testAnalytics.eventCache,
                    clear: ()=>{
                        window.testAnalytics.eventCache = [];
                        try {
                            localStorage.removeItem('awc.ui.viewed.last.sent');
                            localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                            localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                            localStorage.removeItem('awc-local.ui.viewed.last.sent');
                        } catch (_error) {}
                    }
                };
            };
            this._cache = (event)=>{
                if (typeof window === 'undefined') return;
                if (window.testAnalytics.eventCache.length >= $2ac9c02deb377e2c$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
                window.testAnalytics.eventCache.push(event);
            };
            this._shouldCacheEvent = ()=>this._isDebugCookieEnabled;
            this.saveEvent = (event)=>{
                if (event && this._shouldCacheEvent()) {
                    if (!window.testAnalytics) this._bind();
                    if (event.tags instanceof Array) event.tags.push($2ac9c02deb377e2c$var$DEBUG_TAG);
                    else event.tags = [
                        $2ac9c02deb377e2c$var$DEBUG_TAG
                    ];
                    this._cache(event);
                }
            };
            this._isDebugCookieEnabled = $2ac9c02deb377e2c$var$getDebugCookie();
            if (this._isDebugCookieEnabled) this._bind();
        }
    }
    var $2ac9c02deb377e2c$export$2e2bcd8739ae039 = $2ac9c02deb377e2c$var$TestingCache;
});
parcelRegister("eBko8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$980229c9bd5a9a49$export$2e2bcd8739ae039);
    var $1nBQ6 = parcelRequire("1nBQ6");
    var $2Q4NN = parcelRequire("2Q4NN");
    const $980229c9bd5a9a49$var$DEFAULT_DELAY = 2000;
    const $980229c9bd5a9a49$var$DEFAULT_THROTTLE = 3600000;
    const $980229c9bd5a9a49$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
    class $980229c9bd5a9a49$export$2e2bcd8739ae039 {
        constructor(productInfo, getContext, onEvent, settings = {}){
            this.start = ()=>{
                this._startInterval();
                this._bindEventListeners();
            };
            this.stop = ()=>{
                this._stopInterval();
                this._unbindEventListeners();
            };
            this.resetTimers = ()=>{
                if (this._intervalId) {
                    this.stop();
                    this.start();
                }
            };
            this._bindEventListeners = ()=>{
                if (typeof window !== 'undefined') {
                    window.addEventListener('focus', this._focusListener);
                    window.addEventListener('blur', this._blurListener);
                }
            };
            this._unbindEventListeners = ()=>{
                if (typeof window !== 'undefined') {
                    window.removeEventListener('focus', this._focusListener);
                    window.removeEventListener('blur', this._blurListener);
                }
            };
            this._startInterval = ()=>{
                clearInterval(this._intervalId);
                this._intervalId = setInterval(this._handleInterval, this._delay);
            };
            this._stopInterval = ()=>{
                if (this._intervalId) {
                    clearInterval(this._intervalId);
                    this._intervalId = null;
                }
            };
            this._getProductKey = (product, subproduct)=>{
                let productKey = product;
                if (subproduct) productKey += `-${subproduct}`;
                return productKey;
            };
            this._getLastSentTimestamp = (productKey, tenantId, userId)=>{
                const json = this._parseLocalStorageData() || {};
                const u = json[userId] || {};
                const t = u[tenantId] || {};
                const p = t[productKey] || null;
                return p;
            };
            this._parseLocalStorageData = ()=>{
                const data = this._safeLocalStorage.getItem(this._storageKey);
                try {
                    return JSON.parse(data || '');
                } catch (error) {
                    this._safeLocalStorage.removeItem(this._storageKey);
                    return null;
                }
            };
            this._setLastSentTimestamp = (productKey, tenantId, userId)=>{
                const json = this._parseLocalStorageData() || {};
                const u = json[userId] || {};
                const t = u[tenantId] || {};
                t[productKey] = Date.now();
                u[tenantId] = t;
                json[userId] = u;
                this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
            };
            this._shouldSendEvent = (productKey, tenantIdType, tenantId, userId)=>{
                if (!document.hasFocus()) return false;
                if (tenantIdType !== (0, $1nBQ6.tenantType).NONE && !tenantId || !userId) return false;
                const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
                return sinceLastSent > this._throttle;
            };
            this._handleInterval = ()=>{
                const { embeddedProduct: embeddedProduct, ...context } = this._getContext();
                this._sendEvent(this._product, context);
                if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
            };
            this._sendEvent = (product, context, isEmbeddedProduct = false)=>{
                const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
                const productKey = this._getProductKey(product, subproduct);
                if (this._shouldSendEvent(productKey, tenantIdType, tenantId, userId)) {
                    this._setLastSentTimestamp(productKey, tenantId, userId);
                    const event = this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes);
                    this._onEvent(event);
                }
            };
            this._createEvent = (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes)=>{
                const event = {
                    product: product,
                    source: 'ui',
                    action: 'viewed',
                    actionSubject: 'ui',
                    attributes: extraAttributes
                };
                if (isEmbeddedProduct) {
                    event.subproduct = null;
                    event.version = null;
                    event.attributes = {
                        ...event.attributes,
                        embeddedInEnv: this._productInfo.env,
                        embeddedInProduct: this._productInfo.product,
                        embeddedInSubproduct: subproduct,
                        embeddedInVersion: this._productInfo.version,
                        embeddedInOrigin: this._productInfo.origin,
                        embeddedInPlatform: this._productInfo.platform
                    };
                }
                if (lastScreenEvent) event.attributes = {
                    ...event.attributes,
                    lastScreenEvent: {
                        name: lastScreenEvent.name,
                        attributes: lastScreenEvent.attributes
                    }
                };
                return event;
            };
            if (!productInfo) throw new Error('Missing productInfo');
            if (!productInfo.product) throw new Error('Missing productInfo.product');
            if (!getContext) throw new Error('Missing getContext callback');
            if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
            if (!onEvent) throw new Error('Missing onEvent callback');
            if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
            this._productInfo = productInfo;
            this._product = productInfo.product;
            this._getContext = getContext;
            this._onEvent = onEvent;
            this._delay = settings.delay || $980229c9bd5a9a49$var$DEFAULT_DELAY;
            this._throttle = settings.throttle || $980229c9bd5a9a49$var$DEFAULT_THROTTLE;
            this._storageKey = settings.storageKey || $980229c9bd5a9a49$var$DEFAULT_STORAGE_KEY;
            this._safeLocalStorage = new (0, $2Q4NN.default)({
                envPrefix: this._productInfo.env
            });
            this._focusListener = ()=>{
                this._startInterval();
            };
            this._blurListener = ()=>{
                this._stopInterval();
            };
        }
    }
});
parcelRegister("knSwe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$49d5d17c08704104$export$2e2bcd8739ae039);
    function $49d5d17c08704104$export$2e2bcd8739ae039(callback, event) {
        if (!callback || typeof callback !== 'function') return null;
        return ()=>{
            callback(event);
        };
    }
});
parcelRegister("8G3nl", function(module, exports) {
    $parcel$export(module.exports, "XIDPromise", ()=>$5bb0e465a8f8589a$export$fbe53bbbe682bcdd);
    var $8ffCJ = parcelRequire("8ffCJ");
    const $5bb0e465a8f8589a$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
        if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
            const timeoutPromise = ()=>{
                return new Promise((resolve)=>{
                    setTimeout(()=>resolve(()=>(0, $8ffCJ.createTimeoutXid)()), (0, $8ffCJ.XID_TIMEOUT));
                });
            };
            const xidPromise = ()=>{
                return xidPromiseFn().catch(()=>()=>(0, $8ffCJ.createUnknownXid)());
            };
            return Promise.race([
                xidPromise(),
                timeoutPromise()
            ]);
        }
        return undefined;
    };
});
parcelRegister("8ffCJ", function(module, exports) {
    $parcel$export(module.exports, "XID_TIMEOUT", ()=>$9928feb3a97ba79a$export$545bcbd53afabfa3);
    $parcel$export(module.exports, "createTimeoutXid", ()=>$9928feb3a97ba79a$export$af4087e36d63846);
    $parcel$export(module.exports, "createUnknownXid", ()=>$9928feb3a97ba79a$export$fa341d0c750d705b);
    var $577k4 = parcelRequire("577k4");
    const $9928feb3a97ba79a$export$545bcbd53afabfa3 = 5000;
    const $9928feb3a97ba79a$export$af4087e36d63846 = ()=>[
            {
                type: (0, $577k4.XIDItemType).XC,
                state: 'TIMEOUT'
            },
            {
                type: (0, $577k4.XIDItemType).UID,
                state: 'TIMEOUT'
            }
        ];
    const $9928feb3a97ba79a$export$fa341d0c750d705b = ()=>[
            {
                type: (0, $577k4.XIDItemType).XC,
                state: 'UNKNOWN'
            },
            {
                type: (0, $577k4.XIDItemType).UID,
                state: 'UNKNOWN'
            }
        ];
});
parcelRegister("577k4", function(module, exports) {
    $parcel$export(module.exports, "XIDItemType", ()=>$f19656eea5c92d1c$export$92ca0438bcb0d396);
    var $f19656eea5c92d1c$export$92ca0438bcb0d396;
    (function(XIDItemType) {
        XIDItemType["XC"] = "xc";
        XIDItemType["UID"] = "uid";
    })($f19656eea5c92d1c$export$92ca0438bcb0d396 || ($f19656eea5c92d1c$export$92ca0438bcb0d396 = {}));
    var $f19656eea5c92d1c$export$c9079017d1f5aab9;
    (function(XIDState) {
        XIDState["NEW"] = "NEW";
        XIDState["CHANGED"] = "CHANGED";
        XIDState["EXISTING"] = "EXISTING";
        XIDState["TIMEOUT"] = "TIMEOUT";
        XIDState["ERROR"] = "ERROR";
        XIDState["UNAVAILABLE"] = "UNAVAILABLE";
        XIDState["MALFORMED"] = "MALFORMED";
        XIDState["UNKNOWN"] = "UNKNOWN";
    })($f19656eea5c92d1c$export$c9079017d1f5aab9 || ($f19656eea5c92d1c$export$c9079017d1f5aab9 = {}));
});
parcelRegister("6NrWB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$79b4aa62784c7060$export$2e2bcd8739ae039);
    var $dFBS3 = parcelRequire("dFBS3");
    var $FM1hX = parcelRequire("FM1hX");
    var $9DKYC = parcelRequire("9DKYC");
    const $79b4aa62784c7060$var$packageVersion = "0.0.0-use.local";
    const $79b4aa62784c7060$var$originParamName = 'atlOrigin';
    const $79b4aa62784c7060$var$originVersioningAttributes = {
        originLibrary: `origin-tracing.js@${$79b4aa62784c7060$var$packageVersion}`
    };
    class $79b4aa62784c7060$export$2e2bcd8739ae039 {
        constructor({ id: id = $79b4aa62784c7060$export$2e2bcd8739ae039.generateId(), product: product, dangerouslySkipValidation: dangerouslySkipValidation = false }){
            this.id = id;
            this.product = product;
            if (!dangerouslySkipValidation) this.validate();
        }
        static isValidId(value) {
            return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,36}$/.test(value);
        }
        static isValidProduct(value) {
            return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,20}$/.test(value);
        }
        static generateId() {
            const id = (0, ($parcel$interopDefault($dFBS3)))();
            return id.replace(/-/g, '');
        }
        static createEmpty() {
            return new $79b4aa62784c7060$var$EmptyOriginTracer();
        }
        static createMalformed() {
            return new $79b4aa62784c7060$var$MalformedOriginTracer();
        }
        static fromUrl(url) {
            let params = new ((0, $9DKYC.getEnv)()).URLSearchParams();
            $79b4aa62784c7060$var$replaceQuery(url, (queryString)=>{
                params = new ((0, $9DKYC.getEnv)()).URLSearchParams(queryString);
            });
            return $79b4aa62784c7060$export$2e2bcd8739ae039.fromEncoded(params.get($79b4aa62784c7060$var$originParamName));
        }
        static fromEncoded(encoded) {
            if (!encoded) return $79b4aa62784c7060$export$2e2bcd8739ae039.createEmpty();
            try {
                return $79b4aa62784c7060$export$2e2bcd8739ae039.decode(encoded);
            } catch (e) {
                return $79b4aa62784c7060$export$2e2bcd8739ae039.createMalformed();
            }
        }
        static removeFromUrl(url) {
            return $79b4aa62784c7060$var$replaceQuery(url, (queryString)=>{
                const params = new ((0, $9DKYC.getEnv)()).URLSearchParams(queryString);
                params.delete($79b4aa62784c7060$var$originParamName);
                return params.toString();
            });
        }
        static decode(encodedOrigin) {
            const originData = (0, $FM1hX.decode)(encodedOrigin);
            return new $79b4aa62784c7060$export$2e2bcd8739ae039(originData);
        }
        encode() {
            return (0, $FM1hX.encode)({
                id: this.id,
                product: this.product
            });
        }
        addToUrl(url) {
            return $79b4aa62784c7060$var$replaceQuery(url, (originalQueryString)=>{
                const params = new ((0, $9DKYC.getEnv)()).URLSearchParams(originalQueryString);
                params.set($79b4aa62784c7060$var$originParamName, this.encode());
                return params.toString();
            });
        }
        isEmpty() {
            return false;
        }
        isMalformed() {
            return !this.isEmpty() && !this.isValid();
        }
        isValid() {
            return true;
        }
        toAnalyticsAttributes({ transformValue: transformValue = (v)=>v === null ? undefined : v, hasGeneratedId: hasGeneratedId = false } = {}) {
            const originIdProp = hasGeneratedId ? 'originIdGenerated' : 'originId';
            return {
                [originIdProp]: transformValue(this.id),
                originProduct: transformValue(this.product),
                ...$79b4aa62784c7060$var$originVersioningAttributes
            };
        }
        validate() {
            if (!$79b4aa62784c7060$export$2e2bcd8739ae039.isValidId(this.id)) throw new TypeError('Invalid Origin id');
            if (!$79b4aa62784c7060$export$2e2bcd8739ae039.isValidProduct(this.product)) throw new TypeError('Missing/invalid Origin product');
        }
    }
    class $79b4aa62784c7060$var$EmptyOriginTracer extends $79b4aa62784c7060$export$2e2bcd8739ae039 {
        constructor(){
            super({
                id: null,
                product: null,
                dangerouslySkipValidation: true
            });
        }
        isValid() {
            return false;
        }
        isEmpty() {
            return true;
        }
        toAnalyticsAttributes() {
            return {
                ...$79b4aa62784c7060$var$originVersioningAttributes
            };
        }
    }
    class $79b4aa62784c7060$var$MalformedOriginTracer extends $79b4aa62784c7060$export$2e2bcd8739ae039 {
        constructor(){
            super({
                id: null,
                product: null,
                dangerouslySkipValidation: true
            });
        }
        isValid() {
            return false;
        }
        isEmpty() {
            return false;
        }
        toAnalyticsAttributes() {
            return {
                originMalformed: true,
                ...$79b4aa62784c7060$var$originVersioningAttributes
            };
        }
    }
    function $79b4aa62784c7060$var$replaceQuery(url, replacer) {
        const urlWithQueryStringRegex = /(^[^?#]*)(?:\?)?([^#]*?)(#.*|$)$/;
        const urlString = String(url);
        return urlString.replace(urlWithQueryStringRegex, (_wholeMatch, beforeQuery, queryString, afterQuery)=>{
            let newQueryString = replacer(queryString);
            if (newQueryString) newQueryString = `?${newQueryString}`;
            return `${beforeQuery}${newQueryString}${afterQuery}`;
        });
    }
});
parcelRegister("FM1hX", function(module, exports) {
    $parcel$export(module.exports, "encode", ()=>$5c3d1af570572345$export$c564cdbbe6da493);
    $parcel$export(module.exports, "decode", ()=>$5c3d1af570572345$export$2f872c0f2117be69);
    var $f6rdV = parcelRequire("f6rdV");
    var $9DKYC = parcelRequire("9DKYC");
    const $5c3d1af570572345$var$productShorthands = {
        confluence: 'c',
        jira: 'j',
        stride: 's',
        bitbucket: 'b',
        trello: 't'
    };
    function $5c3d1af570572345$export$c564cdbbe6da493(originData) {
        const json = JSON.stringify($5c3d1af570572345$export$4bc4b533a565aabe(originData));
        const base64 = (0, $9DKYC.getEnv)().btoa(json);
        return (0, $f6rdV.base64ToBase64Url)(base64);
    }
    function $5c3d1af570572345$export$2f872c0f2117be69(encodedOriginString) {
        const base64 = (0, $f6rdV.base64UrlToBase64)(encodedOriginString);
        const json = (0, $9DKYC.getEnv)().atob(base64);
        return $5c3d1af570572345$export$46d5cda6b884b7ab(JSON.parse(json));
    }
    function $5c3d1af570572345$export$4bc4b533a565aabe({ id: id, product: product }) {
        return {
            i: id,
            p: product && product in $5c3d1af570572345$var$productShorthands ? $5c3d1af570572345$var$productShorthands[product] : product
        };
    }
    function $5c3d1af570572345$export$46d5cda6b884b7ab(originJSONObject) {
        const originData = {};
        if (originJSONObject.i) originData.id = originJSONObject.i;
        if (originJSONObject.p) originData.product = $5c3d1af570572345$var$expandProductShorthand(originJSONObject.p);
        return originData;
    }
    function $5c3d1af570572345$var$expandProductShorthand(maybeShorthand) {
        const products = Object.keys($5c3d1af570572345$var$productShorthands);
        for(let i = 0; i < products.length; i++){
            const product = products[i];
            const shorthand = $5c3d1af570572345$var$productShorthands[product];
            if (maybeShorthand === shorthand) return product;
        }
        return maybeShorthand;
    }
});
parcelRegister("f6rdV", function(module, exports) {
    $parcel$export(module.exports, "base64ToBase64Url", ()=>$6d33bac58d495161$export$3b91e21dac1023c6);
    $parcel$export(module.exports, "base64UrlToBase64", ()=>$6d33bac58d495161$export$47c5265a25535d02);
    function $6d33bac58d495161$export$3b91e21dac1023c6(base64) {
        if (base64 == null) return '';
        return String(base64).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    }
    function $6d33bac58d495161$export$47c5265a25535d02(base64url) {
        if (base64url == null) return '';
        const base64 = String(base64url).replace(/-/g, '+').replace(/_/g, '/');
        const padLength = (4 - base64url.length % 4) % 4;
        const pad = '==='.slice(0, padLength);
        return base64 + pad;
    }
});
parcelRegister("9DKYC", function(module, exports) {
    $parcel$export(module.exports, "getEnv", ()=>$be751784dd4f8879$export$4bd44a2aa29d3d6e);
    var $aul3P = parcelRequire("aul3P");
    const $be751784dd4f8879$export$d3cd91e0fdbfdbc0 = ()=>({
            atob: typeof atob === 'function' && atob.bind(undefined) || typeof (0, $aul3P.Buffer) !== 'undefined' && ((encoded)=>(0, $aul3P.Buffer).from(encoded, 'base64').toString()),
            btoa: typeof btoa === 'function' && btoa.bind(undefined) || typeof (0, $aul3P.Buffer) !== 'undefined' && ((str)=>(0, $aul3P.Buffer).from(str).toString('base64')),
            URLSearchParams: typeof URLSearchParams === 'function' && URLSearchParams || (0, (parcelRequire("78Ywx")).URLSearchParams)
        });
    let $be751784dd4f8879$var$env;
    const $be751784dd4f8879$export$4bd44a2aa29d3d6e = ()=>$be751784dd4f8879$var$env || ($be751784dd4f8879$var$env = $be751784dd4f8879$var$validateEnv($be751784dd4f8879$export$d3cd91e0fdbfdbc0()));
    const $be751784dd4f8879$var$validateEnv = (env)=>{
        if (!(env.atob && env.btoa && env.URLSearchParams)) throw new TypeError(`Origin-Tracing: missing environment APIs. Required: btoa(), atob(), URLSearchParams() (or in Node: Buffer, require('url').URLSearchParams).`);
        return env;
    };
});
parcelRegister("kW7h5", function(module, exports) {
    $parcel$export(module.exports, "canCompress", ()=>$86a14cd6f3d412d6$export$ec3662f84d9f778c);
    $parcel$export(module.exports, "buildCompressionFunction", ()=>$86a14cd6f3d412d6$export$20de0576abb0bcc5);
    const $86a14cd6f3d412d6$export$ec3662f84d9f778c = (event)=>event.actionSubject === 'feature' && event.action === 'exposed' && event.eventType === 'operational' && event.attributes && event.tags && event.tags.includes('measurement') && !event.tags.includes('hasCustomAttributes');
    const $86a14cd6f3d412d6$export$ca25d5d7792a4f37 = (events, batchSize = 50)=>{
        if (!events || events.length <= 0) return [];
        if (batchSize <= 0) throw new Error('Batch size must be greater than 0');
        const flagEvaluations = events.map((currentEvent)=>{
            const { flagKey: flagKey, value: value, reason: reason, ruleId: ruleId, errorKind: errorKind } = currentEvent.attributes;
            return {
                key: flagKey,
                value: value,
                ...reason && {
                    reason: reason
                },
                ...ruleId && {
                    ruleId: ruleId
                },
                ...errorKind && {
                    errorKind: errorKind
                }
            };
        });
        return $86a14cd6f3d412d6$var$createBatches(flagEvaluations, batchSize);
    };
    const $86a14cd6f3d412d6$var$createBatches = (array, batchSize)=>{
        let compressedEvaluations = [];
        for(let i = 0; i < array.length; i += batchSize){
            let evaluationBatch = array.slice(i, i + batchSize);
            compressedEvaluations.push({
                actionSubject: 'features',
                action: 'exposed',
                eventType: 'operational',
                attributes: {
                    evaluations: evaluationBatch
                },
                tags: [
                    'measurement'
                ],
                source: '@atlassian/exposure-events-compressor'
            });
        }
        return compressedEvaluations;
    };
    const $86a14cd6f3d412d6$export$20de0576abb0bcc5 = (batchSize)=>(events)=>$86a14cd6f3d412d6$export$ca25d5d7792a4f37(events, batchSize);
});
parcelRegister("i5FOB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$abe9b155dae519ad$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $iQC4h = parcelRequire("iQC4h");
    var $cmup6 = parcelRequire("cmup6");
    var $ac3Dv = parcelRequire("ac3Dv");
    var $kUO48 = parcelRequire("kUO48");
    const $abe9b155dae519ad$var$EngagementProviderWithEvents = (0, $iQC4h.default)()((0, $kUO48.EngagementProvider));
    const $abe9b155dae519ad$var$EngagementProviderWithDefaultStore = (props)=>{
        return (0, ($parcel$interopDefault($eUqFw))).createElement($abe9b155dae519ad$var$EngagementProviderWithEvents, {
            ...props,
            store: (0, $ac3Dv.default)(props.config)
        });
    };
    var $abe9b155dae519ad$export$2e2bcd8739ae039 = (0, $cmup6.default)($abe9b155dae519ad$var$EngagementProviderWithDefaultStore);
});
parcelRegister("cmup6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$002d78b1a2b2d388$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    function $002d78b1a2b2d388$export$2e2bcd8739ae039(Component) {
        const PreventNestedInstancesContext = (0, ($parcel$interopDefault($eUqFw))).createContext(false);
        return function PreventNestedInstances(props) {
            return ((0, ($parcel$interopDefault($eUqFw))).createElement(PreventNestedInstancesContext.Consumer, null, (shouldPreventInstantiation)=>shouldPreventInstantiation ? props.children : (0, ($parcel$interopDefault($eUqFw))).createElement(PreventNestedInstancesContext.Provider, {
                    value: true
                }, (0, ($parcel$interopDefault($eUqFw))).createElement(Component, props))));
        };
    }
});
parcelRegister("ac3Dv", function(module, exports) {
    $parcel$export(module.exports, "store", ()=>$7c76ba0b9abf72f7$export$6f57813fe9f31bf9);
    $parcel$export(module.exports, "default", ()=>$7c76ba0b9abf72f7$export$2e2bcd8739ae039);
    var $hTLlD = parcelRequire("hTLlD");
    var $huRi7 = parcelRequire("huRi7");
    var $fhqUC = parcelRequire("fhqUC");
    var $jBXeU = parcelRequire("jBXeU");
    var $4Dcsc = parcelRequire("4Dcsc");
    var $dPFF6 = parcelRequire("dPFF6");
    const $7c76ba0b9abf72f7$export$36d128238e6b60f5 = {
        messageMapping: new Map(),
        current: null,
        initialized: false,
        initializing: false,
        config: {
            cloudId: '',
            aaid: '',
            locale: '',
            product: '',
            stargateUrl: '',
            orgId: '',
            workspaceId: ''
        }
    };
    let $7c76ba0b9abf72f7$var$processMessagesCancellationToken = (0, $fhqUC.createCancellationToken)();
    function $7c76ba0b9abf72f7$export$7a10f46f72407bc5(messageMapping, component) {
        const newMapping = new Map();
        messageMapping.forEach((value, key)=>{
            if (!(0, ($parcel$interopDefault($hTLlD)))(value.component, component)) newMapping.set(key, value);
        });
        return newMapping;
    }
    const $7c76ba0b9abf72f7$export$6f57813fe9f31bf9 = (0, $huRi7.createStore)((state = $7c76ba0b9abf72f7$export$36d128238e6b60f5, action)=>{
        switch(action.type){
            case 0, $4Dcsc.SET_MESSAGE_MAPPING:
                return {
                    ...state,
                    initialized: true,
                    initializing: false,
                    messageMapping: action.messageMapping
                };
            case 0, $4Dcsc.SET_INITIALIZING:
                return {
                    ...state,
                    config: action.config,
                    initializing: true
                };
            case 0, $4Dcsc.SET_CURRENT:
                {
                    const { eventMapping: eventMapping } = action;
                    const { message: message, component: component } = eventMapping;
                    const messageMapping = $7c76ba0b9abf72f7$export$7a10f46f72407bc5(state.messageMapping, component);
                    return {
                        ...state,
                        current: {
                            messageId: message.messageId,
                            variationId: message.variationId,
                            ...component
                        },
                        messageMapping: messageMapping
                    };
                }
            case 0, $4Dcsc.CLEAR_CURRENT:
                return {
                    ...state,
                    current: null
                };
            case 0, $4Dcsc.RESET_STORE:
                return $7c76ba0b9abf72f7$export$36d128238e6b60f5;
            default:
                return state;
        }
    });
    var $7c76ba0b9abf72f7$export$2e2bcd8739ae039 = (config)=>{
        const state = $7c76ba0b9abf72f7$export$6f57813fe9f31bf9.getState();
        if (state.initializing || state.initialized) {
            if (state.config.cloudId === config.cloudId) return $7c76ba0b9abf72f7$export$6f57813fe9f31bf9;
            $7c76ba0b9abf72f7$var$processMessagesCancellationToken.isCancelled = true;
            $7c76ba0b9abf72f7$var$processMessagesCancellationToken = (0, $fhqUC.createCancellationToken)();
            $7c76ba0b9abf72f7$export$6f57813fe9f31bf9.dispatch((0, $4Dcsc.resetStore)());
        }
        const newConfig = {
            ...config
        };
        newConfig.locale = newConfig.locale.replace('_', '-');
        $7c76ba0b9abf72f7$export$6f57813fe9f31bf9.dispatch((0, $4Dcsc.initialize)(newConfig));
        if ((0, $jBXeU.isMessagingEnabled)()) (0, $dPFF6.processMessages)($7c76ba0b9abf72f7$export$6f57813fe9f31bf9, newConfig, $7c76ba0b9abf72f7$var$processMessagesCancellationToken);
        return $7c76ba0b9abf72f7$export$6f57813fe9f31bf9;
    };
});
parcelRegister("fhqUC", function(module, exports) {
    $parcel$export(module.exports, "createCancellationToken", ()=>$ed58f63ea58b190e$export$eac027797b968991);
    function $ed58f63ea58b190e$export$eac027797b968991(isCancelled = false) {
        return {
            isCancelled: isCancelled
        };
    }
});
parcelRegister("jBXeU", function(module, exports) {
    $parcel$export(module.exports, "isMessagingEnabled", ()=>$c32f1b209988fcfe$export$a77934ac158768dd);
    var $atsKT = parcelRequire("atsKT");
    function $c32f1b209988fcfe$export$a77934ac158768dd() {
        return !(0, $atsKT.isFedRamp)();
    }
});
parcelRegister("4Dcsc", function(module, exports) {
    $parcel$export(module.exports, "SET_MESSAGE_MAPPING", ()=>$944d5ff326220746$export$d05fe3e897340c89);
    $parcel$export(module.exports, "SET_INITIALIZING", ()=>$944d5ff326220746$export$eacd3ec165715d8);
    $parcel$export(module.exports, "RESET_STORE", ()=>$944d5ff326220746$export$874c5149d7f0e3b8);
    $parcel$export(module.exports, "CLEAR_CURRENT", ()=>$944d5ff326220746$export$cb5041d68cb18859);
    $parcel$export(module.exports, "SET_CURRENT", ()=>$944d5ff326220746$export$a9319af002a4c677);
    $parcel$export(module.exports, "resetStore", ()=>$944d5ff326220746$export$a20a1205b2a2b7e4);
    $parcel$export(module.exports, "initialize", ()=>$944d5ff326220746$export$2a47f398eeff8b01);
    $parcel$export(module.exports, "setMessageMapping", ()=>$944d5ff326220746$export$375dd0a76fecd4c7);
    $parcel$export(module.exports, "setCurrent", ()=>$944d5ff326220746$export$5f80f094fd31fffd);
    $parcel$export(module.exports, "clearCurrent", ()=>$944d5ff326220746$export$96105f873ade39d7);
    const $944d5ff326220746$export$d05fe3e897340c89 = 'SET_MESSAGE_MAPPING';
    const $944d5ff326220746$export$eacd3ec165715d8 = 'SET_INITIALIZING';
    const $944d5ff326220746$export$874c5149d7f0e3b8 = 'RESET_STORE';
    const $944d5ff326220746$export$cb5041d68cb18859 = 'CLEAR_CURRENT';
    const $944d5ff326220746$export$a9319af002a4c677 = 'SET_CURRENT';
    const $944d5ff326220746$export$a20a1205b2a2b7e4 = ()=>({
            type: $944d5ff326220746$export$874c5149d7f0e3b8
        });
    const $944d5ff326220746$export$2a47f398eeff8b01 = (config)=>({
            type: $944d5ff326220746$export$eacd3ec165715d8,
            config: config
        });
    const $944d5ff326220746$export$375dd0a76fecd4c7 = (messageMapping)=>({
            type: $944d5ff326220746$export$d05fe3e897340c89,
            messageMapping: messageMapping
        });
    function $944d5ff326220746$export$5f80f094fd31fffd(eventMapping) {
        return {
            type: $944d5ff326220746$export$a9319af002a4c677,
            eventMapping: eventMapping
        };
    }
    function $944d5ff326220746$export$96105f873ade39d7() {
        return {
            type: $944d5ff326220746$export$cb5041d68cb18859
        };
    }
});
parcelRegister("dPFF6", function(module, exports) {
    $parcel$export(module.exports, "processMessages", ()=>$8ce18d6e73bf4de5$export$d2e92820f98a2592);
    var $i7Llh = parcelRequire("i7Llh");
    var $4Dcsc = parcelRequire("4Dcsc");
    var $ac3Dv = parcelRequire("ac3Dv");
    const $8ce18d6e73bf4de5$export$a9d4ce3abb5d2365 = (messages)=>{
        const mapping = new Map();
        messages.forEach((message)=>{
            const components = message.components;
            components.forEach((component, index)=>{
                component.triggers.forEach((trigger)=>{
                    mapping.set(trigger, {
                        message: message,
                        component: {
                            componentId: index,
                            isLast: index === components.length - 1,
                            ...component
                        }
                    });
                });
            });
        });
        return mapping;
    };
    async function $8ce18d6e73bf4de5$export$d2e92820f98a2592(engagementStore, config, cancellationToken) {
        if (cancellationToken.isCancelled) return;
        const state = (0, $ac3Dv.store).getState();
        const { cloudId: cloudId, stargateUrl: stargateUrl, product: product, locale: locale } = config;
        let messages, interval;
        try {
            const results = await (0, $i7Llh.getMessages)(cloudId, stargateUrl, product, locale);
            if (cancellationToken.isCancelled) return;
            messages = results.messages;
            interval = results.interval;
        } catch (e) {
            return;
        }
        if (state.current === null) {
            const messageMapping = $8ce18d6e73bf4de5$export$a9d4ce3abb5d2365(messages);
            engagementStore.dispatch((0, $4Dcsc.setMessageMapping)(messageMapping));
        }
        if (interval !== 0) setTimeout(()=>{
            $8ce18d6e73bf4de5$export$d2e92820f98a2592(engagementStore, config, cancellationToken);
        }, interval * 1000);
    }
});
parcelRegister("i7Llh", function(module, exports) {
    $parcel$export(module.exports, "getMessages", ()=>$cd3120149da0736f$export$8c20ab16ac9cf14f);
    $parcel$export(module.exports, "startMessage", ()=>$cd3120149da0736f$export$7a77c9a7b182680b);
    $parcel$export(module.exports, "stopMessage", ()=>$cd3120149da0736f$export$159ff839f1f095d2);
    $parcel$export(module.exports, "sendUserResponse", ()=>$cd3120149da0736f$export$e1fd1449cf83c1f5);
    $parcel$export(module.exports, "markAsSeenAndFatigued", ()=>$cd3120149da0736f$export$3683393f780c6905);
    var $asbhz = parcelRequire("asbhz");
    var $kE2z1 = parcelRequire("kE2z1");
    var $5LHs9 = parcelRequire("5LHs9");
    const $cd3120149da0736f$export$f4d1b02d312560f5 = '2';
    const $cd3120149da0736f$var$inProductMessagesUrlTemplate = (0, ($parcel$interopDefault($asbhz))).parse('/engage-targeting/api/v2/user/{cloudId}/in-product-messages{?product,schema,locale}');
    async function $cd3120149da0736f$export$8c20ab16ac9cf14f(cloudId, stargateUrl, product, locale) {
        return (0, $5LHs9.stargateFetchRetryOn5xx)(`${stargateUrl}${$cd3120149da0736f$var$inProductMessagesUrlTemplate.expand({
            cloudId: cloudId,
            product: product,
            schema: $cd3120149da0736f$export$f4d1b02d312560f5,
            locale: locale
        })}`).then((0, $5LHs9.errorIfNotOk)).then((r)=>r.json().then((messages)=>({
                    messages: messages,
                    interval: Number.parseFloat(r.headers.get('POLL-INTERVAL') || '0')
                })));
    }
    function $cd3120149da0736f$var$handleStartStopMessageResponse(response) {
        return response.status === (0, $3181f97da209d060$export$3288b14b6745c572);
    }
    const $cd3120149da0736f$var$startMessageUrlTemplate = (0, ($parcel$interopDefault($asbhz))).parse('/engage-targeting/api/v2/user/messages/{messageId}/start');
    const $cd3120149da0736f$var$startMessageWithVariationIdUrlTemplate = (0, ($parcel$interopDefault($asbhz))).parse('/engage-targeting/api/v2/user/messages/{messageId}/start/{variationId}');
    const $cd3120149da0736f$var$stopMessageUrlTemplate = (0, ($parcel$interopDefault($asbhz))).parse('/engage-targeting/api/v2/user/messages/{messageId}/stop');
    var $cd3120149da0736f$export$56ac8ebc9870b1b9;
    (function(envType) {
        envType["LOCAL"] = "local";
        envType["DEV"] = "dev";
        envType["STAGING"] = "staging";
        envType["PROD"] = "prod";
    })($cd3120149da0736f$export$56ac8ebc9870b1b9 || ($cd3120149da0736f$export$56ac8ebc9870b1b9 = {}));
    let $cd3120149da0736f$var$choreographerPlugin;
    async function $cd3120149da0736f$export$7a77c9a7b182680b(startMessageConfig, options) {
        if (options?.enableChoreographer) return $cd3120149da0736f$var$startMessageWithChoreographer(startMessageConfig, options);
        return $cd3120149da0736f$var$startMessageWithCoordination(startMessageConfig);
    }
    async function $cd3120149da0736f$export$159ff839f1f095d2(stopMessageConfig, options) {
        if (options?.enableChoreographer) return $cd3120149da0736f$var$stopMessageWithChoreographer(stopMessageConfig, options);
        return $cd3120149da0736f$var$stopMessageWithCoordination(stopMessageConfig);
    }
    async function $cd3120149da0736f$var$startMessageWithChoreographer(startMessageConfig, options) {
        if (!$cd3120149da0736f$var$choreographerPlugin) $cd3120149da0736f$var$choreographerPlugin = new (0, $kE2z1.EngagekitChoreographerPlugin)(options.envType ?? "local");
        return $cd3120149da0736f$var$choreographerPlugin.startMessageWithPlugin(startMessageConfig.messageId, ()=>$cd3120149da0736f$var$startMessageWithCoordination(startMessageConfig, true), options.additionalData);
    }
    async function $cd3120149da0736f$var$stopMessageWithChoreographer(stopMessageConfig, options) {
        if (!$cd3120149da0736f$var$choreographerPlugin) $cd3120149da0736f$var$choreographerPlugin = new (0, $kE2z1.EngagekitChoreographerPlugin)(options.envType ?? "local");
        return $cd3120149da0736f$var$choreographerPlugin.stopMessageWithPlugin(stopMessageConfig.messageId, ()=>$cd3120149da0736f$var$stopMessageWithCoordination(stopMessageConfig, true), options.additionalData);
    }
    async function $cd3120149da0736f$var$startMessageWithCoordination(startMessageConfig, choreographerEnabled = false) {
        const requestBody = {
            cloudId: startMessageConfig.cloudId,
            orgId: startMessageConfig.orgId,
            workspaceId: startMessageConfig.workspaceId,
            choreographerEnabled: choreographerEnabled
        };
        return (0, $5LHs9.stargateFetchRetryOn5xx)(startMessageConfig.variationId ? `${startMessageConfig.stargateUrl}${$cd3120149da0736f$var$startMessageWithVariationIdUrlTemplate.expand({
            messageId: startMessageConfig.messageId,
            variationId: startMessageConfig.variationId
        })}` : `${startMessageConfig.stargateUrl}${$cd3120149da0736f$var$startMessageUrlTemplate.expand({
            messageId: startMessageConfig.messageId
        })}`, {
            method: 'post',
            body: JSON.stringify(requestBody),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((0, $5LHs9.pullResponseTextIfNotOk)).then($cd3120149da0736f$var$handleStartStopMessageResponse);
    }
    async function $cd3120149da0736f$var$stopMessageWithCoordination(stopMessageConfig, choreographerEnabled = false) {
        const requestBody = {
            cloudId: stopMessageConfig.cloudId,
            orgId: stopMessageConfig.orgId,
            workspaceId: stopMessageConfig.workspaceId,
            choreographerEnabled: choreographerEnabled
        };
        return (0, $5LHs9.stargateFetchRetryOn5xx)(`${stopMessageConfig.stargateUrl}${$cd3120149da0736f$var$stopMessageUrlTemplate.expand({
            messageId: stopMessageConfig.messageId
        })}`, {
            method: 'post',
            body: JSON.stringify(requestBody),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((0, $5LHs9.pullResponseTextIfNotOk)).then($cd3120149da0736f$var$handleStartStopMessageResponse);
    }
    const $cd3120149da0736f$var$userResponseUrlTemplate = (0, ($parcel$interopDefault($asbhz))).parse('/engage-targeting/api/v2/user/{cloudId}/messages/{messageId}/response');
    async function $cd3120149da0736f$export$e1fd1449cf83c1f5(cloudId, stargateUrl, messageId, payload) {
        return (0, $5LHs9.stargateFetchRetryOn5xx)(`${stargateUrl}${$cd3120149da0736f$var$userResponseUrlTemplate.expand({
            cloudId: cloudId,
            messageId: messageId
        })}`, {
            method: 'post',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((0, $5LHs9.pullResponseTextIfNotOk)).then(()=>Promise.resolve());
    }
    const $cd3120149da0736f$var$markSeenAndFatigueUrlTemplate = (0, ($parcel$interopDefault($asbhz))).parse('/engage-targeting/api/v2/user/messages/{messageId}/seen');
    async function $cd3120149da0736f$export$3683393f780c6905(seenMessageConfig) {
        const requestBody = {
            cloudId: seenMessageConfig.cloudId,
            orgId: seenMessageConfig.orgId,
            workspaceId: seenMessageConfig.workspaceId
        };
        return (0, $5LHs9.stargateFetchRetryOn5xx)(`${seenMessageConfig.stargateUrl}${$cd3120149da0736f$var$markSeenAndFatigueUrlTemplate.expand({
            messageId: seenMessageConfig.messageId
        })}`, {
            method: 'post',
            body: JSON.stringify(requestBody),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((0, $5LHs9.pullResponseTextIfNotOk)).then(()=>Promise.resolve());
    }
});
parcelRegister("kE2z1", function(module, exports) {
    $parcel$export(module.exports, "EngagekitChoreographerPlugin", ()=>$3ed9d240dba3b00f$export$da23bd36e2d631b);
    var $6fVtW = parcelRequire("6fVtW");
    var $gIvAV = parcelRequire("gIvAV");
    var $hBadn = parcelRequire("hBadn");
    var $7Pzeh = parcelRequire("7Pzeh");
    var $2XWh5 = parcelRequire("2XWh5");
    const $3ed9d240dba3b00f$export$63ce1a41d951945d = 300000;
    class $3ed9d240dba3b00f$export$da23bd36e2d631b extends (0, $2XWh5.ChoreographerPlugin) {
        constructor(env, metaMetricsData = {}){
            super((0, $gIvAV.ProductIds).ENGAGEKIT, env, metaMetricsData);
        }
        isValidDuplicateStartRequest(messageId) {
            const currentMessage = (0, $6fVtW.Choreographer).getInstance().getCurrentMessage() ?? (0, $6fVtW.Choreographer).getInstance().getCurrentPendingMessage();
            return Boolean(currentMessage && currentMessage.productId === this.state.productId && currentMessage.messageId === messageId && Date.now() - currentMessage.timestamp < $3ed9d240dba3b00f$export$63ce1a41d951945d);
        }
        async startMessageWithPlugin(messageId, callback, additionalData = {}) {
            const debugLogger = new (0, $hBadn.DebugLogger)(this.state.productId, messageId);
            const actionSubject = (0, $gIvAV.MessageAction).START;
            debugLogger.trace({
                verbose: `EngagekitChoreographerPlugin::startMessageWithPlugin`
            });
            const isValidDuplicateStartRequest = this.isValidDuplicateStartRequest(messageId);
            if (isValidDuplicateStartRequest) {
                const logger = new (0, $7Pzeh.Logger)(actionSubject, messageId, {
                    ...this.state.metaMetricsData,
                    ...additionalData
                }, this.analyticsClient);
                const didStart = Boolean(await callback());
                if (didStart) {
                    logger.started();
                    debugLogger.log({
                        verbose: {
                            phase: actionSubject,
                            plugin: this.constructor.name,
                            disposition: (0, $gIvAV.MessageDeliveryStatus).STARTED,
                            timestamp: performance.now()
                        }
                    });
                }
                return didStart;
            }
            this.onStart(messageId, callback);
            const result = await this.startMessage(messageId, additionalData);
            return result === (0, $gIvAV.MessageDeliveryStatus).STARTED;
        }
        async stopMessageWithPlugin(messageId, callback, additionalData = {}) {
            const debugLogger = new (0, $hBadn.DebugLogger)(this.state.productId, messageId);
            debugLogger.trace({
                verbose: `EngagekitChoreographerPlugin::stopMessageWithPlugin`
            });
            this.onStop(messageId, callback);
            const result = await this.stopMessage(messageId, additionalData);
            return result === (0, $gIvAV.MessageDeliveryStatus).STOPPED;
        }
    }
});
parcelRegister("6fVtW", function(module, exports) {
    $parcel$export(module.exports, "Choreographer", ()=>$9a5c85a2d0faba7e$export$236158f15971c92e);
    var $gIvAV = parcelRequire("gIvAV");
    var $hBadn = parcelRequire("hBadn");
    var $7Pzeh = parcelRequire("7Pzeh");
    const $9a5c85a2d0faba7e$var$CHOREOGRAPHER_MESSAGE_TTL = 300000;
    let $9a5c85a2d0faba7e$var$singleton;
    class $9a5c85a2d0faba7e$export$236158f15971c92e {
        static getInstance() {
            if (!$9a5c85a2d0faba7e$var$singleton) $9a5c85a2d0faba7e$var$singleton = new this();
            return $9a5c85a2d0faba7e$var$singleton;
        }
        constructor(){
            this.state = {
                currentMessage: null,
                isDisabled: false,
                messages: new Map(),
                messageQueue: [],
                messageTtl: null,
                plugins: new Map(),
                queueingBehindMessage: null,
                shouldQueueMessages: false
            };
        }
        stopCurrentMessage() {
            if (this.state.currentMessage) this.stopMessageInternal(this.state.currentMessage.productId, this.state.currentMessage.messageId, this.state.currentMessage.analyticsClient, this.state.currentMessage.metricsData, true).then(()=>{
                this.clearMessageTtl();
                this.enablePlugins();
            });
        }
        queueMessages(productId, messageId) {
            this.state.shouldQueueMessages = true;
            this.state.queueingBehindMessage = {
                productId: productId,
                messageId: messageId,
                timestamp: Date.now()
            };
        }
        queueMessage(productId, messageId, analyticsClient, metricsData, plugin) {
            return new Promise((resolve)=>{
                this.state.messageQueue.push({
                    productId: productId,
                    messageId: messageId,
                    analyticsClient: analyticsClient,
                    metricsData: metricsData,
                    plugin: plugin,
                    resolve: resolve
                });
            });
        }
        processQueuedMessage() {
            const queuedMessage = this.state.messageQueue.shift();
            this.state.shouldQueueMessages = false;
            this.state.queueingBehindMessage = null;
            if (queuedMessage) queuedMessage.resolve(this.startMessage(queuedMessage.productId, queuedMessage.messageId, queuedMessage.analyticsClient, queuedMessage.metricsData, queuedMessage.plugin));
        }
        destroyMessageQueue() {
            this.state.shouldQueueMessages = false;
            this.state.queueingBehindMessage = null;
            while(this.state.messageQueue.length > 0){
                const { analyticsClient: analyticsClient, messageId: messageId, metricsData: metricsData, productId: productId, resolve: resolve } = this.state.messageQueue.shift();
                const attributes = {
                    ...metricsData,
                    productId: productId,
                    messageId: messageId
                };
                const actionSubject = (0, $gIvAV.MessageAction).START;
                const logger = new (0, $7Pzeh.Logger)(actionSubject, messageId, attributes, analyticsClient);
                const debugLogger = new (0, $hBadn.DebugLogger)(productId, messageId);
                logger.blocked({
                    blockedByProductId: this.state.currentMessage?.productId,
                    blockedByMessageId: this.state.currentMessage?.messageId
                });
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $gIvAV.MessageDeliveryStatus).BLOCKED,
                        blockedByProductId: this.state.currentMessage?.productId,
                        blockedByMessageId: this.state.currentMessage?.messageId
                    }
                });
                resolve((0, $gIvAV.MessageDeliveryStatus).BLOCKED);
            }
        }
        setMessageTtl(productId, messageId, analyticsClient, metricsData) {
            this.state.currentMessage = {
                productId: productId,
                messageId: messageId,
                analyticsClient: analyticsClient,
                metricsData: metricsData,
                timestamp: Date.now()
            };
            this.state.messageTtl = setTimeout(()=>{
                if (this.isCurrentMessage(productId, messageId)) this.stopCurrentMessage();
            }, $9a5c85a2d0faba7e$var$CHOREOGRAPHER_MESSAGE_TTL);
        }
        isCurrentMessage(productId, messageId) {
            return Boolean(this.state.currentMessage && this.state.currentMessage.productId === productId && this.state.currentMessage.messageId === messageId);
        }
        getCurrentMessage() {
            return this.state.currentMessage;
        }
        getCurrentPendingMessage() {
            return this.state.queueingBehindMessage;
        }
        clearMessageTtl() {
            this.state.currentMessage = null;
            if (this.state.messageTtl) clearTimeout(this.state.messageTtl);
        }
        disablePlugins(exceptFor) {
            this.state.isDisabled = true;
            [
                ...this.state.plugins.values()
            ].forEach((p)=>{
                if (p !== exceptFor) p.disable();
            });
        }
        enablePlugins() {
            [
                ...this.state.plugins.values()
            ].forEach((p)=>p.enable());
            this.state.isDisabled = false;
        }
        unregisterPlugin(productId) {
            if (this.state.currentMessage?.productId === productId) this.stopCurrentMessage();
            this.state.messages.delete(productId);
            this.state.plugins.delete(productId);
        }
        isDisplayingMessage() {
            return Boolean(this.state.currentMessage || [
                ...this.state.plugins.values()
            ].reduce((isDisplayingMessage, p)=>{
                return isDisplayingMessage || p.isDisplayingMessage();
            }, false));
        }
        getMessages(productId) {
            return this.state.messages.get(productId) ?? new Map();
        }
        async startMessage(productId, messageId, analyticsClient, metricsData = {}, plugin) {
            const debugLogger = new (0, $hBadn.DebugLogger)(productId, messageId);
            const actionSubject = (0, $gIvAV.MessageAction).START;
            const requestTimestamp = performance.now();
            debugLogger.log({
                info: {
                    phase: actionSubject,
                    timestamp: requestTimestamp
                },
                verbose: {
                    phase: actionSubject,
                    timestamp: requestTimestamp
                }
            });
            const attributes = {
                ...metricsData,
                productId: productId,
                messageId: messageId
            };
            const logger = new (0, $7Pzeh.Logger)(actionSubject, messageId, attributes, analyticsClient);
            try {
                if (!this.hasMessageRecord(productId, messageId)) {
                    logger.unregistered();
                    debugLogger.log({
                        verbose: {
                            phase: actionSubject,
                            disposition: (0, $gIvAV.MessageDeliveryStatus).UNREGISTERED
                        }
                    });
                    return (0, $gIvAV.MessageDeliveryStatus).UNREGISTERED;
                }
                if (this.state.shouldQueueMessages) {
                    debugLogger.log({
                        verbose: {
                            phase: actionSubject,
                            disposition: `queued behind ${this.state.queueingBehindMessage?.productId} ${this.state.queueingBehindMessage?.messageId}`
                        }
                    });
                    return this.queueMessage(productId, messageId, analyticsClient, metricsData, plugin);
                }
                if (this.state.isDisabled || this.isDisplayingMessage()) {
                    logger.blocked({
                        blockedByProductId: this.state.currentMessage?.productId,
                        blockedByMessageId: this.state.currentMessage?.messageId
                    });
                    debugLogger.log({
                        verbose: {
                            phase: actionSubject,
                            disposition: (0, $gIvAV.MessageDeliveryStatus).BLOCKED,
                            blockedByProductId: this.state.currentMessage?.productId,
                            blockedByMessageId: this.state.currentMessage?.messageId
                        }
                    });
                    return (0, $gIvAV.MessageDeliveryStatus).BLOCKED;
                }
                const message = this.ensureMessageRecord(productId, messageId);
                this.queueMessages(productId, messageId);
                const didStart = await message.start?.() ?? true;
                if (didStart) {
                    message.onStart?.();
                    logger.started();
                    this.disablePlugins(plugin);
                    this.setMessageTtl(productId, messageId, analyticsClient, metricsData);
                    this.destroyMessageQueue();
                    debugLogger.log({
                        verbose: {
                            phase: actionSubject,
                            disposition: (0, $gIvAV.MessageDeliveryStatus).STARTED
                        }
                    });
                    return (0, $gIvAV.MessageDeliveryStatus).STARTED;
                }
                this.processQueuedMessage();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $gIvAV.MessageDeliveryStatus).CANCELED
                    }
                });
                return (0, $gIvAV.MessageDeliveryStatus).CANCELED;
            } catch (error) {
                const e = error;
                logger.error({
                    reason: e.message
                });
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $gIvAV.MessageDeliveryStatus).ERROR
                    }
                });
                return (0, $gIvAV.MessageDeliveryStatus).ERROR;
            }
        }
        async stopMessageInternal(productId, messageId, analyticsClient, metricsData = {}, forceStop = false) {
            const debugLogger = new (0, $hBadn.DebugLogger)(productId, messageId);
            const actionSubject = (0, $gIvAV.MessageAction).STOP;
            const requestTimestamp = performance.now();
            debugLogger.log({
                info: {
                    phase: actionSubject,
                    timestamp: requestTimestamp
                },
                verbose: {
                    phase: actionSubject,
                    timestamp: requestTimestamp
                }
            });
            const attributes = {
                ...metricsData,
                productId: productId,
                messageId: messageId
            };
            const logger = new (0, $7Pzeh.Logger)(actionSubject, messageId, attributes, analyticsClient);
            try {
                if (!this.hasMessageRecord(productId, messageId)) {
                    logger.unregistered();
                    debugLogger.log({
                        verbose: {
                            phase: actionSubject,
                            disposition: (0, $gIvAV.MessageDeliveryStatus).UNREGISTERED
                        }
                    });
                    return (0, $gIvAV.MessageDeliveryStatus).UNREGISTERED;
                }
                const message = this.ensureMessageRecord(productId, messageId);
                if (this.isCurrentMessage(productId, messageId)) this.queueMessages(productId, messageId);
                const didStop = await message.stop?.() ?? true;
                if (didStop || forceStop) {
                    if (this.isCurrentMessage(productId, messageId)) {
                        message.onStop?.();
                        logger.stopped(forceStop ? {
                            forceStop: forceStop,
                            didStop: didStop
                        } : undefined);
                        this.clearMessageTtl();
                        this.enablePlugins();
                    }
                    this.processQueuedMessage();
                    debugLogger.log({
                        verbose: {
                            phase: actionSubject,
                            disposition: (0, $gIvAV.MessageDeliveryStatus).STOPPED
                        }
                    });
                    return (0, $gIvAV.MessageDeliveryStatus).STOPPED;
                }
                this.destroyMessageQueue();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $gIvAV.MessageDeliveryStatus).CANCELED
                    }
                });
                return (0, $gIvAV.MessageDeliveryStatus).CANCELED;
            } catch (error) {
                const e = error;
                logger.error({
                    reason: e.message
                });
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $gIvAV.MessageDeliveryStatus).ERROR
                    }
                });
                return (0, $gIvAV.MessageDeliveryStatus).ERROR;
            }
        }
        async stopMessage(productId, messageId, analyticsClient, metricsData = {}) {
            return this.stopMessageInternal(productId, messageId, analyticsClient, metricsData);
        }
        registerPlugin(productId, plugin) {
            if (this.state.plugins.has(productId)) throw new Error(`Choreographer plugin already registered for ${productId}!`);
            this.state.plugins = this.state.plugins.set(productId, plugin);
            if (this.state.isDisabled) plugin.disable();
            return ()=>{
                this.unregisterPlugin(productId);
            };
        }
        ensureMessageRecord(productId, messageId) {
            let productMessages = this.state.messages.get(productId);
            if (!productMessages) {
                productMessages = new Map();
                this.state.messages.set(productId, productMessages);
            }
            let message = productMessages.get(messageId);
            if (!message) {
                message = {};
                productMessages.set(messageId, message);
            }
            return message;
        }
        hasMessageRecord(productId, messageId) {
            return Boolean(this.state.messages.get(productId)?.has?.(messageId));
        }
        on(productId, messageId, options = {}, finalizers = {}) {
            const message = {
                ...this.ensureMessageRecord(productId, messageId),
                ...options,
                ...finalizers
            };
            this.state.messages.get(productId).set(messageId, message);
        }
        onStart(productId, messageId, startCallback, finalizers) {
            this.on(productId, messageId, {
                start: startCallback
            }, finalizers);
        }
        onStop(productId, messageId, stopCallback, finalizers = {}) {
            this.on(productId, messageId, {
                stop: stopCallback
            }, finalizers);
        }
        off(productId, messageId) {
            this.state.messages.get(productId)?.delete?.(messageId);
        }
    }
});
parcelRegister("gIvAV", function(module, exports) {
    $parcel$export(module.exports, "MessageEventType", ()=>$be974c5c16c30800$export$d33b097e0a285bc2);
    $parcel$export(module.exports, "MessageDeliveryStatus", ()=>$be974c5c16c30800$export$f6a9504bc1305cf0);
    $parcel$export(module.exports, "ProductIds", ()=>$be974c5c16c30800$export$7fb117db98868be6);
    $parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", ()=>$be974c5c16c30800$export$dbe9e38c9d6f26d0);
    $parcel$export(module.exports, "MessageAction", ()=>$be974c5c16c30800$export$865c0eaaa43d90f8);
    const $be974c5c16c30800$export$d33b097e0a285bc2 = {
        START: 'start',
        STOP: 'stop'
    };
    const $be974c5c16c30800$export$f6a9504bc1305cf0 = {
        BLOCKED: 'blocked',
        CANCELED: 'canceled',
        ERROR: 'error',
        STARTED: 'started',
        STOPPED: 'stopped',
        UNREGISTERED: 'unregistered'
    };
    var $be974c5c16c30800$export$7fb117db98868be6;
    (function(ProductIds) {
        ProductIds["CONFLUENCE"] = "confluence";
        ProductIds["ENGAGEKIT"] = "Engagekit";
        ProductIds["INTERCOM"] = "intercom";
        ProductIds["JIRA"] = "jira";
        ProductIds["PENDO"] = "pendo";
        ProductIds["CLOUDADMIN"] = "cloudadmin";
        ProductIds["BITBUCKET"] = "bitbucket";
        ProductIds["POST_OFFICE"] = "post-office";
    })($be974c5c16c30800$export$7fb117db98868be6 || ($be974c5c16c30800$export$7fb117db98868be6 = {}));
    const $be974c5c16c30800$export$94e85cf3348f045a = {
        ENGAGEMENT: 'engagement',
        MARKETING: 'marketing',
        TRANSACTIONAL: 'transactional'
    };
    const $be974c5c16c30800$export$dbe9e38c9d6f26d0 = [
        $be974c5c16c30800$export$94e85cf3348f045a.ENGAGEMENT,
        $be974c5c16c30800$export$94e85cf3348f045a.MARKETING
    ];
    const $be974c5c16c30800$export$865c0eaaa43d90f8 = {
        START: 'messageStart',
        STOP: 'messageStop'
    };
    const $be974c5c16c30800$export$fc6a8b8cb405f50 = {
        INFO: 'info',
        VERBOSE: 'verbose'
    };
});
parcelRegister("hBadn", function(module, exports) {
    $parcel$export(module.exports, "DebugLogger", ()=>$56e217ad93d0f817$export$21e6cc849c1dc1ab);
    function $56e217ad93d0f817$var$getCurrentLoggingLevel() {
        return window.choreographerLoggingLevel;
    }
    function $56e217ad93d0f817$var$logMessageIfValidLoggingLevel(loggingLevel, data) {
        if ($56e217ad93d0f817$var$getCurrentLoggingLevel() === loggingLevel) console.table(data);
    }
    function $56e217ad93d0f817$var$traceMessageIfValidLoggingLevel(loggingLevel, productId, messageId, message) {
        if ($56e217ad93d0f817$var$getCurrentLoggingLevel() === loggingLevel) console.log(`CHOREOGRAPHER - ${productId} - ${messageId} - ${message}`);
    }
    class $56e217ad93d0f817$export$21e6cc849c1dc1ab {
        constructor(productId, messageId){
            this.log = (messages)=>{
                [
                    ...Object.keys(messages)
                ].forEach((loggingLevel)=>{
                    $56e217ad93d0f817$var$logMessageIfValidLoggingLevel(loggingLevel, {
                        productId: this.state.productId,
                        messageId: this.state.messageId,
                        ...messages[loggingLevel] ?? {},
                        ...loggingLevel === 'verbose' ? {
                            timestamp: performance.now()
                        } : {}
                    });
                });
            };
            this.trace = (messages)=>{
                [
                    ...Object.keys(messages)
                ].forEach((loggingLevel)=>{
                    $56e217ad93d0f817$var$traceMessageIfValidLoggingLevel(loggingLevel, this.state.productId, this.state.messageId, `${messages[loggingLevel]}${loggingLevel === 'verbose' ? ` (${performance.now()})` : ''}`);
                });
            };
            this.state = {
                productId: productId,
                messageId: messageId
            };
        }
    }
});
parcelRegister("7Pzeh", function(module, exports) {
    $parcel$export(module.exports, "Logger", ()=>$001eaa38f05c9cf7$export$efa9a398d6368992);
    var $iDwTy = parcelRequire("iDwTy");
    var $gIvAV = parcelRequire("gIvAV");
    class $001eaa38f05c9cf7$export$efa9a398d6368992 {
        constructor(actionSubject, actionSubjectId, metricsData, analyticsClient){
            this.state = {
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                metricsData: metricsData,
                analyticsClient: analyticsClient
            };
        }
        sendOperationalEvent(action, additionalAttributes) {
            if ((0, $iDwTy.fg)('platform.post-office.enable-full-choreographer-logging')) {
                const { analyticsClient: analyticsClient, actionSubject: actionSubject, actionSubjectId: actionSubjectId, metricsData: attributes } = this.state;
                analyticsClient.sendOperationalEvent({
                    source: 'choreographer',
                    action: action,
                    actionSubject: actionSubject,
                    actionSubjectId: actionSubjectId,
                    attributes: {
                        ...attributes ?? {},
                        ...additionalAttributes ?? {}
                    },
                    tags: [
                        'postOffice'
                    ]
                });
            }
        }
        blocked(additionalAttributes) {
            this.sendOperationalEvent((0, $gIvAV.MessageDeliveryStatus).BLOCKED, additionalAttributes);
        }
        error(additionalAttributes) {
            this.sendOperationalEvent((0, $gIvAV.MessageDeliveryStatus).ERROR, additionalAttributes);
        }
        unregistered(additionalAttributes) {
            this.sendOperationalEvent((0, $gIvAV.MessageDeliveryStatus).UNREGISTERED, additionalAttributes);
        }
        started(additionalAttributes) {
            this.sendOperationalEvent((0, $gIvAV.MessageDeliveryStatus).STARTED, additionalAttributes);
        }
        stopped(additionalAttributes) {
            this.sendOperationalEvent((0, $gIvAV.MessageDeliveryStatus).STOPPED, additionalAttributes);
        }
    }
});
parcelRegister("2XWh5", function(module, exports) {
    $parcel$export(module.exports, "ChoreographerPlugin", ()=>$5e8a69cbe97f759a$export$71324a662782c710);
    var $17RWd = parcelRequire("17RWd");
    var $1nBQ6 = parcelRequire("1nBQ6");
    var $6fVtW = parcelRequire("6fVtW");
    class $5e8a69cbe97f759a$export$71324a662782c710 {
        constructor(productId, env, metaMetricsData = {}){
            this.state = {
                isDisabled: false,
                isDisplayingMessage: false,
                metaMetricsData: metaMetricsData,
                productId: productId,
                unregisterPlugin: ()=>{}
            };
            this.analyticsClient = this.createAnalyticsClient(env);
            this.finalizers = {
                onStart: ()=>this.blockDisplayState(),
                onStop: ()=>this.clearDisplayState()
            };
            this.state.unregisterPlugin = this.registerPlugin(productId);
        }
        destroy() {
            this.state.unregisterPlugin();
        }
        isDisplayingMessage() {
            return this.state.isDisplayingMessage;
        }
        blockDisplayState() {
            this.state.isDisplayingMessage = true;
        }
        clearDisplayState() {
            this.state.isDisplayingMessage = false;
        }
        disable() {
            this.state.isDisabled = true;
        }
        enable() {
            this.state.isDisabled = false;
        }
        async startMessage(messageId, additionalData = {}) {
            return (0, $6fVtW.Choreographer).getInstance().startMessage(this.state.productId, messageId, this.analyticsClient, {
                ...this.state.metaMetricsData,
                ...additionalData
            }, this);
        }
        async stopMessage(messageId, additionalData = {}) {
            return (0, $6fVtW.Choreographer).getInstance().stopMessage(this.state.productId, messageId, this.analyticsClient, {
                ...this.state.metaMetricsData,
                ...additionalData
            });
        }
        on(messageId, options = {}) {
            return (0, $6fVtW.Choreographer).getInstance().on(this.state.productId, messageId, options, this.finalizers);
        }
        onStart(messageId, startCallback) {
            return (0, $6fVtW.Choreographer).getInstance().onStart(this.state.productId, messageId, startCallback, this.finalizers);
        }
        onStop(messageId, stopCallback) {
            return (0, $6fVtW.Choreographer).getInstance().onStop(this.state.productId, messageId, stopCallback, this.finalizers);
        }
        off(messageId) {
            return (0, $6fVtW.Choreographer).getInstance().off(this.state.productId, messageId);
        }
        registerPlugin(productId) {
            return (0, $6fVtW.Choreographer).getInstance().registerPlugin(productId, this);
        }
        createAnalyticsClient(env) {
            const analyticsClient = new (0, $17RWd.default)({
                env: env,
                product: 'postOffice',
                origin: (0, $1nBQ6.originType).WEB
            });
            return analyticsClient;
        }
    }
});
const $3181f97da209d060$export$3288b14b6745c572 = 204;
const $3181f97da209d060$export$c09e7ea0fc79f34f = 409;
const $3181f97da209d060$export$974c37534b0191b1 = 503;
parcelRegister("5LHs9", function(module, exports) {
    $parcel$export(module.exports, "errorIfNotOk", ()=>$787e63e29575bb20$export$4adbd37839ed7718);
    $parcel$export(module.exports, "pullResponseTextIfNotOk", ()=>$787e63e29575bb20$export$2ba4cde277adb6b1);
    $parcel$export(module.exports, "stargateFetch", ()=>$787e63e29575bb20$export$317bcea84a3bea48);
    $parcel$export(module.exports, "stargateFetchRetryOn5xx", ()=>$787e63e29575bb20$export$2d9a5db60a4c50cd);
    var $hLsyz = parcelRequire("hLsyz");
    const $787e63e29575bb20$export$3410cacbbaf2b385 = 60;
    async function $787e63e29575bb20$export$4adbd37839ed7718(response) {
        if (!response.ok) throw Error(`${response.status}: ${await response.text()}`);
        return response;
    }
    async function $787e63e29575bb20$export$2ba4cde277adb6b1(response) {
        if (!response.ok) await response.text();
        return response;
    }
    function $787e63e29575bb20$var$basicStargateRetryCondition(response) {
        const failureCategory = response.headers.get('X-Failure-Category');
        const failureCategoryIsThrottled = !!failureCategory && failureCategory.toLowerCase() === 'throttled';
        return response.status === (0, $3181f97da209d060$export$974c37534b0191b1) && failureCategoryIsThrottled;
    }
    function $787e63e29575bb20$export$317bcea84a3bea48(input, reqOptions, retryCondition = $787e63e29575bb20$var$basicStargateRetryCondition) {
        return $787e63e29575bb20$var$fetchWithRetry(input, retryCondition, $787e63e29575bb20$export$d63a365100d81d24(reqOptions));
    }
    function $787e63e29575bb20$export$2d9a5db60a4c50cd(input, reqOptions) {
        return $787e63e29575bb20$export$317bcea84a3bea48(input, reqOptions, (response)=>response.status >= 500 && response.status <= 599);
    }
    function $787e63e29575bb20$export$d63a365100d81d24(reqOptions) {
        return {
            ...reqOptions,
            credentials: (0, $hLsyz.default).includes(location.host) ? 'include' : 'same-origin'
        };
    }
    function $787e63e29575bb20$var$handleFetchResultAndRetryIfNeeded(fetchResult, retryCondition, retry) {
        return fetchResult.then((r)=>retryCondition(r) ? retry() : Promise.resolve(r)).catch(retry);
    }
    function $787e63e29575bb20$var$fetchWithRetry(input, retryCondition, reqOptions) {
        return $787e63e29575bb20$var$handleFetchResultAndRetryIfNeeded(fetch(input, reqOptions), retryCondition, ()=>$787e63e29575bb20$var$retryFetchWithBackoff(input, retryCondition, reqOptions));
    }
    function $787e63e29575bb20$var$retryFetchWithBackoff(input, retryCondition, reqOptions, waitTimeMinutes = 0) {
        return $787e63e29575bb20$var$handleFetchResultAndRetryIfNeeded($787e63e29575bb20$var$fetchAfter(input, waitTimeMinutes, reqOptions), retryCondition, ()=>$787e63e29575bb20$var$retryFetchWithBackoff(input, retryCondition, reqOptions, Math.min(waitTimeMinutes === 0 ? 1 : waitTimeMinutes * 2, $787e63e29575bb20$export$3410cacbbaf2b385)));
    }
    const $787e63e29575bb20$export$1e8d24b3235d31db = 5000;
    function $787e63e29575bb20$var$fetchAfter(input, waitTimeMinutes, reqOptions) {
        const staggerDelay = Math.round(Math.random() * $787e63e29575bb20$export$1e8d24b3235d31db);
        const delay = waitTimeMinutes ? waitTimeMinutes * 60000 + staggerDelay : 0;
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                fetch(input, reqOptions).then(resolve).catch(reject);
            }, delay);
        });
    }
});
parcelRegister("hLsyz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5280fe68d9fa0d52$export$2e2bcd8739ae039);
    var $5280fe68d9fa0d52$export$2e2bcd8739ae039 = [
        'bitbucket-pipelines.dev.public.atl-paas.net',
        'bitbucket-pipelines.staging.public.atl-paas.net',
        'bitbucket-pipelines.prod.public.atl-paas.net'
    ];
});
parcelRegister("kUO48", function(module, exports) {
    $parcel$export(module.exports, "EngagementProvider", ()=>$41da1f95c495c2a8$export$83b8ae7ce7b4d59c);
    var $eUqFw = parcelRequire("eUqFw");
    var $046kq = parcelRequire("046kq");
    var $6l6Xk = parcelRequire("6l6Xk");
    var $1Qivz = parcelRequire("1Qivz");
    var $1Zvbf = parcelRequire("1Zvbf");
    var $6ZukE = parcelRequire("6ZukE");
    var $7lZLl = parcelRequire("7lZLl");
    var $gIvAV = parcelRequire("gIvAV");
    var $ik9Zk = parcelRequire("ik9Zk");
    var $i7Llh = parcelRequire("i7Llh");
    var $dWRaN = parcelRequire("dWRaN");
    var $eImWQ = parcelRequire("eImWQ");
    var $2j4LQ = parcelRequire("2j4LQ");
    var $jBXeU = parcelRequire("jBXeU");
    var $4Dcsc = parcelRequire("4Dcsc");
    var $hfxUI = parcelRequire("hfxUI");
    const $41da1f95c495c2a8$var$MAX_EVENT_QUEUE_SIZE = 100;
    const $41da1f95c495c2a8$var$EK_LOADED_EVENT = 'engagement.inproduct.loaded';
    const $41da1f95c495c2a8$export$5306bd00631dbf8c = 'ep.analyticEvent';
    function $41da1f95c495c2a8$var$collapseEventToPayload(event) {
        const payload = {
            ...event.payload,
            context: {}
        };
        Object.assign(payload.context, ...event.context);
        return payload;
    }
    function $41da1f95c495c2a8$var$findMatchingTrigger(messageMapping, payload) {
        return Array.from(messageMapping.keys()).find((trigger)=>{
            return (0, ($parcel$interopDefault($046kq)))(payload, trigger);
        });
    }
    function $41da1f95c495c2a8$var$fireExposureEvent(attributes, clientOrPromise) {
        const analyticsEvent = new (0, $6ZukE.default)({
            payload: {
                action: 'exposed',
                actionSubject: 'feature',
                actionSubjectId: attributes.flagKey,
                source: 'engagement-platform',
                attributes: attributes
            }
        });
        Promise.resolve(clientOrPromise).then((client)=>{
            client.sendTrackEvent(analyticsEvent.payload);
        });
    }
    function $41da1f95c495c2a8$var$getExposureAttributes(messageId, cohort, additionalProps) {
        return {
            reason: 'RULE_MATCH',
            ruleId: 'engagement.inproduct',
            flagKey: `engagement.inproduct.${messageId}`,
            value: cohort,
            ...additionalProps
        };
    }
    function $41da1f95c495c2a8$var$getBaseAttributes(messageId, variationId, componentId, locale) {
        return {
            messageId: messageId,
            variationId: variationId,
            componentIndex: componentId,
            locale: locale
        };
    }
    async function $41da1f95c495c2a8$export$473a2bbbfd90c87b(eventMapping, config, store, clientOrPromise, coordinationOptions, componentConfig) {
        const { locale: locale } = config;
        const { message: message, component: component } = eventMapping;
        if (message.holdout) {
            await (0, $i7Llh.startMessage)({
                cloudId: config.cloudId,
                stargateUrl: config.stargateUrl,
                messageId: message.messageId,
                variationId: message.variationId,
                orgId: config.orgId,
                workspaceId: config.workspaceId
            }, coordinationOptions);
            await (0, $i7Llh.stopMessage)({
                cloudId: config.cloudId,
                stargateUrl: config.stargateUrl,
                messageId: message.messageId,
                orgId: config.orgId,
                workspaceId: config.workspaceId
            }, coordinationOptions);
            $41da1f95c495c2a8$var$fireExposureEvent($41da1f95c495c2a8$var$getExposureAttributes(message.messageId, 'holdout', {
                locale: locale
            }), clientOrPromise);
            return;
        }
        if (component.componentId === 0) {
            const success = await (0, $i7Llh.startMessage)({
                cloudId: config.cloudId,
                stargateUrl: config.stargateUrl,
                messageId: message.messageId,
                variationId: message.variationId,
                orgId: config.orgId,
                workspaceId: config.workspaceId
            }, coordinationOptions);
            if (coordinationOptions?.enableChoreographer && componentConfig?.onMessageDisposition) componentConfig.onMessageDisposition(success ? (0, $gIvAV.MessageDeliveryStatus).STARTED : (0, $gIvAV.MessageDeliveryStatus).BLOCKED);
            if (success) {
                $41da1f95c495c2a8$var$fireExposureEvent($41da1f95c495c2a8$var$getExposureAttributes(message.messageId, message.variationId, {
                    locale: locale
                }), clientOrPromise);
                store.dispatch((0, $4Dcsc.setCurrent)(eventMapping));
            }
        } else {
            $41da1f95c495c2a8$var$fireExposureEvent($41da1f95c495c2a8$var$getExposureAttributes(message.messageId, message.variationId, {
                locale: locale
            }), clientOrPromise);
            store.dispatch((0, $4Dcsc.setCurrent)(eventMapping));
        }
    }
    class $41da1f95c495c2a8$export$83b8ae7ce7b4d59c extends (0, $eUqFw.Component) {
        static{
            this.componentConfig = new Map();
        }
        static{
            this.childContextTypes = {
                subscribeEngagementState: (0, ($parcel$interopDefault($1Qivz))).func,
                setComponentConfig: (0, ($parcel$interopDefault($1Qivz))).func
            };
        }
        static{
            this.defaultProps = {
                eventTarget: (0, ($parcel$interopDefault($1Zvbf)))
            };
        }
        static{
            this.hasInitializedAtLeastOneEngagementProvider = false;
        }
        constructor(props){
            super(props);
            this.onStoreChange = (state)=>{
                const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
                const config = this.getConfig();
                const { locale: locale } = config;
                if (state.initialized) {
                    if (!$41da1f95c495c2a8$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider) {
                        this.sendOperationalEventWithClient({
                            action: 'loaded',
                            actionSubject: 'messages',
                            actionSubjectId: undefined,
                            source: 'engagekit',
                            attributes: {
                                locale: locale
                            }
                        });
                        const browserInfo = (0, $eImWQ.getBrowserInfo)();
                        this.onEvent(createAnalyticsEvent({
                            event: $41da1f95c495c2a8$var$EK_LOADED_EVENT,
                            properties: {
                                browser: browserInfo.name,
                                browserVersion: browserInfo.version
                            }
                        }));
                        $41da1f95c495c2a8$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider = true;
                    }
                    this.analyticsEventQueue.flush(this.onEvent);
                    if (this.unsubscribeFromStore) this.unsubscribeFromStore();
                }
            };
            this.onEvent = (event)=>{
                const state = this.getState();
                if (!state.initialized) {
                    const success = this.analyticsEventQueue.enqueue(event);
                    if (!success) this.fireQueueOverflowEvent();
                    return;
                }
                const { eventTarget: eventTarget, store: store, analyticsClientInstance: analyticsClientInstance } = this.props;
                const config = this.getConfig();
                const { current: current, messageMapping: messageMapping } = state;
                const payload = $41da1f95c495c2a8$var$collapseEventToPayload(event);
                eventTarget.dispatchEvent((0, $2j4LQ.default)({
                    eventName: $41da1f95c495c2a8$export$5306bd00631dbf8c,
                    canBubble: false,
                    cancellable: false,
                    detail: payload
                }));
                if (!(0, $jBXeU.isMessagingEnabled)()) return;
                if (current) return;
                const trigger = $41da1f95c495c2a8$var$findMatchingTrigger(messageMapping, payload);
                if (!trigger) return;
                const eventMapping = messageMapping.get(trigger);
                let componentConfig;
                if (eventMapping.component?.componentType) {
                    const componentConfigId = this.getConfigId(eventMapping.component.componentType, eventMapping.component.target);
                    componentConfig = $41da1f95c495c2a8$export$83b8ae7ce7b4d59c.componentConfig.get(componentConfigId);
                }
                const coordinationOptions = this.getComponentCoordinationOptions(componentConfig);
                $41da1f95c495c2a8$export$473a2bbbfd90c87b(eventMapping, config, store, analyticsClientInstance, coordinationOptions, componentConfig);
            };
            this.onEngagementEvent = (event)=>{
                const { action: action, clickType: clickType, ekMessageId: ekMessageId, ekVariationId: ekVariationId, ekComponentId: ekComponentId, ekComponentType: ekComponentType, ekIsLast: ekIsLast } = event.payload;
                const config = this.getConfig();
                const { locale: locale } = config;
                const attributes = $41da1f95c495c2a8$var$getBaseAttributes(ekMessageId, ekVariationId, ekComponentId, locale);
                if (action === 'click') {
                    this.handleClickEvent(ekMessageId, ekVariationId, ekComponentId);
                    attributes.buttonType = clickType;
                    this.sendUIEventWithClient({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: `${clickType}Button`,
                        source: `engagement_${ekComponentType}`,
                        attributes: attributes
                    });
                } else {
                    if (action === 'shown') {
                        attributes.componentType = ekComponentType;
                        this.sendScreenEventWithClient({
                            name: `engagement_${ekComponentType}`,
                            attributes: attributes
                        });
                    }
                    if (action === 'hidden') {
                        attributes.isLast = ekIsLast;
                        this.sendUIEventWithClient({
                            action: 'hid',
                            actionSubject: 'component',
                            actionSubjectId: undefined,
                            source: `engagement_${ekComponentType}`,
                            attributes: attributes
                        });
                    }
                }
                this.onEvent(event);
            };
            this.subscribeEngagementState = (callback)=>{
                const { store: store } = this.props;
                callback(store.getState());
                return store.subscribe(()=>{
                    callback(store.getState());
                });
            };
            this.getComponentCoordinationOptions = (componentConfig)=>{
                const enableChoreographer = Boolean(this.props.coordinationOptions?.enableChoreographer);
                return {
                    ...this.props.coordinationOptions,
                    enableChoreographer: componentConfig?.messageType ? (0, $ik9Zk.shouldBeChoreographed)(componentConfig, {
                        enableChoreographer: true
                    }) : enableChoreographer
                };
            };
            this.getConfigId = (componentType, engagementId)=>{
                return engagementId ? `${componentType}-${engagementId}` : componentType;
            };
            this.setComponentConfig = (componentType, config, engagementId)=>{
                const configId = this.getConfigId(componentType, engagementId);
                $41da1f95c495c2a8$export$83b8ae7ce7b4d59c.componentConfig.set(configId, config);
                return ()=>this.removeComponentConfig(configId);
            };
            this.removeComponentConfig = (configId)=>{
                if ($41da1f95c495c2a8$export$83b8ae7ce7b4d59c.componentConfig.has(configId)) $41da1f95c495c2a8$export$83b8ae7ce7b4d59c.componentConfig.delete(configId);
            };
            const { analyticsClientInstance: analyticsClientInstance } = this.props;
            this.sendUIEventWithClient = (0, $dWRaN.sendUIEvent).bind(null, analyticsClientInstance);
            this.sendScreenEventWithClient = (0, $dWRaN.sendScreenEvent).bind(null, analyticsClientInstance);
            this.sendOperationalEventWithClient = (0, $dWRaN.sendOperationalEvent).bind(null, analyticsClientInstance);
            this.analyticsEventQueue = new (0, $hfxUI.default)($41da1f95c495c2a8$var$MAX_EVENT_QUEUE_SIZE);
            this.unsubscribeFromStore = this.subscribeEngagementState(this.onStoreChange);
            this.fireQueueOverflowEvent = (0, ($parcel$interopDefault($6l6Xk)))(()=>{});
        }
        getConfig() {
            const { config: config } = this.getState();
            return config;
        }
        getChildContext() {
            return {
                subscribeEngagementState: this.subscribeEngagementState,
                setComponentConfig: this.setComponentConfig
            };
        }
        getState() {
            return this.props.store.getState();
        }
        getActiveMessage() {
            return this.getState().current;
        }
        async completeMessage(messageId, componentConfig) {
            const config = this.getConfig();
            const coordinationOptions = this.getComponentCoordinationOptions(componentConfig);
            const disposition = await (0, $i7Llh.stopMessage)({
                cloudId: config.cloudId,
                stargateUrl: config.stargateUrl,
                messageId: messageId,
                orgId: config.orgId,
                workspaceId: config.workspaceId
            }, coordinationOptions);
            if (coordinationOptions.enableChoreographer && componentConfig?.onMessageDisposition) componentConfig.onMessageDisposition(disposition ? (0, $gIvAV.MessageDeliveryStatus).STOPPED : (0, $gIvAV.MessageDeliveryStatus).CANCELED);
        }
        handleClickEvent(messageId, variationId, componentId) {
            const activeMessage = this.getActiveMessage();
            if (!activeMessage || activeMessage.messageId !== messageId || activeMessage.variationId !== variationId || activeMessage.componentId !== componentId) return;
            let componentConfig;
            if (activeMessage.componentType) {
                const componentConfigId = this.getConfigId(activeMessage.componentType, activeMessage.target);
                componentConfig = $41da1f95c495c2a8$export$83b8ae7ce7b4d59c.componentConfig.get(componentConfigId);
            }
            if (activeMessage.isLast) this.completeMessage(messageId, componentConfig);
            this.props.store.dispatch((0, $4Dcsc.clearCurrent)());
        }
        componentWillUnmount() {
            this.unsubscribeFromStore && this.unsubscribeFromStore();
        }
        render() {
            return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $7lZLl.default), {
                channel: "*",
                onEvent: this.onEvent
            }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $7lZLl.default), {
                channel: "engagement",
                onEvent: this.onEngagementEvent
            }, this.props.children));
        }
    }
});
parcelRegister("ik9Zk", function(module, exports) {
    $parcel$export(module.exports, "shouldBeChoreographed", ()=>$9f91501b370e3342$export$a8ba9111c7eec9ac);
    $parcel$export(module.exports, "wrapComponentForChoreographer", ()=>$9f91501b370e3342$export$51d40de083bcc6e7);
    $parcel$export(module.exports, "wrapToggleableComponentForChoreographer", ()=>$9f91501b370e3342$export$7c574bc7a8b74124);
    var $eUqFw = parcelRequire("eUqFw");
    var $gIvAV = parcelRequire("gIvAV");
    const $9f91501b370e3342$export$a8ba9111c7eec9ac = (props, coordinationOptions)=>{
        return Boolean(coordinationOptions?.enableChoreographer) && props?.messageType !== undefined && (0, $gIvAV.IntegratedChoreographerMessageTypesEnum).includes(props.messageType);
    };
    const $9f91501b370e3342$export$51d40de083bcc6e7 = (Component)=>{
        function WrapperComponent({ shouldBeChoreographed: shouldBeChoreographedProp, withChoreographedRender: withChoreographedRender, ...props }) {
            const ChoreographedComponent = (0, $eUqFw.useMemo)(()=>withChoreographedRender(Component), [
                withChoreographedRender
            ]);
            if (shouldBeChoreographedProp(props)) {
                const { messageType: messageType, ...rest } = props;
                return (0, ($parcel$interopDefault($eUqFw))).createElement(ChoreographedComponent, rest);
            }
            const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
            return (0, ($parcel$interopDefault($eUqFw))).createElement(Component, rest);
        }
        WrapperComponent.displayName = `ChoreographerWrapped${(Component.displayName ?? Component.name) || 'Component'}`;
        return WrapperComponent;
    };
    const $9f91501b370e3342$export$7c574bc7a8b74124 = (Component, toggleableProp)=>{
        function WrapperComponent({ shouldBeChoreographed: shouldBeChoreographedProp, withChoreographedToggle: withChoreographedToggle, ...props }) {
            const ChoreographedComponent = (0, $eUqFw.useMemo)(()=>withChoreographedToggle(Component, toggleableProp), [
                withChoreographedToggle
            ]);
            if (shouldBeChoreographedProp(props)) {
                const { messageType: messageType, ...rest } = props;
                return (0, ($parcel$interopDefault($eUqFw))).createElement(ChoreographedComponent, rest);
            }
            const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
            return (0, ($parcel$interopDefault($eUqFw))).createElement(Component, rest);
        }
        WrapperComponent.displayName = `ChoreographerWrapped${(Component.displayName ?? Component.name) || 'Component'}`;
        return WrapperComponent;
    };
});
parcelRegister("dWRaN", function(module, exports) {
    $parcel$export(module.exports, "sendScreenEvent", ()=>$f5d42819f06046a9$export$22a3b1671f38a193);
    $parcel$export(module.exports, "sendUIEvent", ()=>$f5d42819f06046a9$export$1aecf263098db667);
    $parcel$export(module.exports, "sendOperationalEvent", ()=>$f5d42819f06046a9$export$e5f89b51c6d4e36b);
    function $f5d42819f06046a9$export$22a3b1671f38a193(clientOrPromise, payload) {
        Promise.resolve(clientOrPromise).then((client)=>{
            client.sendScreenEvent(payload);
        });
    }
    function $f5d42819f06046a9$export$1aecf263098db667(clientOrPromise, payload) {
        Promise.resolve(clientOrPromise).then((client)=>{
            client.sendUIEvent(payload);
        });
    }
    function $f5d42819f06046a9$export$e5f89b51c6d4e36b(clientOrPromise, payload) {
        Promise.resolve(clientOrPromise).then((client)=>{
            client.sendOperationalEvent(payload);
        });
    }
});
parcelRegister("eImWQ", function(module, exports) {
    $parcel$export(module.exports, "getBrowserInfo", ()=>$78e2a409244f3210$export$6c724a6ffa2dc3e1);
    const $78e2a409244f3210$var$browserMatchers = [
        {
            name: 'IE',
            pattern: /Trident\/.*; rv:([^;)]+)/
        },
        {
            name: 'Chrome',
            pattern: /Chrome\/([^ )]+)/
        },
        {
            name: 'Firefox',
            pattern: /Firefox\/([^ )]+)/
        }
    ];
    const $78e2a409244f3210$export$cda2203640e08931 = {
        name: 'unknown',
        version: 'unknown'
    };
    function $78e2a409244f3210$export$6c724a6ffa2dc3e1(userAgent) {
        if (!window.navigator) return $78e2a409244f3210$export$cda2203640e08931;
        if (!userAgent) userAgent = window.navigator.userAgent;
        for (const matcher of $78e2a409244f3210$var$browserMatchers){
            const versionMatch = userAgent.match(matcher.pattern);
            if (versionMatch) return {
                name: matcher.name,
                version: versionMatch[1]
            };
        }
        return $78e2a409244f3210$export$cda2203640e08931;
    }
});
parcelRegister("2j4LQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$803b26b91ad08435$export$2e2bcd8739ae039);
    const $803b26b91ad08435$var$createCustomEvent = ({ eventName: eventName, canBubble: canBubble, cancellable: cancellable, detail: detail })=>{
        const customEvent = document.createEvent('CustomEvent');
        customEvent.initCustomEvent(eventName, canBubble, cancellable, detail);
        return customEvent;
    };
    var $803b26b91ad08435$export$2e2bcd8739ae039 = $803b26b91ad08435$var$createCustomEvent;
});
parcelRegister("hfxUI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d99ed1e7b737775b$export$2e2bcd8739ae039);
    class $d99ed1e7b737775b$export$2e2bcd8739ae039 {
        constructor(maxSize){
            this.queue = [];
            this.maxSize = maxSize;
        }
        enqueue(item) {
            if (this.queue.length === this.maxSize) return false;
            this.queue.push(item);
            return true;
        }
        flush(callback) {
            this.queue.forEach(callback);
            this.queue = [];
        }
        getSize() {
            return this.queue.length;
        }
    }
});
parcelRegister("aZSxk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$95c6465099b06ab7$export$2e2bcd8739ae039);
    var $cJt2B = parcelRequire("cJt2B");
    var $beD8L = parcelRequire("beD8L");
    const $95c6465099b06ab7$var$DEFAULT_TIMING = {
        initialPollInterval: 5000,
        idleTimeout: 30000,
        multiplierCallback: (x)=>x + x
    };
    class $95c6465099b06ab7$export$2e2bcd8739ae039 {
        constructor(trackCallback, eventData, searchSessionId, timingOptions){
            this.start = ()=>{
                this.browserInteractionTime.startTimer();
                this.browserInteractionTime.addTimeIntervalEllapsedCallback({
                    callback: (timeInMilliseconds)=>this._sendDwellEvent(this._eventData, this._searchSessionId, timeInMilliseconds, false),
                    timeInMilliseconds: this._timing.initialPollInterval,
                    multiplier: this._timing.multiplierCallback
                });
                if (typeof window !== 'undefined') window.addEventListener('beforeunload', this._onBeforeUnload);
            };
            this.stop = ()=>{
                if (this.browserInteractionTime.isRunning()) this._sendDwellEvent(this._eventData, this._searchSessionId, this.browserInteractionTime.getTimeInMilliseconds(), true);
                this.browserInteractionTime.stopTimer();
            };
            this.newPage = (eventData, searchSessionId)=>{
                (0, $beD8L.validateDwellBaseEvent)(eventData);
                this.stop();
                this.browserInteractionTime.reset();
                this.setEventData(eventData);
                this.setSearchSessionId(searchSessionId);
                this.start();
            };
            this.setEventData = (eventData)=>{
                this._eventData = eventData;
            };
            this.getEventData = ()=>this._eventData;
            this.setSearchSessionId = (searchSessionId)=>{
                this._searchSessionId = searchSessionId;
            };
            this.getSearchSessionId = ()=>this._searchSessionId;
            this.destroy = ()=>{
                this.browserInteractionTime.destroy();
                if (typeof window !== 'undefined') window.removeEventListener('beforeunload', this._onBeforeUnload);
            };
            this._onBeforeUnload = ()=>{
                this.stop();
                this.destroy();
            };
            this._sendDwellEvent = (eventData, searchSessionId, timeInMilliseconds, isFinalDwellEvent)=>{
                const dwellAttributes = {
                    dwellTime: timeInMilliseconds,
                    searchReferrer: searchSessionId,
                    finalDwellEvent: isFinalDwellEvent
                };
                this._trackCallback({
                    action: 'dwelled',
                    actionSubject: eventData.actionSubject,
                    actionSubjectId: eventData.actionSubjectId,
                    source: eventData.source,
                    containerType: eventData.containerType,
                    containerId: eventData.containerId,
                    objectType: eventData.objectType,
                    objectId: eventData.objectId,
                    attributes: {
                        ...dwellAttributes,
                        ...eventData.attributes
                    },
                    tags: eventData.tags
                });
            };
            if (!trackCallback) throw new Error('trackCallback is required for DwellTimeHelper');
            (0, $beD8L.validateDwellBaseEvent)(eventData);
            this._trackCallback = trackCallback;
            this._eventData = eventData;
            this._searchSessionId = searchSessionId;
            this._timing = {
                ...$95c6465099b06ab7$var$DEFAULT_TIMING,
                ...timingOptions
            };
            this.browserInteractionTime = new (0, $cJt2B.default)({
                idleTimeoutMs: this._timing.idleTimeout,
                checkCallbacksIntervalMs: 500
            });
        }
    }
});
parcelRegister("69ORk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4a126592a48ddf93$export$2e2bcd8739ae039);
    var $6rgVQ = parcelRequire("6rgVQ");
    var $beD8L = parcelRequire("beD8L");
    const $4a126592a48ddf93$var$DEFAULT_TIMING = {
        initialPollInterval: 5,
        pollBackoffRate: 2,
        idleTimeout: 30
    };
    class $4a126592a48ddf93$export$2e2bcd8739ae039 {
        constructor(trackCallback, eventData, searchSessionId, timingOptions, dwellTimeHelperOptions){
            this.timeMeInitialized = false;
            this.start = ()=>{
                if (this.timeMeInitialized) throw new Error('DwellTimeHelper should only be initialised once per page load.');
                this.timeMeInitialized = true;
                this._initDwellTimeCounterAndPolling();
                if (typeof window !== 'undefined') window.addEventListener('beforeunload', ()=>{
                    this.stop();
                });
            };
            this.stop = ()=>{
                if ((0, ($parcel$interopDefault($6rgVQ))).isUserCurrentlyOnPage) this._sendDwellEvent(this._eventData, this._searchSessionId, true);
                (0, ($parcel$interopDefault($6rgVQ))).stopAllTimers();
                (0, ($parcel$interopDefault($6rgVQ))).resetAllRecordedPageTimes();
                (0, ($parcel$interopDefault($6rgVQ))).timeElapsedCallbacks = [];
                this.timeMeInitialized = false;
            };
            this.newPage = (eventData, searchSessionId)=>{
                (0, $beD8L.validateDwellBaseEvent)(eventData);
                this.stop();
                this._eventData = eventData;
                this._searchSessionId = searchSessionId;
                this._initDwellTimeCounterAndPolling();
            };
            this._listForIdleEvents = ()=>{
                document.addEventListener('mousemove', ()=>{
                    (0, ($parcel$interopDefault($6rgVQ))).userActivityDetected();
                });
                document.addEventListener('keyup', ()=>{
                    (0, ($parcel$interopDefault($6rgVQ))).userActivityDetected();
                });
                document.addEventListener('touchstart', ()=>{
                    (0, ($parcel$interopDefault($6rgVQ))).userActivityDetected();
                });
                window.addEventListener('scroll', ()=>{
                    (0, ($parcel$interopDefault($6rgVQ))).userActivityDetected();
                });
                const iframes = document.getElementsByTagName('iframe');
                for(let i = 0; i < iframes.length; i++){
                    const iframe = iframes[i];
                    try {
                        iframe?.contentWindow?.document.addEventListener('mousemove', ()=>{
                            (0, ($parcel$interopDefault($6rgVQ))).userActivityDetected();
                        });
                        iframe?.contentWindow?.document.addEventListener('keyup', ()=>{
                            (0, ($parcel$interopDefault($6rgVQ))).userActivityDetected();
                        });
                        iframe?.contentWindow?.document.addEventListener('touchstart', ()=>{
                            (0, ($parcel$interopDefault($6rgVQ))).userActivityDetected();
                        });
                    } catch (e) {}
                }
                setInterval(()=>{
                    if ((0, ($parcel$interopDefault($6rgVQ))).isUserCurrentlyIdle !== true) {
                        (0, ($parcel$interopDefault($6rgVQ))).checkIdleState();
                        (0, ($parcel$interopDefault($6rgVQ))).startTimer();
                    }
                }, (0, ($parcel$interopDefault($6rgVQ))).checkIdleStateRateMs);
            };
            this._initDwellTimeCounterAndPolling = ()=>{
                if (this._dwellTimeHelperOptions?.iframeDwell) (0, ($parcel$interopDefault($6rgVQ))).listForIdleEvents = this._listForIdleEvents;
                (0, ($parcel$interopDefault($6rgVQ))).initialize({
                    idleTimeoutInSeconds: this._timing.idleTimeout
                });
                this._pollDwellTime(this._timing.initialPollInterval, this._searchSessionId, this._eventData);
            };
            this._pollDwellTime = (pollTime, searchSessionId, eventData)=>{
                (0, ($parcel$interopDefault($6rgVQ))).callAfterTimeElapsedInSeconds(pollTime, ()=>{
                    this._sendDwellEvent(eventData, searchSessionId, false);
                    this._pollDwellTime(pollTime * this._timing.pollBackoffRate, searchSessionId, eventData);
                });
            };
            this._sendDwellEvent = (eventData, searchSessionId, isFinalDwellEvent)=>{
                const dwellAttributes = {
                    dwellTime: (0, ($parcel$interopDefault($6rgVQ))).getTimeOnCurrentPageInMilliseconds(),
                    searchReferrer: searchSessionId,
                    finalDwellEvent: isFinalDwellEvent
                };
                this._trackCallback({
                    action: 'dwelled',
                    actionSubject: eventData.actionSubject,
                    actionSubjectId: eventData.actionSubjectId,
                    source: eventData.source,
                    containerType: eventData.containerType,
                    containerId: eventData.containerId,
                    containers: eventData.containers,
                    objectType: eventData.objectType,
                    objectId: eventData.objectId,
                    attributes: {
                        ...dwellAttributes,
                        ...eventData.attributes
                    },
                    tags: eventData.tags
                });
            };
            if (!trackCallback) throw new Error('trackCallback is required for DwellTimeHelper');
            (0, $beD8L.validateDwellBaseEvent)(eventData);
            this._trackCallback = trackCallback;
            this._eventData = eventData;
            this._searchSessionId = searchSessionId;
            this._timing = {
                ...$4a126592a48ddf93$var$DEFAULT_TIMING,
                ...timingOptions
            };
            this._dwellTimeHelperOptions = dwellTimeHelperOptions;
        }
    }
});
const $9f48e301b76cfb15$export$70df29c238ba7306 = 'mediaCtx';
var $207acf722dcd432b$exports = {};
$parcel$export($207acf722dcd432b$exports, "R50", ()=>$207acf722dcd432b$export$4b84fd0e2c617bd);
$parcel$export($207acf722dcd432b$exports, "R75", ()=>$207acf722dcd432b$export$b34b069eff244586);
$parcel$export($207acf722dcd432b$exports, "R100", ()=>$207acf722dcd432b$export$be802dd0d8b57f35);
$parcel$export($207acf722dcd432b$exports, "R200", ()=>$207acf722dcd432b$export$60847d42f9da92a6);
$parcel$export($207acf722dcd432b$exports, "R300", ()=>$207acf722dcd432b$export$4a7404f376229999);
$parcel$export($207acf722dcd432b$exports, "R400", ()=>$207acf722dcd432b$export$2010d0fb4295b346);
$parcel$export($207acf722dcd432b$exports, "R500", ()=>$207acf722dcd432b$export$2837b5a1a71d5c02);
$parcel$export($207acf722dcd432b$exports, "Y50", ()=>$207acf722dcd432b$export$8d9596b529bbb9cf);
$parcel$export($207acf722dcd432b$exports, "Y75", ()=>$207acf722dcd432b$export$41060a744ab0b7ae);
$parcel$export($207acf722dcd432b$exports, "Y100", ()=>$207acf722dcd432b$export$1cc05bbbf340e559);
$parcel$export($207acf722dcd432b$exports, "Y200", ()=>$207acf722dcd432b$export$5aae31392d72caaa);
$parcel$export($207acf722dcd432b$exports, "Y300", ()=>$207acf722dcd432b$export$c6930421db9fa514);
$parcel$export($207acf722dcd432b$exports, "Y400", ()=>$207acf722dcd432b$export$59619663aa6500fb);
$parcel$export($207acf722dcd432b$exports, "Y500", ()=>$207acf722dcd432b$export$874739ea9e379ab6);
$parcel$export($207acf722dcd432b$exports, "G50", ()=>$207acf722dcd432b$export$8a6341c32b6a3ee6);
$parcel$export($207acf722dcd432b$exports, "G75", ()=>$207acf722dcd432b$export$69a3bf21b9686c2b);
$parcel$export($207acf722dcd432b$exports, "G100", ()=>$207acf722dcd432b$export$afbce1382ec95f73);
$parcel$export($207acf722dcd432b$exports, "G200", ()=>$207acf722dcd432b$export$747d86715d4175de);
$parcel$export($207acf722dcd432b$exports, "G300", ()=>$207acf722dcd432b$export$940e1f69e873f202);
$parcel$export($207acf722dcd432b$exports, "G400", ()=>$207acf722dcd432b$export$a49394138f7b8e85);
$parcel$export($207acf722dcd432b$exports, "G500", ()=>$207acf722dcd432b$export$6fa04827ac68a4fb);
$parcel$export($207acf722dcd432b$exports, "B50", ()=>$207acf722dcd432b$export$226de0355ed012f8);
$parcel$export($207acf722dcd432b$exports, "B75", ()=>$207acf722dcd432b$export$8c13c2ee36917869);
$parcel$export($207acf722dcd432b$exports, "B100", ()=>$207acf722dcd432b$export$ecfc1dff386a3e7a);
$parcel$export($207acf722dcd432b$exports, "B200", ()=>$207acf722dcd432b$export$215b7063051591f1);
$parcel$export($207acf722dcd432b$exports, "B300", ()=>$207acf722dcd432b$export$e62e8919cca44969);
$parcel$export($207acf722dcd432b$exports, "B400", ()=>$207acf722dcd432b$export$b3de0ae08da2ce64);
$parcel$export($207acf722dcd432b$exports, "B500", ()=>$207acf722dcd432b$export$a6ee3d71bc067634);
$parcel$export($207acf722dcd432b$exports, "B600", ()=>$207acf722dcd432b$export$67f15409e87642a1);
$parcel$export($207acf722dcd432b$exports, "B700", ()=>$207acf722dcd432b$export$f0539dbc42dbb067);
$parcel$export($207acf722dcd432b$exports, "P50", ()=>$207acf722dcd432b$export$363e4475840015bb);
$parcel$export($207acf722dcd432b$exports, "P75", ()=>$207acf722dcd432b$export$4b0a4417ed59760f);
$parcel$export($207acf722dcd432b$exports, "P100", ()=>$207acf722dcd432b$export$6011520a64d9a187);
$parcel$export($207acf722dcd432b$exports, "P200", ()=>$207acf722dcd432b$export$a7175d4e9206bc80);
$parcel$export($207acf722dcd432b$exports, "P300", ()=>$207acf722dcd432b$export$b48405b95304b5a1);
$parcel$export($207acf722dcd432b$exports, "P400", ()=>$207acf722dcd432b$export$c71e4279dd54a18d);
$parcel$export($207acf722dcd432b$exports, "P500", ()=>$207acf722dcd432b$export$147899de772240ec);
$parcel$export($207acf722dcd432b$exports, "T50", ()=>$207acf722dcd432b$export$2cf711fe14c66f06);
$parcel$export($207acf722dcd432b$exports, "T75", ()=>$207acf722dcd432b$export$7a8f4d33f6f9772c);
$parcel$export($207acf722dcd432b$exports, "T100", ()=>$207acf722dcd432b$export$776c9c497ef08533);
$parcel$export($207acf722dcd432b$exports, "T200", ()=>$207acf722dcd432b$export$69cb3ca10c1e330e);
$parcel$export($207acf722dcd432b$exports, "T300", ()=>$207acf722dcd432b$export$9dc1ef0f3f48059b);
$parcel$export($207acf722dcd432b$exports, "T400", ()=>$207acf722dcd432b$export$7c835c78b6fcdef8);
$parcel$export($207acf722dcd432b$exports, "T500", ()=>$207acf722dcd432b$export$6036577f95c3877e);
$parcel$export($207acf722dcd432b$exports, "N0", ()=>$207acf722dcd432b$export$29a4f05edc054374);
$parcel$export($207acf722dcd432b$exports, "N10", ()=>$207acf722dcd432b$export$e655ef011c4aa1a2);
$parcel$export($207acf722dcd432b$exports, "N20", ()=>$207acf722dcd432b$export$9fdfb749e33cdf97);
$parcel$export($207acf722dcd432b$exports, "N30", ()=>$207acf722dcd432b$export$3e51e8f1440314ba);
$parcel$export($207acf722dcd432b$exports, "N40", ()=>$207acf722dcd432b$export$1ce2d1575d444ceb);
$parcel$export($207acf722dcd432b$exports, "N50", ()=>$207acf722dcd432b$export$8754fc7e6d8b3000);
$parcel$export($207acf722dcd432b$exports, "N60", ()=>$207acf722dcd432b$export$c2e91cbeada39b8b);
$parcel$export($207acf722dcd432b$exports, "N70", ()=>$207acf722dcd432b$export$5f71e19f3a7ad9de);
$parcel$export($207acf722dcd432b$exports, "N80", ()=>$207acf722dcd432b$export$eaa8c8a70ac22806);
$parcel$export($207acf722dcd432b$exports, "N90", ()=>$207acf722dcd432b$export$7c87d337fb91a97d);
$parcel$export($207acf722dcd432b$exports, "N100", ()=>$207acf722dcd432b$export$d6447c357493214f);
$parcel$export($207acf722dcd432b$exports, "N200", ()=>$207acf722dcd432b$export$f563ee71e9ee74cd);
$parcel$export($207acf722dcd432b$exports, "N300", ()=>$207acf722dcd432b$export$e2ef2124cf4024b1);
$parcel$export($207acf722dcd432b$exports, "N400", ()=>$207acf722dcd432b$export$eece5f492e429f08);
$parcel$export($207acf722dcd432b$exports, "N500", ()=>$207acf722dcd432b$export$c39c0fe0f26207ae);
$parcel$export($207acf722dcd432b$exports, "N600", ()=>$207acf722dcd432b$export$7090862dc3038a9f);
$parcel$export($207acf722dcd432b$exports, "N700", ()=>$207acf722dcd432b$export$ad0bacf983b7ddaa);
$parcel$export($207acf722dcd432b$exports, "N800", ()=>$207acf722dcd432b$export$7d61b15e0da132af);
$parcel$export($207acf722dcd432b$exports, "N900", ()=>$207acf722dcd432b$export$fbda843f0a27fe96);
$parcel$export($207acf722dcd432b$exports, "N10A", ()=>$207acf722dcd432b$export$791e57b27ca738ef);
$parcel$export($207acf722dcd432b$exports, "N20A", ()=>$207acf722dcd432b$export$8d43898f60b96a82);
$parcel$export($207acf722dcd432b$exports, "N30A", ()=>$207acf722dcd432b$export$920c0d5c49070351);
$parcel$export($207acf722dcd432b$exports, "N40A", ()=>$207acf722dcd432b$export$46987b49aab6d1a8);
$parcel$export($207acf722dcd432b$exports, "N50A", ()=>$207acf722dcd432b$export$7d3359664e8bb0e5);
$parcel$export($207acf722dcd432b$exports, "N60A", ()=>$207acf722dcd432b$export$d2d3bedfb276cac0);
$parcel$export($207acf722dcd432b$exports, "N70A", ()=>$207acf722dcd432b$export$6e5e7499ff054f6d);
$parcel$export($207acf722dcd432b$exports, "N80A", ()=>$207acf722dcd432b$export$59264b346c877fa7);
$parcel$export($207acf722dcd432b$exports, "N90A", ()=>$207acf722dcd432b$export$d092757d7c64925c);
$parcel$export($207acf722dcd432b$exports, "N100A", ()=>$207acf722dcd432b$export$486ab785e4bac3c6);
$parcel$export($207acf722dcd432b$exports, "N200A", ()=>$207acf722dcd432b$export$fba592bbc6419fea);
$parcel$export($207acf722dcd432b$exports, "N300A", ()=>$207acf722dcd432b$export$13609db0e6812ab8);
$parcel$export($207acf722dcd432b$exports, "N400A", ()=>$207acf722dcd432b$export$fbae4efaa892d883);
$parcel$export($207acf722dcd432b$exports, "N500A", ()=>$207acf722dcd432b$export$f13946d26f440ce6);
$parcel$export($207acf722dcd432b$exports, "N600A", ()=>$207acf722dcd432b$export$19f58225ac52a306);
$parcel$export($207acf722dcd432b$exports, "N700A", ()=>$207acf722dcd432b$export$6384f09da70e7b62);
$parcel$export($207acf722dcd432b$exports, "N800A", ()=>$207acf722dcd432b$export$d0dccc730683edc2);
$parcel$export($207acf722dcd432b$exports, "DN900", ()=>$207acf722dcd432b$export$2f6319cf7d736c2a);
$parcel$export($207acf722dcd432b$exports, "DN800", ()=>$207acf722dcd432b$export$95126bc8884d6634);
$parcel$export($207acf722dcd432b$exports, "DN700", ()=>$207acf722dcd432b$export$8338d8c35d44ff1);
$parcel$export($207acf722dcd432b$exports, "DN600", ()=>$207acf722dcd432b$export$5368d76ae4fbbda7);
$parcel$export($207acf722dcd432b$exports, "DN500", ()=>$207acf722dcd432b$export$9f0a771d16ec8d36);
$parcel$export($207acf722dcd432b$exports, "DN400", ()=>$207acf722dcd432b$export$abcf8c38338b4aa5);
$parcel$export($207acf722dcd432b$exports, "DN300", ()=>$207acf722dcd432b$export$97e81faa16a182c7);
$parcel$export($207acf722dcd432b$exports, "DN200", ()=>$207acf722dcd432b$export$bfe21c59123ecf33);
$parcel$export($207acf722dcd432b$exports, "DN100", ()=>$207acf722dcd432b$export$ee82aa2ea6a1558);
$parcel$export($207acf722dcd432b$exports, "DN90", ()=>$207acf722dcd432b$export$682927c6ed76be02);
$parcel$export($207acf722dcd432b$exports, "DN80", ()=>$207acf722dcd432b$export$91fd9994c5be9757);
$parcel$export($207acf722dcd432b$exports, "DN70", ()=>$207acf722dcd432b$export$d281fbfe3cff2df6);
$parcel$export($207acf722dcd432b$exports, "DN60", ()=>$207acf722dcd432b$export$3902c91d8b98a753);
$parcel$export($207acf722dcd432b$exports, "DN50", ()=>$207acf722dcd432b$export$8e8133c1ba5845b5);
$parcel$export($207acf722dcd432b$exports, "DN40", ()=>$207acf722dcd432b$export$33ff357f6620b39);
$parcel$export($207acf722dcd432b$exports, "DN30", ()=>$207acf722dcd432b$export$633847cf062b69e0);
$parcel$export($207acf722dcd432b$exports, "DN20", ()=>$207acf722dcd432b$export$9776a6e503bdbf76);
$parcel$export($207acf722dcd432b$exports, "DN10", ()=>$207acf722dcd432b$export$6c813d5160dff5db);
$parcel$export($207acf722dcd432b$exports, "DN0", ()=>$207acf722dcd432b$export$3d4f271a500072a);
$parcel$export($207acf722dcd432b$exports, "DN800A", ()=>$207acf722dcd432b$export$fe151285c22759ec);
$parcel$export($207acf722dcd432b$exports, "DN700A", ()=>$207acf722dcd432b$export$a101c6190d0da34);
$parcel$export($207acf722dcd432b$exports, "DN600A", ()=>$207acf722dcd432b$export$4b16f52932fda51);
$parcel$export($207acf722dcd432b$exports, "DN500A", ()=>$207acf722dcd432b$export$a74bcd7b9845b0d8);
$parcel$export($207acf722dcd432b$exports, "DN400A", ()=>$207acf722dcd432b$export$9209c179316d1751);
$parcel$export($207acf722dcd432b$exports, "DN300A", ()=>$207acf722dcd432b$export$88f55133f636c8dd);
$parcel$export($207acf722dcd432b$exports, "DN200A", ()=>$207acf722dcd432b$export$51126f85d1009512);
$parcel$export($207acf722dcd432b$exports, "DN100A", ()=>$207acf722dcd432b$export$a069b547bd23af78);
$parcel$export($207acf722dcd432b$exports, "DN90A", ()=>$207acf722dcd432b$export$40cce05af3b2600a);
$parcel$export($207acf722dcd432b$exports, "DN80A", ()=>$207acf722dcd432b$export$b78942185925a0d);
$parcel$export($207acf722dcd432b$exports, "DN70A", ()=>$207acf722dcd432b$export$e058fb44b8eaafca);
$parcel$export($207acf722dcd432b$exports, "DN60A", ()=>$207acf722dcd432b$export$92b0b8de26920c18);
$parcel$export($207acf722dcd432b$exports, "DN50A", ()=>$207acf722dcd432b$export$67564f7459d3fc9e);
$parcel$export($207acf722dcd432b$exports, "DN40A", ()=>$207acf722dcd432b$export$77868e1ca884ffa3);
$parcel$export($207acf722dcd432b$exports, "DN30A", ()=>$207acf722dcd432b$export$2afd71d7d3ea2cd5);
$parcel$export($207acf722dcd432b$exports, "DN20A", ()=>$207acf722dcd432b$export$f2a0acaab9972c70);
$parcel$export($207acf722dcd432b$exports, "DN10A", ()=>$207acf722dcd432b$export$9ab70e67d6475361);
$parcel$export($207acf722dcd432b$exports, "T30", ()=>$207acf722dcd432b$export$d2adc5dedf09fced);
$parcel$export($207acf722dcd432b$exports, "L50", ()=>$207acf722dcd432b$export$f51762073d2bb381);
$parcel$export($207acf722dcd432b$exports, "L75", ()=>$207acf722dcd432b$export$95e26d54def96891);
const $207acf722dcd432b$export$4b84fd0e2c617bd = '#FFEBE6';
const $207acf722dcd432b$export$b34b069eff244586 = '#FFBDAD';
const $207acf722dcd432b$export$be802dd0d8b57f35 = '#FF8F73';
const $207acf722dcd432b$export$60847d42f9da92a6 = '#FF7452';
const $207acf722dcd432b$export$4a7404f376229999 = '#FF5630';
const $207acf722dcd432b$export$2010d0fb4295b346 = '#DE350B';
const $207acf722dcd432b$export$2837b5a1a71d5c02 = '#BF2600';
const $207acf722dcd432b$export$8d9596b529bbb9cf = '#FFFAE6';
const $207acf722dcd432b$export$41060a744ab0b7ae = '#FFF0B3';
const $207acf722dcd432b$export$1cc05bbbf340e559 = '#FFE380';
const $207acf722dcd432b$export$5aae31392d72caaa = '#FFC400';
const $207acf722dcd432b$export$c6930421db9fa514 = '#FFAB00';
const $207acf722dcd432b$export$59619663aa6500fb = '#FF991F';
const $207acf722dcd432b$export$874739ea9e379ab6 = '#FF8B00';
const $207acf722dcd432b$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $207acf722dcd432b$export$69a3bf21b9686c2b = '#ABF5D1';
const $207acf722dcd432b$export$afbce1382ec95f73 = '#79F2C0';
const $207acf722dcd432b$export$747d86715d4175de = '#57D9A3';
const $207acf722dcd432b$export$940e1f69e873f202 = '#36B37E';
const $207acf722dcd432b$export$a49394138f7b8e85 = '#00875A';
const $207acf722dcd432b$export$6fa04827ac68a4fb = '#006644';
const $207acf722dcd432b$export$226de0355ed012f8 = '#DEEBFF';
const $207acf722dcd432b$export$8c13c2ee36917869 = '#B3D4FF';
const $207acf722dcd432b$export$ecfc1dff386a3e7a = '#4C9AFF';
const $207acf722dcd432b$export$215b7063051591f1 = '#2684FF';
const $207acf722dcd432b$export$e62e8919cca44969 = '#0065FF';
const $207acf722dcd432b$export$b3de0ae08da2ce64 = '#0052CC';
const $207acf722dcd432b$export$a6ee3d71bc067634 = '#0747A6';
const $207acf722dcd432b$export$67f15409e87642a1 = '#669DF1';
const $207acf722dcd432b$export$f0539dbc42dbb067 = '#8FB8F6';
const $207acf722dcd432b$export$363e4475840015bb = '#EAE6FF';
const $207acf722dcd432b$export$4b0a4417ed59760f = '#C0B6F2';
const $207acf722dcd432b$export$6011520a64d9a187 = '#998DD9';
const $207acf722dcd432b$export$a7175d4e9206bc80 = '#8777D9';
const $207acf722dcd432b$export$b48405b95304b5a1 = '#6554C0';
const $207acf722dcd432b$export$c71e4279dd54a18d = '#5243AA';
const $207acf722dcd432b$export$147899de772240ec = '#403294';
const $207acf722dcd432b$export$2cf711fe14c66f06 = '#E6FCFF';
const $207acf722dcd432b$export$7a8f4d33f6f9772c = '#B3F5FF';
const $207acf722dcd432b$export$776c9c497ef08533 = '#79E2F2';
const $207acf722dcd432b$export$69cb3ca10c1e330e = '#00C7E6';
const $207acf722dcd432b$export$9dc1ef0f3f48059b = '#00B8D9';
const $207acf722dcd432b$export$7c835c78b6fcdef8 = '#00A3BF';
const $207acf722dcd432b$export$6036577f95c3877e = '#008DA6';
const $207acf722dcd432b$export$29a4f05edc054374 = '#FFFFFF';
const $207acf722dcd432b$export$e655ef011c4aa1a2 = '#FAFBFC';
const $207acf722dcd432b$export$9fdfb749e33cdf97 = '#F4F5F7';
const $207acf722dcd432b$export$3e51e8f1440314ba = '#EBECF0';
const $207acf722dcd432b$export$1ce2d1575d444ceb = '#DFE1E6';
const $207acf722dcd432b$export$8754fc7e6d8b3000 = '#C1C7D0';
const $207acf722dcd432b$export$c2e91cbeada39b8b = '#B3BAC5';
const $207acf722dcd432b$export$5f71e19f3a7ad9de = '#A5ADBA';
const $207acf722dcd432b$export$eaa8c8a70ac22806 = '#97A0AF';
const $207acf722dcd432b$export$7c87d337fb91a97d = '#8993A4';
const $207acf722dcd432b$export$d6447c357493214f = '#7A869A';
const $207acf722dcd432b$export$f563ee71e9ee74cd = '#6B778C';
const $207acf722dcd432b$export$e2ef2124cf4024b1 = '#5E6C84';
const $207acf722dcd432b$export$eece5f492e429f08 = '#505F79';
const $207acf722dcd432b$export$c39c0fe0f26207ae = '#42526E';
const $207acf722dcd432b$export$7090862dc3038a9f = '#344563';
const $207acf722dcd432b$export$ad0bacf983b7ddaa = '#253858';
const $207acf722dcd432b$export$7d61b15e0da132af = '#172B4D';
const $207acf722dcd432b$export$fbda843f0a27fe96 = '#091E42';
const $207acf722dcd432b$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $207acf722dcd432b$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $207acf722dcd432b$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $207acf722dcd432b$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $207acf722dcd432b$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $207acf722dcd432b$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $207acf722dcd432b$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $207acf722dcd432b$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $207acf722dcd432b$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $207acf722dcd432b$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $207acf722dcd432b$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $207acf722dcd432b$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $207acf722dcd432b$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $207acf722dcd432b$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $207acf722dcd432b$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $207acf722dcd432b$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $207acf722dcd432b$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $207acf722dcd432b$export$2f6319cf7d736c2a = '#E6EDFA';
const $207acf722dcd432b$export$95126bc8884d6634 = '#DCE5F5';
const $207acf722dcd432b$export$8338d8c35d44ff1 = '#CED9EB';
const $207acf722dcd432b$export$5368d76ae4fbbda7 = '#B8C7E0';
const $207acf722dcd432b$export$9f0a771d16ec8d36 = '#ABBBD6';
const $207acf722dcd432b$export$abcf8c38338b4aa5 = '#9FB0CC';
const $207acf722dcd432b$export$97e81faa16a182c7 = '#8C9CB8';
const $207acf722dcd432b$export$bfe21c59123ecf33 = '#7988A3';
const $207acf722dcd432b$export$ee82aa2ea6a1558 = '#67758F';
const $207acf722dcd432b$export$682927c6ed76be02 = '#56637A';
const $207acf722dcd432b$export$91fd9994c5be9757 = '#455166';
const $207acf722dcd432b$export$d281fbfe3cff2df6 = '#3B475C';
const $207acf722dcd432b$export$3902c91d8b98a753 = '#313D52';
const $207acf722dcd432b$export$8e8133c1ba5845b5 = '#283447';
const $207acf722dcd432b$export$33ff357f6620b39 = '#202B3D';
const $207acf722dcd432b$export$633847cf062b69e0 = '#1B2638';
const $207acf722dcd432b$export$9776a6e503bdbf76 = '#121A29';
const $207acf722dcd432b$export$6c813d5160dff5db = '#0E1624';
const $207acf722dcd432b$export$3d4f271a500072a = '#0D1424';
const $207acf722dcd432b$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $207acf722dcd432b$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $207acf722dcd432b$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $207acf722dcd432b$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $207acf722dcd432b$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $207acf722dcd432b$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $207acf722dcd432b$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $207acf722dcd432b$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $207acf722dcd432b$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $207acf722dcd432b$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $207acf722dcd432b$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $207acf722dcd432b$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $207acf722dcd432b$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $207acf722dcd432b$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $207acf722dcd432b$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $207acf722dcd432b$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $207acf722dcd432b$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $207acf722dcd432b$export$d2adc5dedf09fced = '#292A2E';
const $207acf722dcd432b$export$f51762073d2bb381 = '#94C748';
const $207acf722dcd432b$export$95e26d54def96891 = '#B3DF72';
const $870798c86d5f3294$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $870798c86d5f3294$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $870798c86d5f3294$export$13f57c02915787b3 = 'atlaskit-portal';
const $5c5a0adfb578e838$export$ed5835cc67e87f72 = 'akPortalMount';
const $5c5a0adfb578e838$export$80816bd900e5bd00 = 'akPortalUnmount';
const $cb3878f71492e237$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $cb3878f71492e237$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $cb3878f71492e237$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $394220419f57a1b4$export$a1562d08625f5d7e = 'ui';
const $394220419f57a1b4$export$947dac6c72b26f81 = 'track';
const $394220419f57a1b4$export$f1d537d508d2945a = 'screen';
const $394220419f57a1b4$export$12346a674644c156 = 'operational';
const $394220419f57a1b4$export$b055de0e665cb20c = 'unknown';
const $dfd6778c2091b723$export$d6830277b06edd6 = 'normal';
const $dfd6778c2091b723$export$4f8f13a66ae77bdd = '--color';
const $dfd6778c2091b723$export$e9244ec13bd422b5 = '--bg-color';
const $dfd6778c2091b723$export$97e78d9745006c11 = '--bg-color-hover';
const $dfd6778c2091b723$export$291d63757828f290 = '--bg-color-active';
$parcel$global.rlb("2Lfdl");
